import React, { useEffect, useMemo, useState, createContext, useContext } from 'react';
type Language = 'pt' | 'en' | 'es' | 'ja' | 'zh' | 'ko';
interface Translations {
  nav: {
    inicio: string;
    paraVoce: string;
    paraNegocio: string;
    paraMarca: string;
    ods: string;
    educa: string;
    gov: string;
    clube: string;
    tropa: string;
    solucoes: string;
    ecossistema: string;
    precos: string;
    contato: string;
    paraOng: string;
    paraInvestidor: string;
  };
  footer: {
    blurb: string;
    plataforma: string;
    contato: string;
    faleConosco: string;
    direitos: string;
    termos: string;
    privacidade: string;
  };
  common: {
    disponivelEmBreve: string;
    saibaMais: string;
    faleComAGente: string;
    falarComNossoTime: string;
    trustedBy: string;
    tagline: string;
    darkModeOn: string;
    darkModeOff: string;
  };
  home: {
    heroEyebrow: string;
    heroTitle1: string;
    heroTitle2: string;
    heroDesc: string;
    comoFunciona: string;
    comoFuncionaDesc: string;
    step1Title: string;
    step1Desc: string;
    step2Title: string;
    step2Desc: string;
    step3Title: string;
    step3Desc: string;
    pilaresTitle: string;
    pilar1Title: string;
    pilar1Desc: string;
    pilar2Title: string;
    pilar2Desc: string;
    pilar3Title: string;
    pilar3Desc: string;
    pilar4Title: string;
    pilar4Desc: string;
    audiencesTitle: string;
    audiencesDesc: string;
    aud1Title: string;
    aud1Desc: string;
    aud2Title: string;
    aud2Desc: string;
    aud3Title: string;
    aud3Desc: string;
    ctaTitle: string;
    ctaDesc: string;
    featuresEyebrow: string;
    audiencesEyebrow: string;
    mockAlt2: string;
  };
  paraVoce: {
    heroEyebrow: string;
    heroTitle1: string;
    heroTitle2: string;
    heroDesc: string;
    ben1Title: string;
    ben1Desc: string;
    ben2Title: string;
    ben2Desc: string;
    ben3Title: string;
    ben3Desc: string;
    ben4Title: string;
    ben4Desc: string;
    ben5Title: string;
    ben5Desc: string;
    ben6Title: string;
    ben6Desc: string;
    walletTitle: string;
    walletDesc: string;
    walletList1: string;
    walletList2: string;
    walletList3: string;
    howToTitle: string;
    howToDesc: string;
    step1Title: string;
    step1Desc: string;
    step2Title: string;
    step2Desc: string;
    step3Title: string;
    step3Desc: string;
    step4Title: string;
    step4Desc: string;
    testimonialQuote: string;
    testimonialAuthor: string;
    benefitsEyebrow: string;
    benefitsTitle: string;
    howToEyebrow: string;
    mockAlt2: string;
  };
  paraNegocio: {
    heroEyebrow: string;
    heroTitle1: string;
    heroTitle2: string;
    heroDesc: string;
    dashTitle: string;
    dashDesc: string;
    dashStat1: string;
    dashStat2: string;
    dashStat3: string;
    whyTitle: string;
    why1Title: string;
    why1Desc: string;
    why2Title: string;
    why2Desc: string;
    why3Title: string;
    why3Desc: string;
    why4Title: string;
    why4Desc: string;
    why5Title: string;
    why5Desc: string;
    why6Title: string;
    why6Desc: string;
    presenceTitle: string;
    presenceDesc: string;
    presenceList1: string;
    presenceList2: string;
    presenceList3: string;
    presenceList4: string;
    stepsTitle: string;
    step1Title: string;
    step1Desc: string;
    step2Title: string;
    step2Desc: string;
    step3Title: string;
    step3Desc: string;
    pricingTitle: string;
    pricingDesc: string;
    planTitle: string;
    planList1: string;
    planList2: string;
    planPrice: string;
    planSub: string;
    whyEyebrow: string;
    presenceEyebrow: string;
    stepsEyebrow: string;
    pricingEyebrow: string;
    democEyebrow: string;
    democTitle: string;
    democDesc: string;
    democCard1Title: string;
    democCard1Desc: string;
    democCard2Title: string;
    democCard2Desc: string;
    democCard3Title: string;
    democCard3Desc: string;
    democHighlight: string;
  };
  paraMarca: {
    heroEyebrow: string;
    heroTag: string;
    heroTitle1: string;
    heroTitle2: string;
    heroDesc: string;
    heroNielsen: string;
    activeTerritoriesTitle: string;
    activeTerritoriesDesc: string;
    activeTerritoriesList1: string;
    activeTerritoriesList2: string;
    activeTerritoriesList3: string;
    activeTerritoriesList4: string;
    activeTerritoriesList5: string;
    activeTerritoriesList6: string;
    strengthenTitle: string;
    strengthenDesc: string;
    strengthenList1: string;
    strengthenList2: string;
    strengthenList3: string;
    strengthenList4: string;
    strengthenConclusion: string;
    examplesTitle: string;
    example1Title: string;
    example1Desc: string;
    example1List1: string;
    example1List2: string;
    example1List3: string;
    example1List4: string;
    example2Title: string;
    example2Desc: string;
    example2Detail: string;
    example3Title: string;
    example3Desc: string;
    example4Title: string;
    example4Desc: string;
    example4Detail: string;
    benefitsTitle: string;
    benefit1Title: string;
    benefit1Desc: string;
    benefit2Title: string;
    benefit2Desc: string;
    benefit3Title: string;
    benefit3Desc: string;
    benefit4Title: string;
    benefit4Desc: string;
    benefit5Title: string;
    benefit5Desc: string;
    benefit5List1: string;
    benefit5List2: string;
    benefit5List3: string;
    benefit5List4: string;
    benefit5List5: string;
    mockAlt1: string;
    ctaTitle: string;
    ctaDesc: string;
    ctaDesc2: string;
    ctaButton: string;
    ctaOr: string;
    formats: string[];
  };
  educa: {
    heroEyebrow: string;
    heroTitle1: string;
    heroTitle2: string;
    heroDesc: string;
    heroDesc2: string;
    missionTitle: string;
    missionDesc: string;
    findTitle: string;
    find1: string;
    find2: string;
    find3: string;
    find4: string;
    find5: string;
    find6: string;
    find7: string;
    partnersTitle: string;
    partnersDesc: string;
    partnersClosing: string;
    partnerChips: string[];
    freeBadge: string;
    ctaTitle: string;
    ctaDesc: string;
    ctaButton: string;
  };
  gov: {
    heroEyebrow: string;
    heroTitle1: string;
    heroTitle2: string;
    heroDesc: string;
    ctaPrimary: string;
    ctaSecondary: string;
    whatTitle: string;
    whatDesc1: string;
    whatDesc2: string;
    modulesTitle: string[];
    moduleDescs: string[];
    moduleFeatures: string[][];
    useCasesTitle: string;
    useCases: string[];
    impactTitle: string;
    impactGovTitle: string;
    impactGov: string[];
    impactCitizensTitle: string;
    impactCitizens: string[];
    impactTerritoriesTitle: string;
    impactTerritories: string[];
    dashboardTitle: string;
    dashboardDesc: string;
    dashboardMetrics: string[];
    sdgTitle: string;
    sdgs: string[];
    ecosystemTitle: string;
    ecosystemDesc: string;
    ecosystemCenter: string;
    ecosystemModules: string[];
    investorsTitle: string;
    investorsDesc: string;
    marketB2cTitle: string;
    marketB2c: string[];
    marketB2gTitle: string;
    marketB2g: string[];
    investorsNote: string;
    ctaFinalTitle: string;
    ctaFinalDesc: string;
    dashboardPanel: string;
    dashboardLive: string;
    nodeLabels: string[];
  };
  clube: {
    heroEyebrow: string;
    heroTitle1: string;
    heroTitle2: string;
    heroDesc1: string;
    heroDesc2: string;
    pointsTitle: string;
    pointsSubtitle: string;
    pointsDesc1: string;
    pointsDesc2: string;
    pointsRedeemIntro: string;
    pointsList: string[];
    couponsTitle: string;
    couponsSubtitle: string;
    couponsDesc1: string;
    couponsDesc2: string;
    couponsIntro: string;
    couponsList: string[];
    cardLabels: string[];
    pointsBenefit: string;
    localTitle: string;
    localDesc: string;
    localHighlight: string;
    tagline: string;
    ctaTitle: string;
    ctaDesc: string;
    ctaButton: string;
  };
  tropa: {
    heroEyebrow: string;
    heroTitle: string;
    heroDesc1: string;
    heroDesc2: string;
    howItWorksTitle: string;
    howItWorksDesc1: string;
    howItWorksDesc2: string;
    opportunitiesTitle: string;
    opportunitiesTitles: string[];
    opportunitiesDescs: string[];
    participantBenefitsTitle: string;
    participantBenefitsTitles: string[];
    participantBenefitsDescs: string[];
    businessBenefitsTitle: string;
    businessBenefitsTitles: string[];
    businessBenefitsDescs: string[];
    closingDesc1: string;
    closingDesc2: string;
    closingHighlight: string;
    ctaTitle: string;
    ctaDesc: string;
    ctaButton: string;
  };
  ods: {
    heroEyebrow: string;
    heroTitle1: string;
    heroTitle2: string;
    heroDesc: string;
    stat1Desc: string;
    stat2Desc: string;
    stat3Desc: string;
    stat4Desc: string;
    impactTitle: string;
    impactDesc: string;
    impactList1: string;
    impactList2: string;
    impactList3: string;
    impactList4: string;
    odsTitle: string;
    ods1Title: string;
    ods1Desc: string;
    ods2Title: string;
    ods2Desc: string;
    ods3Title: string;
    ods3Desc: string;
    ods4Title: string;
    ods4Desc: string;
    impactEyebrow: string;
    odsEyebrow: string;
  };
  contato: {
    heroEyebrow: string;
    heroTitle: string;
    heroDesc: string;
    infoTitle: string;
    infoEmail: string;
    infoPhone: string;
    infoOffice: string;
    infoAddress1: string;
    infoAddress2: string;
    successTitle: string;
    successDesc: string;
    successButton: string;
    formName: string;
    formNamePlaceholder: string;
    formEmail: string;
    formEmailPlaceholder: string;
    formSubject: string;
    formSubjectPlaceholder: string;
    formSub1: string;
    formSub2: string;
    formSub3: string;
    formSub4: string;
    formSub5: string;
    formSub6: string;
    formSub7: string;
    formMessage: string;
    formMessagePlaceholder: string;
    formSubmit: string;
    formSubmitting: string;
    errorTitle: string;
    errorDesc: string;
    errorButton: string;
  };
  precos: {
    heroEyebrow: string;
    heroTitle1: string;
    heroTitle2: string;
    heroDesc: string;
    monthly: string;
    annual: string;
    annualDiscount: string;
    plan1Name: string;
    plan1Desc: string;
    plan1PriceM: string;
    plan1PriceA: string;
    plan1Cta: string;
    plan1Advantage: string;
    plan2Name: string;
    plan2Badge: string;
    plan2Desc: string;
    plan2PriceM: string;
    plan2PriceA: string;
    plan2Cta: string;
    plan2Advantage: string;
    plan3Name: string;
    plan3Desc: string;
    plan3PriceM: string;
    plan3PriceA: string;
    plan3Cta: string;
    plan3Advantage: string;
    feature1: string;
    feature2: string;
    feature3: string;
    feature4: string;
    feature5: string;
    feature6: string;
    feature7: string;
    feature8: string;
    feature9: string;
    feature10: string;
    matrixTitle: string;
    matrixNote: string;
    faqTitle: string;
    faq1Q: string;
    faq1A: string;
    faq2Q: string;
    faq2A: string;
    faq3Q: string;
    faq3A: string;
    testimonialQuote: string;
    testimonialAuthor: string;
  };
  paraOng: {
    heroEyebrow: string;
    heroTitle1: string;
    heroTitle2: string;
    heroDesc: string;
    whatTitle: string;
    whatDesc: string;
    benefitsTitle: string;
    benefit1Title: string;
    benefit1Desc: string;
    benefit2Title: string;
    benefit2Desc: string;
    benefit3Title: string;
    benefit3Desc: string;
    benefit4Title: string;
    benefit4Desc: string;
    stepsTitle: string;
    step1Title: string;
    step1Desc: string;
    step2Title: string;
    step2Desc: string;
    step3Title: string;
    step3Desc: string;
    impactaEyebrow: string;
    impactaTitle: string;
    impactaDesc: string;
    impactaList1: string;
    impactaList2: string;
    impactaList3: string;
    impactaMockAlt: string;
    ctaTitle: string;
    ctaDesc: string;
    ctaButton: string;
  };
  paraInvestidor: {
    heroEyebrow: string;
    heroTitle1: string;
    heroTitle2: string;
    heroDesc: string;
    marketTitle: string;
    marketB2cTitle: string;
    marketB2cList: string[];
    marketB2gTitle: string;
    marketB2gList: string[];
    whyNowTitle: string;
    whyNowDesc: string;
    thesisTitle: string;
    thesis1Title: string;
    thesis1Desc: string;
    thesis2Title: string;
    thesis2Desc: string;
    thesis3Title: string;
    thesis3Desc: string;
    ecosystemTitle: string;
    ecosystemDesc: string;
    tractionTitle: string;
    tractionDesc: string;
    ctaTitle: string;
    ctaDesc: string;
    ctaButton: string;
  };
}
const translations: Record<'pt' | 'en', Translations> = {
  pt: {
    nav: {
      inicio: 'Início',
      paraVoce: 'Para você',
      paraNegocio: 'Para o seu negócio',
      paraMarca: 'Para sua marca',
      ods: 'ODS',
      educa: 'BairrouEduca!',
      gov: 'BairrouGov',
      clube: 'BairrouClube!',
      tropa: 'Tropa do Bairrou!',
      solucoes: 'Soluções',
      ecossistema: 'Ecossistema',
      precos: 'Preços',
      contato: 'Contato',
      paraOng: 'Para ONGs',
      paraInvestidor: 'Para Investidores'
    },
    footer: {
      blurb: 'O melhor está aqui! Conectando você aos negócios, oportunidades e pessoas do seu bairro.',
      plataforma: 'Plataforma',
      contato: 'Contato',
      faleConosco: 'Fale conosco',
      direitos: '© 2026 BairrouApp. Todos os direitos reservados.',
      termos: 'Termos de Uso',
      privacidade: 'Privacidade'
    },
    common: {
      disponivelEmBreve: 'Disponível em breve',
      saibaMais: 'Saiba mais',
      faleComAGente: 'Fale com a gente',
      falarComNossoTime: 'Falar com nosso time',
      trustedBy: 'Empresas que confiam na gente',
      tagline: 'O melhor está aqui!',
      darkModeOn: 'Ativar modo escuro',
      darkModeOff: 'Ativar modo claro'
    },
    home: {
      heroEyebrow: 'O APP DO SEU BAIRRO',
      heroTitle1: 'Seu bairro,',
      heroTitle2: 'em um só app.',
      heroDesc: 'O BairrouApp! é a infraestrutura digital dos bairros: descubra negócios locais, ganhe pontos, economize e fortaleça a sua comunidade — tudo em um só app.',
      comoFunciona: 'Como funciona?',
      comoFuncionaDesc: 'Tudo o que você precisa para viver melhor o seu bairro, na palma da mão.',
      step1Title: '1. Explore',
      step1Desc: 'Encontre os melhores comércios, serviços e ofertas perto de você.',
      step2Title: '2. Compre e Ganhe',
      step2Desc: 'Acumule pontos em cada compra e troque por descontos exclusivos.',
      step3Title: '3. Fortaleça',
      step3Desc: 'Apoie a economia local e participe de iniciativas de impacto no bairro.',
      pilaresTitle: 'Um app, muitas possibilidades',
      pilar1Title: 'Ofertas Locais',
      pilar1Desc: 'Cupons e promoções dos seus vizinhos.',
      pilar2Title: 'Educa',
      pilar2Desc: 'Cursos e capacitação para a comunidade.',
      pilar3Title: 'Desapega',
      pilar3Desc: 'Compre, venda ou troque itens usados.',
      pilar4Title: 'Impacta',
      pilar4Desc: 'Apoie causas sociais do seu bairro.',
      audiencesTitle: 'Feito para todos',
      audiencesDesc: 'Seja você um morador, um pequeno empreendedor ou uma grande marca.',
      aud1Title: 'Para você',
      aud1Desc: 'Economize, ganhe pontos e descubra o melhor do seu bairro.',
      aud2Title: 'Para o seu negócio',
      aud2Desc: 'Atraia mais clientes locais e fidelize sua vizinhança.',
      aud3Title: 'Para sua marca',
      aud3Desc: 'Conecte-se com comunidades de forma autêntica e hiperlocal.',
      ctaTitle: 'Pronto para explorar?',
      ctaDesc: 'Junte-se a milhares de vizinhos que já estão transformando seus bairros.',
      featuresEyebrow: 'TUDO EM UM SÓ LUGAR',
      audiencesEyebrow: 'PARA QUEM É',
      mockAlt2: 'Tela de ofertas locais no BairrouApp'
    },
    paraVoce: {
      heroEyebrow: 'PARA MORADORES',
      heroTitle1: 'O melhor do seu bairro,',
      heroTitle2: 'para você.',
      heroDesc: 'Descontos exclusivos, acúmulo de pontos e a facilidade de encontrar tudo o que você precisa a poucos passos de casa.',
      ben1Title: 'Descontos e Cupons',
      ben1Desc: 'Aproveite ofertas exclusivas nos comércios locais que você já ama.',
      ben2Title: 'Pontos e Recompensas',
      ben2Desc: 'Cada compra gera pontos na sua carteira digital para trocar por prêmios.',
      ben3Title: 'Descubra Negócios',
      ben3Desc: 'Encontre padarias, mecânicos, salões e muito mais, bem pertinho.',
      ben4Title: 'Cursos no Educa',
      ben4Desc: 'Acesse capacitações e cursos rápidos para o seu desenvolvimento.',
      ben5Title: 'Compre e Venda',
      ben5Desc: 'Use o Desapega para dar nova vida a itens que você não usa mais.',
      ben6Title: 'Pagamentos Fáceis',
      ben6Desc: 'Pague suas compras direto pelo app com forma segura.',
      walletTitle: 'Sua carteira de benefícios',
      walletDesc: 'Acompanhe seus pontos, resgate cupons e veja seu histórico de economia em tempo real. Tudo organizado em um só lugar para você aproveitar o melhor do seu bairro.',
      walletList1: 'Saldo atualizado instantaneamente',
      walletList2: 'Catálogo de recompensas locais',
      walletList3: 'Histórico transparente de ganhos e usos',
      howToTitle: 'Como ganhar pontos?',
      howToDesc: 'É simples, rápido e divertido.',
      step1Title: 'Compre no bairro',
      step1Desc: 'Faça compras nos estabelecimentos parceiros usando o app.',
      step2Title: 'Cumpra missões',
      step2Desc: 'Participe de desafios locais, como avaliar uma loja ou reciclar itens.',
      step3Title: 'Indique amigos',
      step3Desc: 'Traga seus vizinhos para o BairrouApp e ganhe pontos extras.',
      step4Title: 'Troque por prêmios',
      step4Desc: 'Use seus pontos para resgatar produtos, serviços ou descontos.',
      testimonialQuote: '"Desde que comecei a usar o BairrouApp, descobri lugares incríveis na minha rua que eu nem sabia que existiam. E os pontos que acumulo já pagaram meu café da manhã várias vezes!"',
      testimonialAuthor: '— Mariana S., moradora local',
      benefitsEyebrow: 'VANTAGENS',
      benefitsTitle: 'Tudo o que você precisa',
      howToEyebrow: 'PASSO A PASSO',
      mockAlt2: 'Tela de missões e recompensas no BairrouApp'
    },
    paraNegocio: {
      heroEyebrow: 'PARA EMPREENDEDORES',
      heroTitle1: 'Faça seu negócio',
      heroTitle2: 'crescer no bairro.',
      heroDesc: 'Conecte-se com clientes que moram perto de você. Aumente suas vendas, crie programas de fidelidade e ganhe visibilidade local.',
      dashTitle: 'Dashboard do Lojista',
      dashDesc: 'Visão geral de hoje',
      dashStat1: 'Visitas na página',
      dashStat2: 'Cupons resgatados',
      dashStat3: 'Novos clientes',
      whyTitle: 'Por que o BairrouApp?',
      why1Title: 'Atraia a Vizinhança',
      why1Desc: 'Seja encontrado por pessoas que moram ou trabalham perto do seu estabelecimento.',
      why2Title: 'Crie Ofertas',
      why2Desc: 'Publique promoções e cupons para atrair movimento em dias mais tranquilos.',
      why3Title: 'Fidelize Clientes',
      why3Desc: 'Ofereça pontos nas compras para garantir que seus clientes sempre voltem.',
      why4Title: 'Receba Pagamentos',
      why4Desc: 'Aceite pagamentos pelo app com taxas competitivas e recebimento rápido.',
      why5Title: 'Visibilidade Local',
      why5Desc: 'Destaque-se no mapa do bairro e nas buscas por categorias.',
      why6Title: 'Vitrine Digital',
      why6Desc: 'Mostre seus produtos, horários e fotos em uma página exclusiva.',
      presenceTitle: 'Sua presença digital acessível',
      presenceDesc: 'Tenha uma página para o seu negócio dentro do app e democratize a fidelização: ferramentas antes restritas às grandes redes, agora ao alcance do comércio de bairro. Apresente seus serviços e horários, ofereça cupons e um cartão fidelidade digital para a sua vizinhança.',
      presenceList1: 'Listagem do seu estabelecimento ou serviço',
      presenceList2: 'Horários de funcionamento atualizados',
      presenceList3: 'Ofertas e cartão fidelidade digital',
      presenceList4: 'Check-in via QR Code',
      stepsTitle: 'Comece em 3 passos',
      step1Title: 'Cadastre-se',
      step1Desc: 'Crie sua conta de lojista em menos de 5 minutos.',
      step2Title: 'Configure',
      step2Desc: 'Adicione fotos, horários e sua primeira oferta.',
      step3Title: 'Venda mais',
      step3Desc: 'Comece a receber clientes do seu bairro.',
      pricingTitle: 'Planos que cabem no seu bolso',
      pricingDesc: 'Comece gratuitamente e pague apenas uma pequena taxa sobre as vendas realizadas pelo app. Sem mensalidades surpresa.',
      planTitle: 'Plano Básico',
      planList1: 'Listagem do seu estabelecimento ou serviço',
      planList2: 'Programa de pontos básico',
      planPrice: 'Grátis',
      planSub: 'para começar',
      whyEyebrow: 'POR QUE ESCOLHER',
      presenceEyebrow: 'VITRINE DIGITAL',
      stepsEyebrow: 'COMO COMEÇAR',
      pricingEyebrow: 'PLANOS',
      democEyebrow: 'AO SEU ALCANCE',
      democTitle: 'Inteligência de negócio e fidelização que antes só as grandes redes tinham',
      democDesc: 'Você não precisa desenvolver nem manter um aplicativo próprio. O BairrouApp! democratiza o acesso a ferramentas que custavam caro e eram exclusivas de grandes redes — agora de forma simples e acessível para o comércio de bairro.',
      democCard1Title: 'Programa de fidelidade sem app próprio',
      democCard1Desc: 'Ofereça pontos, cupons e um cartão fidelidade digital aos seus clientes sem investir no desenvolvimento e na manutenção de um aplicativo. Tudo acontece dentro do BairrouApp!.',
      democCard2Title: 'Inteligência de negócio acessível',
      democCard2Desc: 'Entenda seus clientes com dados sobre recorrência, ofertas que mais convertem e desempenho do seu estabelecimento — insights antes restritos a quem tinha grande orçamento e equipe de dados.',
      democCard3Title: 'Acessível de verdade',
      democCard3Desc: 'Comece grátis, sem mensalidades surpresa e sem barreira técnica. A digitalização e a fidelização do seu negócio cabem no seu bolso e na sua rotina.',
      democHighlight: 'Tecnologia de grandes redes, ao alcance do seu bairro.'
    },
    paraMarca: {
      heroEyebrow: 'PARA GRANDES MARCAS',
      heroTag: 'B2B & Parcerias',
      heroTitle1: 'Conecte sua marca às comunidades',
      heroTitle2: 'onde a confiança acontece.',
      heroDesc: 'Em um cenário onde consumidores são cada vez mais seletivos com publicidade tradicional, as recomendações de pessoas próximas, experiências reais e conexões comunitárias têm um papel fundamental na construção de confiança e decisão de compra.',
      heroNielsen: 'As recomendações de amigos, familiares e pessoas próximas seguem como a forma de comunicação mais confiável para os consumidores — e é exatamente aí que o BairrouApp! posiciona a sua marca: presente nos bairros de forma relevante, apoiando pequenos negócios, ativando comunidades e criando experiências que geram valor para todos os envolvidos.',
      activeTerritoriesTitle: 'Ative territórios, não apenas audiências',
      activeTerritoriesDesc: 'Em vez de falar com consumidores de forma genérica, sua marca pode se conectar diretamente aos lugares onde as pessoas vivem, trabalham, consomem e se relacionam. Transforme bairros em pontos de contato estratégicos através de:',
      activeTerritoriesList1: 'Campanhas geolocalizadas',
      activeTerritoriesList2: 'Distribuição de amostras e brindes',
      activeTerritoriesList3: 'Cupons promocionais',
      activeTerritoriesList4: 'Experiências patrocinadas',
      activeTerritoriesList5: 'Ações de impacto social',
      activeTerritoriesList6: 'Iniciativas de engajamento comunitário',
      strengthenTitle: 'Fortaleça pequenos negócios e distribuidores',
      strengthenDesc: 'O BairrouApp! transforma comerciantes, prestadores de serviço e distribuidores locais em parceiros de ativação da sua marca. Isso permite:',
      strengthenList1: 'Ampliar capilaridade',
      strengthenList2: 'Gerar experimentação de produtos',
      strengthenList3: 'Fortalecer canais locais',
      strengthenList4: 'Criar relacionamentos de longo prazo',
      strengthenConclusion: 'Enquanto a marca ganha presença territorial, os pequenos negócios ganham fluxo, visibilidade e novas oportunidades de receita.',
      examplesTitle: 'Exemplos de campanhas',
      example1Title: 'Circuitos de Bairro',
      example1Desc: 'Crie jornadas patrocinadas envolvendo diversos parceiros locais. Exemplos:',
      example1List1: 'Circuito do Café',
      example1List2: 'Circuito da Beleza',
      example1List3: 'Circuito da Família',
      example1List4: 'Circuito do Verão',
      example2Title: 'Compre e Ganhe',
      example2Desc: 'Incentive a experimentação por meio de benefícios patrocinados.',
      example2Detail: 'Compre em parceiros participantes e receba um produto, amostra ou benefício exclusivo da marca.',
      example3Title: 'Descoberta Local',
      example3Desc: 'Estimule consumidores a conhecer novos estabelecimentos e produtos dentro da comunidade.',
      example4Title: 'Impacto Social Patrocinado',
      example4Desc: 'Associe sua marca a projetos sociais, culturais ou ambientais do território.',
      example4Detail: 'A cada compra realizada, parte do investimento da campanha apoia uma iniciativa local.',
      benefitsTitle: 'O que sua marca ganha',
      benefit1Title: 'Presença com relevância',
      benefit1Desc: 'Esteja presente nos momentos e territórios que fazem parte da rotina das pessoas.',
      benefit2Title: 'Confiança comunitária',
      benefit2Desc: 'Recomendações pessoais e a confiança construída entre vizinhos estão entre os fatores mais influentes na decisão de compra, superando boa parte da publicidade tradicional.',
      benefit3Title: 'Engajamento local autêntico',
      benefit3Desc: 'Crie conexões através de experiências e benefícios reais.',
      benefit4Title: 'Dados territoriais e inteligência local',
      benefit4Desc: 'Entenda quais comunidades, bairros e perfis apresentam maior engajamento.',
      benefit5Title: 'Impacto mensurável',
      benefit5Desc: 'Acompanhe resultados através de:',
      benefit5List1: 'Participação',
      benefit5List2: 'Resgates',
      benefit5List3: 'Ativações',
      benefit5List4: 'Alcance territorial',
      benefit5List5: 'Engajamento comunitário',
      mockAlt1: 'Tela de campanha de marca no BairrouApp',
      ctaTitle: 'Mais do que campanhas. Conexões.',
      ctaDesc: 'O BairrouApp! ajuda sua marca a construir presença onde a confiança é criada: nas relações entre pessoas, negócios e comunidades.',
      ctaDesc2: 'Porque os bairros não são apenas mercados. São ecossistemas de relacionamento, pertencimento e influência.',
      ctaButton: 'Agendar uma apresentação',
      ctaOr: 'Ou escreva diretamente para',
      formats: ['Hiperlocal', 'Sampling', 'Cupons', 'Impacto']
    },
    educa: {
      heroEyebrow: 'BAIRROUEDUCA!',
      heroTitle1: 'Conhecimento para crescer,',
      heroTitle2: 'sem custo adicional.',
      heroDesc: 'Todos os usuários do BairrouApp! têm acesso gratuito ao BairrouEduca!, a plataforma de capacitação criada para fortalecer pessoas, negócios e comunidades por meio do conhecimento.',
      heroDesc2: 'Tenha acesso a conteúdos práticos, cursos, trilhas de aprendizagem e certificações oferecidos por instituições reconhecidas, especialistas e profissionais de mercado, abordando temas como empreendedorismo, vendas, marketing digital, finanças, atendimento ao cliente, tecnologia, inovação e desenvolvimento profissional.',
      missionTitle: 'Democratizar o acesso à capacitação',
      missionDesc: 'Nosso objetivo é democratizar o acesso à capacitação de qualidade, ajudando pequenos empreendedores, prestadores de serviço e moradores a desenvolverem novas competências, aumentarem sua renda e fortalecerem a economia local.',
      findTitle: 'O que você encontra no BairrouEduca!',
      find1: 'Cursos e conteúdos gratuitos',
      find2: 'Certificações de parceiros estratégicos',
      find3: 'Trilhas de aprendizagem para empreendedores',
      find4: 'Conteúdos sobre gestão, vendas e marketing',
      find5: 'Capacitação profissional e desenvolvimento de carreira',
      find6: 'Boas práticas para negócios locais',
      find7: 'Conteúdo produzido por especialistas e instituições de referência',
      partnersTitle: 'Parceiros de conhecimento',
      partnersDesc: 'O BairrouEduca! busca reunir conteúdos e oportunidades de instituições reconhecidas, como o SEBRAE, além de especialistas, empresas e profissionais que compartilham conhecimento para impulsionar o desenvolvimento econômico e social dos territórios.',
      partnersClosing: 'Porque fortalecer a economia local também significa investir no crescimento das pessoas que fazem parte dela.',
      partnerChips: ['SEBRAE', 'Especialistas', 'Instituições', 'Profissionais'],
      freeBadge: '100% gratuito para todos os usuários',
      ctaTitle: 'Pronto para aprender e crescer?',
      ctaDesc: 'Faça parte do BairrouApp! e tenha o BairrouEduca! na palma da sua mão, sem custo adicional.',
      ctaButton: 'Fale com a gente'
    },
    gov: {
      heroEyebrow: 'BAIRROUGOV · GOVTECH',
      heroTitle1: 'Infraestrutura digital para engajamento territorial,',
      heroTitle2: 'desenvolvimento local e participação cidadã.',
      heroDesc: 'O BairrouGov ajuda municípios, subprefeituras, órgãos públicos e organizações de desenvolvimento a fortalecer o engajamento cidadão, as economias locais, a comunicação territorial e o impacto comunitário por meio de uma única infraestrutura digital.',
      ctaPrimary: 'Agendar uma demonstração',
      ctaSecondary: 'Falar com nosso time',
      whatTitle: 'Uma plataforma GovTech feita para bairros, comunidades e cidades.',
      whatDesc1: 'O BairrouGov é a camada GovTech do ecossistema Bairrou, criada para ajudar instituições públicas a conectar cidadãos, negócios locais, prestadores de serviço, organizações comunitárias e iniciativas de governo.',
      whatDesc2: 'Com geolocalização, inteligência territorial e ferramentas de engajamento, governos podem construir comunidades mais fortes, melhorar a comunicação pública e apoiar o desenvolvimento econômico local.',
      modulesTitle: 'Módulos principais',
      moduleTitles: ['Comunicação Territorial', 'Participação Cidadã', 'Desenvolvimento Econômico Local', 'BairrouImpacto Gov', 'BairrouEduca Gov', 'Inteligência Territorial'],
      moduleDescs: ['Comunicação segmentada por bairro, distrito ou região.', 'Habilite escuta, consulta e engajamento.', 'Apoie pequenos negócios e empreendedores locais.', 'Mobilize comunidades em torno de iniciativas sociais e ambientais.', 'Promova educação, empreendedorismo e qualificação profissional.', 'Transforme dados territoriais em melhores decisões.'],
      moduleFeatures: [['Campanhas públicas', 'Eventos e iniciativas', 'Notificações localizadas', 'Avisos comunitários'], ['Pesquisas', 'Consultas públicas', 'Feedback da comunidade', 'Programas de engajamento cidadão'], ['Mapeamento de negócios', 'Diretórios de comércio local', 'Iniciativas de desenvolvimento econômico', 'Programas de apoio a empreendedores'], ['Campanhas de sustentabilidade', 'Engajamento comunitário', 'Programas de conscientização em saúde', 'Iniciativas culturais'], ['Capacitação empreendedora', 'Qualificação profissional', 'Educação financeira', 'Inclusão digital'], ['Dashboards', 'Indicadores por bairro', 'Métricas de engajamento comunitário', 'Insights de atividade econômica']],
      useCasesTitle: 'Como governos podem usar o BairrouGov',
      useCases: ['Programas de engajamento de bairro', 'Iniciativas de desenvolvimento econômico', 'Eventos comunitários', 'Consultas públicas', 'Campanhas de sustentabilidade', 'Programas de empreendedorismo local', 'Iniciativas de qualificação profissional', 'Orçamento participativo'],
      impactTitle: 'Da comunicação à transformação.',
      impactGovTitle: 'Para governos',
      impactGov: ['Melhor comunicação com o cidadão', 'Mais participação', 'Decisões baseadas em dados', 'Economias locais mais fortes'],
      impactCitizensTitle: 'Para cidadãos',
      impactCitizens: ['Acesso mais fácil à informação', 'Mais oportunidades', 'Maior envolvimento comunitário', 'Identidade de bairro mais forte'],
      impactTerritoriesTitle: 'Para territórios',
      impactTerritories: ['Desenvolvimento econômico', 'Impacto social', 'Resiliência comunitária', 'Crescimento urbano sustentável'],
      dashboardTitle: 'Painel de Inteligência Territorial',
      dashboardDesc: 'Transforme dados do território em decisões melhores com dashboards e mapas em tempo real.',
      dashboardMetrics: ['Bairros ativos', 'Engajamento comunitário', 'Densidade de negócios locais', 'Participação em eventos', 'Indicadores de atividade econômica', 'Taxas de participação cidadã'],
      sdgTitle: 'Alinhado a metas globais de impacto.',
      sdgs: ['ODS 8 — Trabalho Decente e Crescimento Econômico', 'ODS 10 — Redução das Desigualdades', 'ODS 11 — Cidades e Comunidades Sustentáveis', 'ODS 12 — Consumo e Produção Responsáveis', 'ODS 17 — Parcerias e Meios de Implementação'],
      ecosystemTitle: 'Arquitetura do ecossistema',
      ecosystemDesc: 'Veja como governo, cidadãos, negócios, ONGs e marcas interagem através do ecossistema.',
      ecosystemCenter: 'Plataforma Bairrou',
      ecosystemModules: ['BairrouGov', 'BairrouApp', 'BairrouImpacto', 'BairrouEduca', 'BairrouClube', 'Inteligência Territorial'],
      investorsTitle: 'Uma plataforma que serve mercados públicos e privados.',
      investorsDesc: 'O Bairrou opera em dois mercados complementares:',
      marketB2cTitle: 'B2C / B2B',
      marketB2c: ['Cidadãos', 'Pequenos negócios', 'Prestadores de serviço', 'Marcas'],
      marketB2gTitle: 'B2G',
      marketB2g: ['Municípios', 'Subprefeituras', 'Órgãos públicos', 'Governos estaduais', 'Organizações de desenvolvimento'],
      investorsNote: 'Isso cria um modelo escalável de infraestrutura territorial, com oportunidades de receita recorrente e fortes efeitos de rede.',
      ctaFinalTitle: 'Construa bairros mais fortes e cidades mais inteligentes.',
      ctaFinalDesc: 'Fortaleça comunidades, impulsione economias locais e melhore o engajamento cidadão através de uma única plataforma territorial.',
      dashboardPanel: 'Painel Territorial',
      dashboardLive: 'Ao vivo',
      nodeLabels: ['Cidadãos', 'Negócios locais', 'Governo', 'Organizações']
    },
    clube: {
      heroEyebrow: 'BAIRROUCLUBE!',
      heroTitle1: 'Benefícios por apoiar',
      heroTitle2: 'o comércio local.',
      heroDesc1: 'O BairrouClube! é o programa de fidelidade do ecossistema Bairrou, criado para recompensar quem consome, participa e fortalece a economia do próprio bairro.',
      heroDesc2: 'Ao comprar em estabelecimentos parceiros, utilizar serviços locais ou participar de campanhas e eventos da comunidade, você acumula benefícios e vantagens exclusivas.',
      pointsTitle: 'BairrouPoints!',
      pointsSubtitle: 'Seus pontos, suas recompensas',
      pointsDesc1: 'Com o BairrouPoints!, suas interações geram recompensas que podem ser utilizadas em diferentes parceiros da rede.',
      pointsDesc2: 'Quanto mais você apoia negócios locais, mais benefícios desbloqueia.',
      pointsRedeemIntro: 'Você poderá trocar seus pontos por:',
      pointsList: ['Descontos em estabelecimentos parceiros', 'Produtos e serviços locais', 'Benefícios exclusivos', 'Experiências e ações promocionais', 'Campanhas especiais da comunidade'],
      couponsTitle: 'Cupons e Ofertas Locais',
      couponsSubtitle: 'Economize enquanto fortalece seu bairro',
      couponsDesc1: 'Tenha acesso a cupons, promoções e ofertas exclusivas de negócios próximos a você.',
      couponsDesc2: 'Descubra novas lojas, serviços e oportunidades, economizando no dia a dia enquanto contribui para o crescimento da economia local.',
      couponsIntro: 'Tudo em um só lugar:',
      couponsList: ['Cupons de desconto', 'Promoções sazonais', 'Campanhas especiais', 'Benefícios exclusivos para membros', 'Ofertas geolocalizadas'],
      cardLabels: ['Descontos', 'Ofertas', 'Exclusivos', 'Perto de você'],
      pointsBenefit: '+ benefícios a cada compra local',
      localTitle: 'Quanto mais local, melhor',
      localDesc: 'No BairrouApp!, cada compra, indicação ou interação ajuda a fortalecer os negócios da sua região, gerando mais oportunidades, renda e desenvolvimento para a comunidade.',
      localHighlight: 'Porque quando o bairro cresce, todo mundo ganha.',
      tagline: 'Descubra. Economize. Acumule. Aproveite.',
      ctaTitle: 'Faça parte do BairrouClube!',
      ctaDesc: 'Transforme suas compras locais em benefícios reais.',
      ctaButton: 'Fale com a gente'
    },
    tropa: {
      heroEyebrow: 'Tropa do Bairrou!',
      heroTitle: 'Conectando pessoas a oportunidades dentro da própria comunidade.',
      heroDesc1: 'A Tropa do Bairrou! é a rede colaborativa do ecossistema BairrouApp!, criada para conectar moradores a oportunidades de renda, participação e impacto dentro dos bairros onde vivem.',
      heroDesc2: 'Nossa proposta é simples: aproximar pessoas que precisam de ajuda, serviços ou apoio operacional daqueles que desejam gerar renda, desenvolver experiência profissional e contribuir para o fortalecimento da comunidade local.',
      howItWorksTitle: 'Como funciona',
      howItWorksDesc1: 'Através do BairrouApp!, parceiros, negócios, organizações e moradores podem publicar tarefas, demandas e oportunidades que podem ser executadas por membros da Tropa do Bairrou!.',
      howItWorksDesc2: 'Após a conclusão e validação da atividade, os participantes recebem a recompensa correspondente, que pode ser financeira, em benefícios ou através do ecossistema de recompensas do Bairrou.',
      opportunitiesTitle: 'Tipos de oportunidades',
      opportunitiesTitles: ['Entregas e apoio operacional', 'Apoio a eventos', 'Divulgação local', 'Pesquisas e coleta de informações', 'Validação de informações', 'Serviços sob demanda'],
      opportunitiesDescs: ['Auxílio na retirada, transporte e entrega de produtos para negócios locais e moradores.', 'Suporte em ações culturais, esportivas, comunitárias e eventos realizados no território.', 'Distribuição de materiais promocionais, divulgação de campanhas e mobilização comunitária.', 'Participação em levantamentos, pesquisas de opinião e mapeamento de necessidades locais.', 'Confirmação de funcionamento de estabelecimentos, atualização de cadastros e apoio à construção da inteligência territorial.', 'Pequenos serviços realizados por prestadores locais cadastrados na plataforma.'],
      participantBenefitsTitle: 'Benefícios para quem participa',
      participantBenefitsTitles: ['Gere renda local', 'Flexibilidade', 'Desenvolvimento profissional', 'Reconhecimento comunitário', 'Benefícios exclusivos'],
      participantBenefitsDescs: ['Tenha acesso a oportunidades próximas de onde você vive.', 'Escolha as tarefas e atividades que fazem sentido para sua rotina.', 'Construa experiência, reputação e novas conexões.', 'Participe ativamente do desenvolvimento do seu bairro.', 'Acumule recompensas e vantagens dentro do ecossistema Bairrou.'],
      businessBenefitsTitle: 'Benefícios para negócios e organizações',
      businessBenefitsTitles: ['Acesso rápido a apoio local', 'Redução de custos operacionais', 'Maior alcance territorial', 'Fortalecimento da comunidade'],
      businessBenefitsDescs: ['Encontre pessoas próximas para executar demandas pontuais.', 'Ative recursos da própria comunidade quando necessário.', 'Mobilize moradores para apoiar campanhas, eventos e iniciativas.', 'Transforme atividades econômicas em oportunidades locais.'],
      closingDesc1: 'Acreditamos que muitas oportunidades e talentos já existem dentro dos bairros. O desafio é criar as conexões certas.',
      closingDesc2: 'A Tropa do Bairrou! nasce para aproximar pessoas, negócios e organizações, fortalecendo a economia local e criando novas formas de participação, geração de renda e impacto comunitário.',
      closingHighlight: 'Trabalhe local. Gere impacto local. Cresça junto com sua comunidade.',
      ctaTitle: 'Faça parte da Tropa do Bairrou!',
      ctaDesc: 'Conecte-se a oportunidades reais dentro da sua comunidade.',
      ctaButton: 'Fale com a gente'
    },
    ods: {
      heroEyebrow: 'NOSSO IMPACTO',
      heroTitle1: 'Nosso compromisso com o',
      heroTitle2: 'futuro.',
      heroDesc: 'O BairrouApp nasceu com o propósito de gerar impacto positivo. Nossas ações e funcionalidades estão alinhadas aos Objetivos de Desenvolvimento Sustentável (ODS) da ONU.',
      stat1Desc: 'Itens reutilizados (Desapega)',
      stat2Desc: 'Injetados na economia local',
      stat3Desc: 'Horas de cursos (Educa)',
      stat4Desc: 'Projetos sociais apoiados',
      impactTitle: 'Impacto na prática',
      impactDesc: 'O módulo BairrouImpacta! transforma ações sustentáveis em recompensas. Os usuários completam missões como reciclar, apoiar o comércio local ou participar de mutirões, e ganham pontos por isso.',
      impactList1: 'Missões semanais de sustentabilidade',
      impactList2: 'Cálculo de CO2 economizado',
      impactList3: 'Apoio a projetos sociais do bairro',
      impactList4: 'Gamificação para o bem comum',
      odsTitle: 'Como contribuímos',
      ods1Title: 'Trabalho Decente e Crescimento Econômico',
      ods1Desc: 'Fortalecemos pequenos empreendedores locais, oferecendo ferramentas de digitalização, vendas e fidelização para que seus negócios prosperem, gerando emprego e renda no bairro.',
      ods2Title: 'Cidades e Comunidades Sustentáveis',
      ods2Desc: 'Conectamos vizinhos, reduzindo a necessidade de grandes deslocamentos para consumo e promovendo o senso de pertencimento e cuidado com o espaço urbano local.',
      ods3Title: 'Consumo e Produção Responsáveis',
      ods3Desc: "Através do módulo 'Desapega', incentivamos a economia circular, prolongando a vida útil de produtos e reduzindo o descarte e o consumo desenfreado.",
      ods4Title: 'Educação de Qualidade',
      ods4Desc: "O módulo 'Educa' democratiza o acesso a cursos de capacitação profissional e desenvolvimento pessoal para moradores e comerciantes locais.",
      impactEyebrow: 'NA PRÁTICA',
      odsEyebrow: 'OBJETIVOS DA ONU'
    },
    contato: {
      heroEyebrow: 'FALE CONOSCO',
      heroTitle: 'Fale com a gente',
      heroDesc: 'Dúvidas, sugestões ou parcerias? Estamos aqui para ouvir você.',
      infoTitle: 'Informações de Contato',
      infoEmail: 'E-mail',
      infoPhone: 'Telefone / WhatsApp',
      infoOffice: 'Escritório',
      infoAddress1: 'Rua do Bairro, 123 - Conjunto 45',
      infoAddress2: 'São Paulo, SP - 01234-567',
      successTitle: 'Mensagem enviada!',
      successDesc: 'Obrigado por entrar em contato. Nossa equipe responderá o mais breve possível.',
      successButton: 'Enviar nova mensagem',
      formName: 'Nome completo',
      formNamePlaceholder: 'Seu nome',
      formEmail: 'E-mail',
      formEmailPlaceholder: 'seu@email.com',
      formSubject: 'Assunto',
      formSubjectPlaceholder: 'Selecione um assunto...',
      formSub1: 'Sou usuário (Dúvida/Suporte)',
      formSub2: 'Tenho um negócio local',
      formSub3: 'Represento uma marca (Parcerias)',
      formSub4: 'Imprensa',
      formSub5: 'Outro',
      formSub6: 'Sou investidor',
      formSub7: 'Represento uma ONG',
      formMessage: 'Mensagem',
      formMessagePlaceholder: 'Como podemos ajudar?',
      formSubmit: 'Enviar mensagem',
      formSubmitting: 'Enviando...',
      errorTitle: 'Ops, algo deu errado',
      errorDesc: 'Não foi possível enviar sua mensagem agora. Tente novamente em instantes ou escreva para jon@bairrou.online.',
      errorButton: 'Tentar novamente'
    },
    precos: {
      heroEyebrow: 'PLANOS PARA PARCEIROS',
      heroTitle1: 'Impulsione seu negócio onde ele mais importa:',
      heroTitle2: 'no seu bairro.',
      heroDesc: 'Escolha o plano ideal para se conectar com os moradores, fidelizar clientes locais e capacitar sua equipe.',
      monthly: 'Mensal',
      annual: 'Anual',
      annualDiscount: 'Economize 20%',
      plan1Name: 'Básico',
      plan1Desc: 'Ideal para autônomos, profissionais liberais e prestadores de serviços locais que estão começando a marcar presença digital.',
      plan1PriceM: 'R$ 49,90',
      plan1PriceA: 'R$ 39,90',
      plan1Cta: 'Começar Agora',
      plan1Advantage: 'Sair da invisibilidade digital e ser encontrado imediatamente por quem mora a poucas quadras de você por menos de R$ 1,70 por dia.',
      plan2Name: 'Profissional',
      plan2Badge: 'MAIS VENDIDO',
      plan2Desc: 'Ideal para pequenos comércios, lojas físicas, cafeterias e mercados que querem criar uma base de clientes recorrentes e engajados.',
      plan2PriceM: 'R$ 99,90',
      plan2PriceA: 'R$ 79,90',
      plan2Cta: 'Experimentar Versão Profissional',
      plan2Advantage: 'Constrói uma barreira competitiva local através de fidelização real e inteligência operacional própria.',
      plan3Name: 'Premium',
      plan3Desc: 'Ideal para negócios estratégicos, franquias locais e estabelecimentos consolidados que buscam domínio territorial e campanhas agressivas.',
      plan3PriceM: 'R$ 199,90',
      plan3PriceA: 'R$ 159,90',
      plan3Cta: 'Falar com um Especialista',
      plan3Advantage: 'Ativação em tempo real e inteligência de dados de geofencing para garantir liderança de mercado na sua zona de atuação.',
      feature1: 'Perfil com fotos e contatos',
      feature2: 'Geolocalização no Mapa',
      feature3: 'Botão direto para o WhatsApp',
      feature4: 'Sistema de Avaliações',
      feature5: 'Programa de Fidelidade (BairrouClube)',
      feature6: 'Aceite e Gestão de BairrouPoints!',
      feature7: 'Plataforma de Ensino BairrouEduca!',
      feature8: 'Relatórios de Performance',
      feature9: 'Notificações Push Locais',
      feature10: 'Posição de Destaque no App',
      matrixTitle: 'Compare os planos em detalhes',
      matrixNote: 'Sem taxas ocultas sobre suas vendas por WhatsApp. Impostos e tarifas de processamento de cartão integradas nos planos recorrentes.',
      faqTitle: 'Perguntas Frequentes',
      faq1Q: 'Posso mudar de plano quando quiser?',
      faq1A: 'Sim, o upgrade ou downgrade pode ser feito a qualquer momento no seu painel de controle, sem multas ou taxas adicionais.',
      faq2Q: 'Como funcionam os BairrouPoints! no meu caixa?',
      faq2A: 'É uma ferramenta de engajamento integrada à plataforma. Você define as regras e os clientes acumulam e resgatam pontos sociais diretamente no seu estabelecimento, gerando recorrência.',
      faq3Q: 'Preciso de CNPJ para assinar?',
      faq3A: 'Não, prestadores autônomos e profissionais liberais podem assinar o Plano Básico utilizando apenas o CPF.',
      testimonialQuote: '"Depois que ativamos o plano Profissional, o movimento na padaria aumentou 30% nos dias de semana graças ao programa de fidelidade. Os vizinhos adoram acumular pontos!"',
      testimonialAuthor: '— Carlos M., dono de padaria local'
    },
    paraOng: {
      heroEyebrow: 'PARA ONGS E PROJETOS SOCIAIS',
      heroTitle1: 'Mobilize sua comunidade',
      heroTitle2: 'e amplie seu impacto.',
      heroDesc: 'O BairrouApp! conecta sua organização a moradores e negócios locais, facilitando a arrecadação de doações, o recrutamento de voluntários e a visibilidade das suas causas.',
      whatTitle: 'Como o BairrouApp! ajuda sua ONG',
      whatDesc: 'Nossa plataforma oferece ferramentas para que organizações sociais engajem a comunidade de forma direta e transparente, transformando o apoio local em impacto real.',
      benefitsTitle: 'Vantagens para sua organização',
      benefit1Title: 'Mobilização Comunitária',
      benefit1Desc: 'Conecte-se com moradores engajados e dispostos a apoiar causas no próprio bairro.',
      benefit2Title: 'Missões BairrouImpacta!',
      benefit2Desc: 'Crie missões onde os usuários ganham pontos ao participar de ações voluntárias ou doações.',
      benefit3Title: 'Campanhas Patrocinadas',
      benefit3Desc: 'Participe de campanhas onde marcas parceiras revertem parte das vendas locais para o seu projeto.',
      benefit4Title: 'Alcance Territorial',
      benefit4Desc: 'Aumente a visibilidade da sua ONG para quem vive e trabalha na sua região de atuação.',
      stepsTitle: 'Comece a impactar',
      step1Title: 'Cadastre sua ONG',
      step1Desc: 'Crie um perfil oficial para sua organização na plataforma.',
      step2Title: 'Crie campanhas',
      step2Desc: 'Divulgue suas necessidades de voluntariado ou arrecadação.',
      step3Title: 'Engaje a vizinhança',
      step3Desc: 'Receba apoio direto da comunidade e de negócios locais parceiros.',
      impactaEyebrow: 'INTEGRADO AO BAIRROUIMPACTA!',
      impactaTitle: 'Transforme apoio em impacto real',
      impactaDesc: 'Sua ONG se conecta diretamente ao módulo BairrouImpacta!, onde moradores cumprem missões de impacto social e ambiental no bairro. Cada missão concluída gera engajamento e apoio direto para a sua causa.',
      impactaList1: 'Crie missões de voluntariado e doação para a comunidade',
      impactaList2: 'Os moradores ganham BairrouPoints! ao participar',
      impactaList3: 'Acompanhe o impacto gerado em tempo real',
      impactaMockAlt: 'Módulo BairrouImpacta! mostrando missões de impacto social',
      ctaTitle: 'Pronto para ampliar seu impacto?',
      ctaDesc: 'Junte-se ao ecossistema Bairrou e conecte sua causa a quem quer fazer a diferença.',
      ctaButton: 'Fale com a gente'
    },
    paraInvestidor: {
      heroEyebrow: 'PARA INVESTIDORES',
      heroTitle1: 'A infraestrutura digital',
      heroTitle2: 'dos bairros e cidades.',
      heroDesc: 'O Bairrou é uma plataforma territorial escalável que conecta cidadãos, negócios locais, governos e grandes marcas, criando um ecossistema com fortes efeitos de rede e múltiplas linhas de receita.',
      marketTitle: 'Uma plataforma, dois mercados complementares',
      marketB2cTitle: 'B2C / B2B',
      marketB2cList: ['Cidadãos', 'Pequenos negócios', 'Prestadores de serviço', 'Marcas'],
      marketB2gTitle: 'B2G',
      marketB2gList: ['Municípios', 'Subprefeituras', 'Órgãos públicos', 'Governos estaduais', 'Organizações de desenvolvimento'],
      whyNowTitle: 'Por que agora?',
      whyNowDesc: 'A digitalização do comércio local e a necessidade de governos por ferramentas de engajamento cidadão criam uma oportunidade única para uma infraestrutura territorial unificada.',
      thesisTitle: 'Nossa tese de investimento',
      thesis1Title: 'Efeitos de Rede Locais',
      thesis1Desc: 'Cada novo usuário, negócio ou órgão público atrai mais participantes para o ecossistema local, criando barreiras de entrada naturais.',
      thesis2Title: 'Receita Recorrente e Diversificada',
      thesis2Desc: 'Monetização através de assinaturas SaaS para negócios, licenciamento GovTech para municípios e campanhas patrocinadas para marcas.',
      thesis3Title: 'Escalabilidade Territorial',
      thesis3Desc: 'Modelo de expansão bairro a bairro, cidade a cidade, com baixo custo marginal de replicação da infraestrutura tecnológica.',
      ecosystemTitle: 'Ecossistema Bairrou',
      ecosystemDesc: 'Uma arquitetura modular que atende a diferentes necessidades do território.',
      tractionTitle: 'Alinhamento com Impacto Global',
      tractionDesc: 'Nosso modelo de negócio é nativamente alinhado aos Objetivos de Desenvolvimento Sustentável (ODS) da ONU, unindo retorno financeiro a impacto social e econômico mensurável.',
      ctaTitle: 'Faça parte dessa transformação',
      ctaDesc: 'Estamos construindo a infraestrutura digital que vai redefinir a economia e o engajamento local.',
      ctaButton: 'Falar com Relações com Investidores'
    }
  },
  en: {
    nav: {
      inicio: 'Home',
      paraVoce: 'For You',
      paraNegocio: 'For Business',
      paraMarca: 'For Brands',
      ods: 'SDGs',
      educa: 'BairrouEduca!',
      gov: 'BairrouGov',
      clube: 'BairrouClube!',
      tropa: 'Tropa do Bairrou!',
      solucoes: 'Solutions',
      ecossistema: 'Ecosystem',
      precos: 'Pricing',
      contato: 'Contact',
      paraOng: 'For NGOs',
      paraInvestidor: 'For Investors'
    },
    footer: {
      blurb: 'The best is right here! Connecting you to businesses, opportunities, and people in your neighborhood.',
      plataforma: 'Platform',
      contato: 'Contact',
      faleConosco: 'Contact Us',
      direitos: '© 2026 BairrouApp. All rights reserved.',
      termos: 'Terms of Use',
      privacidade: 'Privacy Policy'
    },
    common: {
      disponivelEmBreve: 'Coming soon',
      saibaMais: 'Learn more',
      faleComAGente: 'Get in touch',
      falarComNossoTime: 'Talk to our team',
      trustedBy: 'Trusted by',
      tagline: 'The best is right here!',
      darkModeOn: 'Switch to dark mode',
      darkModeOff: 'Switch to light mode'
    },
    home: {
      heroEyebrow: 'YOUR NEIGHBORHOOD APP',
      heroTitle1: 'Your neighborhood,',
      heroTitle2: 'in one app.',
      heroDesc: 'BairrouApp! is the digital infrastructure for neighborhoods: discover local businesses, earn points, save money, and strengthen your community — all in a single app.',
      comoFunciona: 'How it works?',
      comoFuncionaDesc: 'Everything you need to experience your neighborhood better, right in your hand.',
      step1Title: '1. Explore',
      step1Desc: 'Find the best shops, services, and deals near you.',
      step2Title: '2. Shop and Earn',
      step2Desc: 'Earn points on every purchase and redeem them for exclusive discounts.',
      step3Title: '3. Strengthen',
      step3Desc: 'Support the local economy and participate in neighborhood impact initiatives.',
      pilaresTitle: 'One app, many possibilities',
      pilar1Title: 'Local Deals',
      pilar1Desc: 'Coupons and promotions from your neighbors.',
      pilar2Title: 'Education',
      pilar2Desc: 'Courses and training for the community.',
      pilar3Title: 'Marketplace',
      pilar3Desc: 'Buy, sell, or trade used items.',
      pilar4Title: 'Impact',
      pilar4Desc: 'Support social causes in your neighborhood.',
      audiencesTitle: 'Made for everyone',
      audiencesDesc: 'Whether you are a resident, a small business owner, or a large brand.',
      aud1Title: 'For You',
      aud1Desc: 'Save money, earn points, and discover the best of your neighborhood.',
      aud2Title: 'For Business',
      aud2Desc: 'Attract more local customers and build loyalty in your neighborhood.',
      aud3Title: 'For Brands',
      aud3Desc: 'Connect with communities authentically and hyper-locally.',
      ctaTitle: 'Ready to explore?',
      ctaDesc: 'Join thousands of neighbors who are already transforming their neighborhoods.',
      featuresEyebrow: 'ALL IN ONE PLACE',
      audiencesEyebrow: 'WHO IT IS FOR',
      mockAlt2: 'Local deals screen on BairrouApp'
    },
    paraVoce: {
      heroEyebrow: 'FOR RESIDENTS',
      heroTitle1: 'The best of your neighborhood,',
      heroTitle2: 'for you.',
      heroDesc: 'Exclusive discounts, point accumulation, and the ease of finding everything you need just steps from home.',
      ben1Title: 'Discounts and Coupons',
      ben1Desc: 'Enjoy exclusive offers at the local shops you already love.',
      ben2Title: 'Points and Rewards',
      ben2Desc: 'Every purchase generates points in your digital wallet to exchange for prizes.',
      ben3Title: 'Discover Businesses',
      ben3Desc: 'Find bakeries, mechanics, salons, and much more, right nearby.',
      ben4Title: 'Courses in Educa',
      ben4Desc: 'Access training and quick courses for your development.',
      ben5Title: 'Buy and Sell',
      ben5Desc: 'Use the Marketplace to give new life to items you no longer use.',
      ben6Title: 'Easy Payments',
      ben6Desc: 'Pay for your purchases directly through the app securely.',
      walletTitle: 'Your benefits wallet',
      walletDesc: 'Track your points, redeem coupons, and view your savings history in real time. Everything organized in one place for you to enjoy the best of your neighborhood.',
      walletList1: 'Instantly updated balance',
      walletList2: 'Local rewards catalog',
      walletList3: 'Transparent history of earnings and usage',
      howToTitle: 'How to earn points?',
      howToDesc: "It's simple, fast, and fun.",
      step1Title: 'Shop locally',
      step1Desc: 'Make purchases at partner establishments using the app.',
      step2Title: 'Complete missions',
      step2Desc: 'Participate in local challenges, like reviewing a store or recycling items.',
      step3Title: 'Refer friends',
      step3Desc: 'Bring your neighbors to BairrouApp and earn extra points.',
      step4Title: 'Redeem for prizes',
      step4Desc: 'Use your points to redeem products, services, or discounts.',
      testimonialQuote: '"Since I started using BairrouApp, I discovered amazing places on my street that I didn\'t even know existed. And the points I accumulate have already paid for my breakfast several times!"',
      testimonialAuthor: '— Mariana S., local resident',
      benefitsEyebrow: 'BENEFITS',
      benefitsTitle: 'Everything you need',
      howToEyebrow: 'STEP BY STEP',
      mockAlt2: 'Missions and rewards screen on BairrouApp'
    },
    paraNegocio: {
      heroEyebrow: 'FOR ENTREPRENEURS',
      heroTitle1: 'Grow your business',
      heroTitle2: 'in the neighborhood.',
      heroDesc: 'Connect with customers who live near you. Increase your sales, create loyalty programs, and gain local visibility.',
      dashTitle: 'Merchant Dashboard',
      dashDesc: "Today's overview",
      dashStat1: 'Page visits',
      dashStat2: 'Redeemed coupons',
      dashStat3: 'New customers',
      whyTitle: 'Why BairrouApp?',
      why1Title: 'Attract the Neighborhood',
      why1Desc: 'Be found by people who live or work near your establishment.',
      why2Title: 'Create Offers',
      why2Desc: 'Publish promotions and coupons to attract traffic on quieter days.',
      why3Title: 'Build Loyalty',
      why3Desc: 'Offer points on purchases to ensure your customers always return.',
      why4Title: 'Receive Payments',
      why4Desc: 'Accept payments through the app with competitive rates and fast receipt.',
      why5Title: 'Local Visibility',
      why5Desc: 'Stand out on the neighborhood map and in category searches.',
      why6Title: 'Digital Storefront',
      why6Desc: 'Show your products, hours, and photos on an exclusive page.',
      presenceTitle: 'Your accessible digital presence',
      presenceDesc: 'Get a page for your business inside the app and democratize loyalty: tools once reserved for large chains, now within reach of neighborhood commerce. Showcase your services and hours, offer coupons, and a digital loyalty card to your neighborhood.',
      presenceList1: 'Listing of your establishment or service',
      presenceList2: 'Updated opening hours',
      presenceList3: 'Offers and digital loyalty card',
      presenceList4: 'QR Code check-in',
      stepsTitle: 'Start in 3 steps',
      step1Title: 'Sign up',
      step1Desc: 'Create your merchant account in less than 5 minutes.',
      step2Title: 'Configure',
      step2Desc: 'Add photos, hours, and your first offer.',
      step3Title: 'Sell more',
      step3Desc: 'Start receiving customers from your neighborhood.',
      pricingTitle: 'Plans that fit your budget',
      pricingDesc: 'Start for free and pay only a small fee on sales made through the app. No surprise monthly fees.',
      planTitle: 'Basic Plan',
      planList1: 'Listing of your establishment or service',
      planList2: 'Basic points program',
      planPrice: 'Free',
      planSub: 'to start',
      whyEyebrow: 'WHY CHOOSE US',
      presenceEyebrow: 'DIGITAL STOREFRONT',
      stepsEyebrow: 'HOW TO START',
      pricingEyebrow: 'PRICING',
      democEyebrow: 'WITHIN YOUR REACH',
      democTitle: 'Business intelligence and loyalty that only big chains used to have',
      democDesc: "You don't need to build or maintain your own app. BairrouApp! democratizes access to tools that were expensive and exclusive to large chains — now simple and affordable for neighborhood commerce.",
      democCard1Title: 'A loyalty program without your own app',
      democCard1Desc: 'Offer points, coupons, and a digital loyalty card to your customers without investing in building and maintaining an app. It all happens inside BairrouApp!.',
      democCard2Title: 'Accessible business intelligence',
      democCard2Desc: "Understand your customers with data on repeat visits, the offers that convert best, and your store's performance — insights once reserved for those with big budgets and data teams.",
      democCard3Title: 'Truly accessible',
      democCard3Desc: 'Start for free, with no surprise monthly fees and no technical barrier. Going digital and building loyalty fits your budget and your routine.',
      democHighlight: "Big-chain technology, within your neighborhood's reach."
    },
    paraMarca: {
      heroEyebrow: 'FOR LARGE BRANDS',
      heroTag: 'B2B & Partnerships',
      heroTitle1: 'Connect your brand to communities',
      heroTitle2: 'where trust happens.',
      heroDesc: 'In a landscape where consumers are increasingly selective with traditional advertising, recommendations from close ones, real experiences, and community connections play a fundamental role in building trust and driving purchase decisions.',
      heroNielsen: 'Recommendations from friends, family, and people nearby remain the most trusted form of communication for consumers — and that is exactly where BairrouApp! positions your brand: present in neighborhoods in a relevant way, supporting small businesses, activating communities, and creating experiences that generate value for everyone involved.',
      activeTerritoriesTitle: 'Activate territories, not just audiences',
      activeTerritoriesDesc: 'Instead of talking to consumers generically, your brand can connect directly to the places where people live, work, consume, and interact. Transform neighborhoods into strategic touchpoints through:',
      activeTerritoriesList1: 'Geolocated campaigns',
      activeTerritoriesList2: 'Distribution of samples and giveaways',
      activeTerritoriesList3: 'Promotional coupons',
      activeTerritoriesList4: 'Sponsored experiences',
      activeTerritoriesList5: 'Social impact actions',
      activeTerritoriesList6: 'Community engagement initiatives',
      strengthenTitle: 'Strengthen small businesses and distributors',
      strengthenDesc: 'BairrouApp! transforms local merchants, service providers, and distributors into activation partners for your brand. This allows you to:',
      strengthenList1: 'Expand reach',
      strengthenList2: 'Generate product trial',
      strengthenList3: 'Strengthen local channels',
      strengthenList4: 'Create long-term relationships',
      strengthenConclusion: 'While the brand gains territorial presence, small businesses gain foot traffic, visibility, and new revenue opportunities.',
      examplesTitle: 'Campaign Examples',
      example1Title: 'Neighborhood Circuits',
      example1Desc: 'Create sponsored journeys involving multiple local partners. Examples:',
      example1List1: 'Coffee Circuit',
      example1List2: 'Beauty Circuit',
      example1List3: 'Family Circuit',
      example1List4: 'Summer Circuit',
      example2Title: 'Buy and Get',
      example2Desc: 'Encourage trial through sponsored benefits.',
      example2Detail: 'Buy at participating partners and receive an exclusive product, sample, or benefit from the brand.',
      example3Title: 'Local Discovery',
      example3Desc: 'Encourage consumers to discover new establishments and products within the community.',
      example4Title: 'Sponsored Social Impact',
      example4Desc: 'Associate your brand with social, cultural, or environmental projects in the territory.',
      example4Detail: 'With every purchase made, part of the campaign investment supports a local initiative.',
      benefitsTitle: 'What your brand gains',
      benefit1Title: 'Relevant presence',
      benefit1Desc: "Be present in the moments and territories that are part of people's daily routines.",
      benefit2Title: 'Community trust',
      benefit2Desc: 'Personal recommendations and the trust built between neighbors are among the most influential drivers of purchase decisions, outperforming much of traditional advertising.',
      benefit3Title: 'Authentic local engagement',
      benefit3Desc: 'Create connections through real experiences and benefits.',
      benefit4Title: 'Territorial data and local intelligence',
      benefit4Desc: 'Understand which communities, neighborhoods, and profiles show the highest engagement.',
      benefit5Title: 'Measurable impact',
      benefit5Desc: 'Track results through:',
      benefit5List1: 'Participation',
      benefit5List2: 'Redemptions',
      benefit5List3: 'Activations',
      benefit5List4: 'Territorial reach',
      benefit5List5: 'Community engagement',
      mockAlt1: 'Brand campaign screen on BairrouApp',
      ctaTitle: 'More than campaigns. Connections.',
      ctaDesc: 'BairrouApp! helps your brand build presence where trust is created: in the relationships between people, businesses, and communities.',
      ctaDesc2: 'Because neighborhoods are not just markets. They are ecosystems of relationships, belonging, and influence.',
      ctaButton: 'Schedule a presentation',
      ctaOr: 'Or write directly to',
      formats: ['Hyperlocal', 'Sampling', 'Coupons', 'Impact']
    },
    educa: {
      heroEyebrow: 'BAIRROUEDUCA!',
      heroTitle1: 'Knowledge to grow,',
      heroTitle2: 'at no extra cost.',
      heroDesc: 'Every BairrouApp! user has free access to BairrouEduca!, the learning platform created to strengthen people, businesses, and communities through knowledge.',
      heroDesc2: 'Get access to practical content, courses, learning paths, and certifications offered by recognized institutions, experts, and market professionals, covering topics such as entrepreneurship, sales, digital marketing, finance, customer service, technology, innovation, and professional development.',
      missionTitle: 'Democratizing access to training',
      missionDesc: 'Our goal is to democratize access to quality training, helping small entrepreneurs, service providers, and residents develop new skills, increase their income, and strengthen the local economy.',
      findTitle: 'What you will find in BairrouEduca!',
      find1: 'Free courses and content',
      find2: 'Certifications from strategic partners',
      find3: 'Learning paths for entrepreneurs',
      find4: 'Content on management, sales, and marketing',
      find5: 'Professional training and career development',
      find6: 'Best practices for local businesses',
      find7: 'Content produced by experts and leading institutions',
      partnersTitle: 'Knowledge partners',
      partnersDesc: 'BairrouEduca! aims to bring together content and opportunities from recognized local entrepreneurship support institutions, in addition to experts, companies, and professionals who share knowledge to drive the economic and social development of territories.',
      partnersClosing: 'Because strengthening the local economy also means investing in the growth of the people who are part of it.',
      partnerChips: ['Local entrepreneurship support institutions', 'Experts', 'Institutions', 'Professionals'],
      freeBadge: '100% free for all users',
      ctaTitle: 'Ready to learn and grow?',
      ctaDesc: 'Join BairrouApp! and have BairrouEduca! in the palm of your hand, at no extra cost.',
      ctaButton: 'Get in touch'
    },
    gov: {
      heroEyebrow: 'BAIRROUGOV · GOVTECH',
      heroTitle1: 'Digital infrastructure for territorial engagement,',
      heroTitle2: 'local development and citizen participation.',
      heroDesc: 'BairrouGov helps municipalities, subprefeituras, public agencies, and development organizations strengthen citizen engagement, local economies, territorial communication, and community impact through a single digital infrastructure.',
      ctaPrimary: 'Schedule a Demo',
      ctaSecondary: 'Talk to Our Team',
      whatTitle: 'A GovTech platform built for neighborhoods, communities, and cities.',
      whatDesc1: 'BairrouGov is the GovTech layer of the Bairrou ecosystem, designed to help public institutions connect citizens, local businesses, service providers, community organizations, and government initiatives.',
      whatDesc2: 'Using geolocation, territorial intelligence, and engagement tools, governments can create stronger communities, improve public communication, and support local economic development.',
      modulesTitle: 'Core Modules',
      moduleTitles: ['Territorial Communication', 'Citizen Participation', 'Local Economic Development', 'BairrouImpacto Gov', 'BairrouEduca Gov', 'Territorial Intelligence'],
      moduleDescs: ['Segmented communication by neighborhood, district, or region.', 'Enable listening, consultation, and engagement.', 'Support small businesses and local entrepreneurs.', 'Mobilize communities around social and environmental initiatives.', 'Promote education, entrepreneurship, and workforce development.', 'Transform territorial data into better decisions.'],
      moduleFeatures: [['Public campaigns', 'Events and initiatives', 'Localized notifications', 'Community announcements'], ['Surveys', 'Public consultations', 'Community feedback', 'Citizen engagement programs'], ['Business mapping', 'Local commerce directories', 'Economic development initiatives', 'Entrepreneur support programs'], ['Sustainability campaigns', 'Community engagement', 'Health awareness programs', 'Cultural initiatives'], ['Entrepreneurship training', 'Professional qualification', 'Financial literacy', 'Digital inclusion'], ['Dashboards', 'Neighborhood indicators', 'Community engagement metrics', 'Economic activity insights']],
      useCasesTitle: 'How governments can use BairrouGov',
      useCases: ['Neighborhood engagement programs', 'Economic development initiatives', 'Community events', 'Public consultations', 'Sustainability campaigns', 'Local entrepreneurship programs', 'Workforce development initiatives', 'Participatory budgeting'],
      impactTitle: 'From communication to transformation.',
      impactGovTitle: 'For Governments',
      impactGov: ['Better citizen communication', 'More participation', 'Data-driven decision making', 'Stronger local economies'],
      impactCitizensTitle: 'For Citizens',
      impactCitizens: ['Easier access to information', 'More opportunities', 'Greater community involvement', 'Stronger neighborhood identity'],
      impactTerritoriesTitle: 'For Territories',
      impactTerritories: ['Economic development', 'Social impact', 'Community resilience', 'Sustainable urban growth'],
      dashboardTitle: 'Territorial Intelligence Dashboard',
      dashboardDesc: 'Turn territorial data into better decisions with real-time dashboards and maps.',
      dashboardMetrics: ['Active neighborhoods', 'Community engagement', 'Local business density', 'Event participation', 'Economic activity indicators', 'Citizen participation rates'],
      sdgTitle: 'Aligned with global impact goals.',
      sdgs: ['SDG 8 — Decent Work and Economic Growth', 'SDG 10 — Reduced Inequalities', 'SDG 11 — Sustainable Cities and Communities', 'SDG 12 — Responsible Consumption and Production', 'SDG 17 — Partnerships for the Goals'],
      ecosystemTitle: 'Ecosystem Architecture',
      ecosystemDesc: 'See how government, citizens, businesses, NGOs, and brands interact through the ecosystem.',
      ecosystemCenter: 'Bairrou Platform',
      ecosystemModules: ['BairrouGov', 'BairrouApp', 'BairrouImpacto', 'BairrouEduca', 'BairrouClube', 'Territorial Intelligence'],
      investorsTitle: 'A platform serving both public and private markets.',
      investorsDesc: 'Bairrou operates across two complementary markets:',
      marketB2cTitle: 'B2C / B2B',
      marketB2c: ['Citizens', 'Small businesses', 'Service providers', 'Brands'],
      marketB2gTitle: 'B2G',
      marketB2g: ['Municipalities', 'Subprefectures', 'Government agencies', 'State governments', 'Development organizations'],
      investorsNote: 'This creates a scalable territorial infrastructure model with recurring revenue opportunities and strong network effects.',
      ctaFinalTitle: 'Build stronger neighborhoods and smarter cities.',
      ctaFinalDesc: 'Empower communities, strengthen local economies, and improve citizen engagement through a single territorial platform.',
      dashboardPanel: 'Territorial Dashboard',
      dashboardLive: 'Live',
      nodeLabels: ['Citizens', 'Local businesses', 'Government', 'Organizations']
    },
    clube: {
      heroEyebrow: 'BAIRROUCLUBE!',
      heroTitle1: 'Rewards for supporting',
      heroTitle2: 'local commerce.',
      heroDesc1: 'BairrouClube! is the loyalty program of the Bairrou ecosystem, created to reward those who shop, participate, and strengthen the economy of their own neighborhood.',
      heroDesc2: 'By shopping at partner establishments, using local services, or taking part in community campaigns and events, you accumulate exclusive benefits and advantages.',
      pointsTitle: 'BairrouPoints!',
      pointsSubtitle: 'Your points, your rewards',
      pointsDesc1: 'With BairrouPoints!, your interactions generate rewards that can be used across different partners in the network.',
      pointsDesc2: 'The more you support local businesses, the more benefits you unlock.',
      pointsRedeemIntro: 'You will be able to redeem your points for:',
      pointsList: ['Discounts at partner establishments', 'Local products and services', 'Exclusive benefits', 'Experiences and promotional actions', 'Special community campaigns'],
      couponsTitle: 'Local Coupons & Offers',
      couponsSubtitle: 'Save while strengthening your neighborhood',
      couponsDesc1: 'Get access to exclusive coupons, promotions, and offers from businesses near you.',
      couponsDesc2: 'Discover new shops, services, and opportunities, saving on everyday life while contributing to the growth of the local economy.',
      couponsIntro: 'All in one place:',
      couponsList: ['Discount coupons', 'Seasonal promotions', 'Special campaigns', 'Exclusive member benefits', 'Geolocated offers'],
      cardLabels: ['Discounts', 'Offers', 'Exclusive', 'Near you'],
      pointsBenefit: '+ benefits with every local purchase',
      localTitle: 'The more local, the better',
      localDesc: 'On BairrouApp!, every purchase, referral, or interaction helps strengthen the businesses in your region, generating more opportunities, income, and development for the community.',
      localHighlight: 'Because when the neighborhood grows, everyone wins.',
      tagline: 'Discover. Save. Earn. Enjoy.',
      ctaTitle: 'Join BairrouClube!',
      ctaDesc: 'Turn your local purchases into real benefits.',
      ctaButton: 'Get in touch'
    },
    tropa: {
      heroEyebrow: 'Tropa do Bairrou!',
      heroTitle: 'Connecting people to opportunities within their own community.',
      heroDesc1: 'Tropa do Bairrou! is the collaborative network of the BairrouApp! ecosystem, created to connect residents to opportunities for income, participation, and impact within the neighborhoods where they live.',
      heroDesc2: 'Our proposal is simple: bring together people who need help, services, or operational support with those who want to generate income, develop professional experience, and contribute to strengthening the local community.',
      howItWorksTitle: 'How it works',
      howItWorksDesc1: 'Through BairrouApp!, partners, businesses, organizations, and residents can publish tasks, demands, and opportunities that can be executed by members of Tropa do Bairrou!.',
      howItWorksDesc2: 'Upon completion and validation of the activity, participants receive the corresponding reward, which can be financial, in benefits, or through the Bairrou rewards ecosystem.',
      opportunitiesTitle: 'Types of opportunities',
      opportunitiesTitles: ['Deliveries and operational support', 'Event support', 'Local promotion', 'Research and data collection', 'Information validation', 'On-demand services'],
      opportunitiesDescs: ['Assistance with pickup, transportation, and delivery of products for local businesses and residents.', 'Support for cultural, sports, community actions, and events held in the territory.', 'Distribution of promotional materials, campaign promotion, and community mobilization.', 'Participation in surveys, opinion polls, and mapping of local needs.', 'Confirmation of establishment operations, registration updates, and support for building territorial intelligence.', 'Small services performed by local providers registered on the platform.'],
      participantBenefitsTitle: 'Benefits for participants',
      participantBenefitsTitles: ['Generate local income', 'Flexibility', 'Professional development', 'Community recognition', 'Exclusive benefits'],
      participantBenefitsDescs: ['Get access to opportunities close to where you live.', 'Choose the tasks and activities that make sense for your routine.', 'Build experience, reputation, and new connections.', 'Actively participate in the development of your neighborhood.', 'Accumulate rewards and advantages within the Bairrou ecosystem.'],
      businessBenefitsTitle: 'Benefits for businesses and organizations',
      businessBenefitsTitles: ['Quick access to local support', 'Reduction of operational costs', 'Greater territorial reach', 'Community strengthening'],
      businessBenefitsDescs: ['Find people nearby to execute specific demands.', 'Activate resources from the community itself when needed.', 'Mobilize residents to support campaigns, events, and initiatives.', 'Transform economic activities into local opportunities.'],
      closingDesc1: 'We believe that many opportunities and talents already exist within neighborhoods. The challenge is creating the right connections.',
      closingDesc2: 'Tropa do Bairrou! is born to bring people, businesses, and organizations closer together, strengthening the local economy and creating new forms of participation, income generation, and community impact.',
      closingHighlight: 'Work locally. Generate local impact. Grow together with your community.',
      ctaTitle: 'Join Tropa do Bairrou!',
      ctaDesc: 'Connect to real opportunities within your community.',
      ctaButton: 'Get in touch'
    },
    ods: {
      heroEyebrow: 'OUR IMPACT',
      heroTitle1: 'Our commitment to the',
      heroTitle2: 'future.',
      heroDesc: 'BairrouApp was born with the purpose of generating positive impact. Our actions and features are aligned with the UN Sustainable Development Goals (SDGs).',
      stat1Desc: 'Reused items (Marketplace)',
      stat2Desc: 'Injected into the local economy',
      stat3Desc: 'Hours of courses (Education)',
      stat4Desc: 'Social projects supported',
      impactTitle: 'Impact in practice',
      impactDesc: 'The BairrouImpacta! module transforms sustainable actions into rewards. Users complete missions like recycling, supporting local commerce, or participating in cleanups, and earn points for it.',
      impactList1: 'Weekly sustainability missions',
      impactList2: 'Saved CO2 calculation',
      impactList3: 'Support for neighborhood social projects',
      impactList4: 'Gamification for the common good',
      odsTitle: 'How we contribute',
      ods1Title: 'Decent Work and Economic Growth',
      ods1Desc: 'We strengthen small local entrepreneurs by offering digitization, sales, and loyalty tools so their businesses thrive, generating employment and income in the neighborhood.',
      ods2Title: 'Sustainable Cities and Communities',
      ods2Desc: 'We connect neighbors, reducing the need for large commutes for consumption and promoting a sense of belonging and care for the local urban space.',
      ods3Title: 'Responsible Consumption and Production',
      ods3Desc: "Through the 'Marketplace' module, we encourage the circular economy, extending the lifespan of products and reducing waste and unbridled consumption.",
      ods4Title: 'Quality Education',
      ods4Desc: "The 'Education' module democratizes access to professional training and personal development courses for local residents and merchants.",
      impactEyebrow: 'IN PRACTICE',
      odsEyebrow: 'UN GOALS'
    },
    contato: {
      heroEyebrow: 'GET IN TOUCH',
      heroTitle: 'Get in touch',
      heroDesc: 'Questions, suggestions, or partnerships? We are here to listen to you.',
      infoTitle: 'Contact Information',
      infoEmail: 'Email',
      infoPhone: 'Phone / WhatsApp',
      infoOffice: 'Office',
      infoAddress1: 'Neighborhood Street, 123 - Suite 45',
      infoAddress2: 'São Paulo, SP - 01234-567',
      successTitle: 'Message sent!',
      successDesc: 'Thank you for getting in touch. Our team will respond as soon as possible.',
      successButton: 'Send new message',
      formName: 'Full Name',
      formNamePlaceholder: 'Your name',
      formEmail: 'Email',
      formEmailPlaceholder: 'your@email.com',
      formSubject: 'Subject',
      formSubjectPlaceholder: 'Select a subject...',
      formSub1: 'I am a user (Question/Support)',
      formSub2: 'I have a local business',
      formSub3: 'I represent a brand (Partnerships)',
      formSub4: 'Press',
      formSub5: 'Other',
      formSub6: 'I am an investor',
      formSub7: 'I represent an NGO',
      formMessage: 'Message',
      formMessagePlaceholder: 'How can we help?',
      formSubmit: 'Send message',
      formSubmitting: 'Sending...',
      errorTitle: 'Oops, something went wrong',
      errorDesc: 'We could not send your message right now. Please try again in a moment or write to jon@bairrou.online.',
      errorButton: 'Try again'
    },
    precos: {
      heroEyebrow: 'PARTNER PLANS',
      heroTitle1: 'Boost your business where it matters most:',
      heroTitle2: 'in your neighborhood.',
      heroDesc: 'Choose the ideal plan to connect with residents, build local loyalty, and empower your team.',
      monthly: 'Monthly',
      annual: 'Annual',
      annualDiscount: 'Save 20%',
      plan1Name: 'Basic',
      plan1Desc: 'Ideal for freelancers, independent professionals, and local service providers starting their digital presence.',
      plan1PriceM: 'R$ 49.90',
      plan1PriceA: 'R$ 39.90',
      plan1Cta: 'Start Now',
      plan1Advantage: 'Step out of digital invisibility and be found immediately by those living a few blocks away for less than R$ 1.70 a day.',
      plan2Name: 'Professional',
      plan2Badge: 'MOST POPULAR',
      plan2Desc: 'Ideal for small shops, physical stores, cafes, and markets looking to build a recurring and engaged customer base.',
      plan2PriceM: 'R$ 99.90',
      plan2PriceA: 'R$ 79.90',
      plan2Cta: 'Try Professional Version',
      plan2Advantage: 'Builds a local competitive barrier through real loyalty and proprietary operational intelligence.',
      plan3Name: 'Premium',
      plan3Desc: 'Ideal for strategic businesses, local franchises, and established establishments seeking territorial dominance and aggressive campaigns.',
      plan3PriceM: 'R$ 199.90',
      plan3PriceA: 'R$ 159.90',
      plan3Cta: 'Talk to an Expert',
      plan3Advantage: 'Real-time activation and geofencing data intelligence to ensure market leadership in your area of operation.',
      feature1: 'Profile with photos and contacts',
      feature2: 'Geolocation on Map',
      feature3: 'Direct WhatsApp button',
      feature4: 'Review System',
      feature5: 'Loyalty Program (BairrouClube)',
      feature6: 'Accept and Manage BairrouPoints!',
      feature7: 'BairrouEduca! Learning Platform',
      feature8: 'Performance Reports',
      feature9: 'Local Push Notifications',
      feature10: 'Featured Position in App',
      matrixTitle: 'Compare plans in detail',
      matrixNote: 'No hidden fees on your WhatsApp sales. Taxes and card processing fees integrated into recurring plans.',
      faqTitle: 'Frequently Asked Questions',
      faq1Q: 'Can I change my plan whenever I want?',
      faq1A: 'Yes, upgrades or downgrades can be done at any time in your dashboard, without penalties or additional fees.',
      faq2Q: 'How do BairrouPoints! work at my checkout?',
      faq2A: 'It is an engagement tool integrated into the platform. You set the rules, and customers accumulate and redeem social points directly at your establishment, generating recurrence.',
      faq3Q: 'Do I need a business ID (CNPJ) to subscribe?',
      faq3A: 'No, freelancers and independent professionals can subscribe to the Basic Plan using just their personal ID (CPF).',
      testimonialQuote: '"After activating the Professional plan, traffic at the bakery increased by 30% on weekdays thanks to the loyalty program. Neighbors love accumulating points!"',
      testimonialAuthor: '— Carlos M., local bakery owner'
    },
    paraOng: {
      heroEyebrow: 'FOR NGOS AND SOCIAL PROJECTS',
      heroTitle1: 'Mobilize your community',
      heroTitle2: 'and expand your impact.',
      heroDesc: 'BairrouApp! connects your organization to local residents and businesses, facilitating donation drives, volunteer recruitment, and visibility for your causes.',
      whatTitle: 'How BairrouApp! helps your NGO',
      whatDesc: 'Our platform offers tools for social organizations to engage the community directly and transparently, turning local support into real impact.',
      benefitsTitle: 'Advantages for your organization',
      benefit1Title: 'Community Mobilization',
      benefit1Desc: 'Connect with engaged residents willing to support causes in their own neighborhood.',
      benefit2Title: 'BairrouImpacta! Missions',
      benefit2Desc: 'Create missions where users earn points by participating in volunteer actions or donations.',
      benefit3Title: 'Sponsored Campaigns',
      benefit3Desc: 'Participate in campaigns where partner brands donate part of local sales to your project.',
      benefit4Title: 'Territorial Reach',
      benefit4Desc: 'Increase your NGO visibility to those who live and work in your area of operation.',
      stepsTitle: 'Start making an impact',
      step1Title: 'Register your NGO',
      step1Desc: 'Create an official profile for your organization on the platform.',
      step2Title: 'Create campaigns',
      step2Desc: 'Promote your volunteering or fundraising needs.',
      step3Title: 'Engage the neighborhood',
      step3Desc: 'Receive direct support from the community and partner local businesses.',
      impactaEyebrow: 'INTEGRATED WITH BAIRROUIMPACTA!',
      impactaTitle: 'Turn support into real impact',
      impactaDesc: 'Your NGO connects directly to the BairrouImpacta! module, where residents complete social and environmental impact missions in the neighborhood. Every completed mission drives engagement and direct support for your cause.',
      impactaList1: 'Create volunteer and donation missions for the community',
      impactaList2: 'Residents earn BairrouPoints! by participating',
      impactaList3: 'Track the impact generated in real time',
      impactaMockAlt: 'BairrouImpacta! module showing social impact missions',
      ctaTitle: 'Ready to expand your impact?',
      ctaDesc: 'Join the Bairrou ecosystem and connect your cause to those who want to make a difference.',
      ctaButton: 'Get in touch'
    },
    paraInvestidor: {
      heroEyebrow: 'FOR INVESTORS',
      heroTitle1: 'The digital infrastructure',
      heroTitle2: 'of neighborhoods and cities.',
      heroDesc: 'Bairrou is a scalable territorial platform that connects citizens, local businesses, governments, and large brands, creating an ecosystem with strong network effects and multiple revenue streams.',
      marketTitle: 'One platform, two complementary markets',
      marketB2cTitle: 'B2C / B2B',
      marketB2cList: ['Citizens', 'Small businesses', 'Service providers', 'Brands'],
      marketB2gTitle: 'B2G',
      marketB2gList: ['Municipalities', 'Subprefectures', 'Government agencies', 'State governments', 'Development organizations'],
      whyNowTitle: 'Why now?',
      whyNowDesc: 'The digitization of local commerce and the need of governments for citizen engagement tools create a unique opportunity for a unified territorial infrastructure.',
      thesisTitle: 'Our investment thesis',
      thesis1Title: 'Local Network Effects',
      thesis1Desc: 'Every new user, business, or public agency attracts more participants to the local ecosystem, creating natural barriers to entry.',
      thesis2Title: 'Recurring and Diversified Revenue',
      thesis2Desc: 'Monetization through SaaS subscriptions for businesses, GovTech licensing for municipalities, and sponsored campaigns for brands.',
      thesis3Title: 'Territorial Scalability',
      thesis3Desc: 'Neighborhood-by-neighborhood, city-by-city expansion model, with low marginal cost of technological infrastructure replication.',
      ecosystemTitle: 'Bairrou Ecosystem',
      ecosystemDesc: 'A modular architecture that serves different needs of the territory.',
      tractionTitle: 'Alignment with Global Impact',
      tractionDesc: 'Our business model is natively aligned with the UN Sustainable Development Goals (SDGs), combining financial returns with measurable social and economic impact.',
      ctaTitle: 'Be part of this transformation',
      ctaDesc: 'We are building the digital infrastructure that will redefine the local economy and engagement.',
      ctaButton: 'Talk to Investor Relations'
    }
  }
};
type DeepPartial<T> = T extends object ? { [P in keyof T]?: DeepPartial<T[P]> } : T;
const localeOverrides: Partial<Record<Language, DeepPartial<Translations>>> = {
  es: {
    nav: {
      inicio: 'Inicio',
      paraVoce: 'Para ti',
      paraNegocio: 'Para tu negocio',
      paraMarca: 'Para tu marca',
      ods: 'ODS',
      educa: 'BairrouEduca!',
      gov: 'BairrouGov',
      clube: 'BairrouClube!',
      tropa: 'Tropa do Bairrou!',
      solucoes: 'Soluciones',
      ecossistema: 'Ecosistema',
      precos: 'Precios',
      contato: 'Contacto',
      paraOng: 'Para ONGs',
      paraInvestidor: 'Para Inversores'
    },
    footer: {
      blurb: '¡Lo mejor está aquí! Conectándote con los negocios, oportunidades y personas de tu barrio.',
      plataforma: 'Plataforma',
      contato: 'Contacto',
      faleConosco: 'Contáctanos',
      direitos: '© 2026 BairrouApp. Todos los derechos reservados.',
      termos: 'Términos de uso',
      privacidade: 'Privacidad'
    },
    common: {
      disponivelEmBreve: 'Próximamente',
      saibaMais: 'Saber más',
      faleComAGente: 'Habla con nosotros',
      falarComNossoTime: 'Habla con nuestro equipo',
      trustedBy: 'Empresas que confían en nosotros',
      tagline: '¡Lo mejor está aquí!',
      darkModeOn: 'Activar modo oscuro',
      darkModeOff: 'Activar modo claro'
    },
    home: {
      heroEyebrow: 'LA APP DE TU BARRIO',
      heroTitle1: 'Tu barrio,',
      heroTitle2: 'en una sola app.',
      heroDesc: 'BairrouApp! es la infraestructura digital de los barrios: descubre negocios locales, gana puntos, ahorra y fortalece tu comunidad — todo en una sola app.',
      comoFunciona: '¿Cómo funciona?',
      comoFuncionaDesc: 'Todo lo que necesitas para vivir mejor tu barrio, en la palma de tu mano.',
      step1Title: '1. Explora',
      step1Desc: 'Encuentra los mejores comercios, servicios y ofertas cerca de ti.',
      step2Title: '2. Compra y Gana',
      step2Desc: 'Acumula puntos en cada compra y canjéalos por descuentos exclusivos.',
      step3Title: '3. Fortalece',
      step3Desc: 'Apoya la economía local y participa en iniciativas de impacto en el barrio.',
      pilaresTitle: 'Una app, muchas posibilidades',
      pilar1Title: 'Ofertas Locales',
      pilar1Desc: 'Cupones y promociones de tus vecinos.',
      pilar2Title: 'Educación',
      pilar2Desc: 'Cursos y capacitación para la comunidad.',
      pilar3Title: 'Marketplace',
      pilar3Desc: 'Compra, vende o intercambia artículos usados.',
      pilar4Title: 'Impacto',
      pilar4Desc: 'Apoya causas sociales en tu barrio.',
      audiencesTitle: 'Hecho para todos',
      audiencesDesc: 'Ya seas un residente, un pequeño empresario o una gran marca.',
      aud1Title: 'Para ti',
      aud1Desc: 'Ahorra dinero, gana puntos y descubre lo mejor de tu barrio.',
      aud2Title: 'Para tu negocio',
      aud2Desc: 'Atrae más clientes locales y fideliza tu barrio.',
      aud3Title: 'Para marcas',
      aud3Desc: 'Conéctate con las comunidades de forma auténtica e hiperlocal.',
      ctaTitle: '¿Listo para explorar?',
      ctaDesc: 'Únete a miles de vecinos que ya están transformando sus barrios.',
      featuresEyebrow: 'TODO EN UN SOLO LUGAR',
      audiencesEyebrow: 'PARA QUIÉN ES',
      mockAlt2: 'Pantalla de ofertas locales en BairrouApp'
    },
    paraVoce: {
      heroEyebrow: 'PARA RESIDENTES',
      heroTitle1: 'Lo mejor de tu barrio,',
      heroTitle2: 'para ti.',
      heroDesc: 'Descuentos exclusivos, acumulación de puntos y la facilidad de encontrar todo lo que necesitas a pocos pasos de casa.',
      ben1Title: 'Descuentos y Cupones',
      ben1Desc: 'Disfruta de ofertas exclusivas en los comercios locales que ya amas.',
      ben2Title: 'Puntos y Recompensas',
      ben2Desc: 'Cada compra genera puntos en tu billetera digital para canjear por premios.',
      ben3Title: 'Descubre Negocios',
      ben3Desc: 'Encuentra panaderías, mecánicos, salones y mucho más, muy cerca.',
      ben4Title: 'Cursos en Educa',
      ben4Desc: 'Accede a capacitación y cursos rápidos para tu desarrollo.',
      ben5Title: 'Compra y Vende',
      ben5Desc: 'Usa el Marketplace para darle nueva vida a los artículos que ya no usas.',
      ben6Title: 'Pagos Fáciles',
      ben6Desc: 'Paga tus compras directamente a través de la app de forma segura.',
      walletTitle: 'Tu billetera de beneficios',
      walletDesc: 'Haz un seguimiento de tus puntos, canjea cupones y ve tu historial de ahorros en tiempo real. Todo organizado en un solo lugar para que disfrutes de lo mejor de tu barrio.',
      walletList1: 'Saldo actualizado al instante',
      walletList2: 'Catálogo de recompensas locales',
      walletList3: 'Historial transparente de ganancias y uso',
      howToTitle: '¿Cómo ganar puntos?',
      howToDesc: 'Es simple, rápido y divertido.',
      step1Title: 'Compra localmente',
      step1Desc: 'Haz compras en establecimientos asociados usando la app.',
      step2Title: 'Completa misiones',
      step2Desc: 'Participa en desafíos locales, como reseñar una tienda o reciclar artículos.',
      step3Title: 'Refiere amigos',
      step3Desc: 'Trae a tus vecinos a BairrouApp y gana puntos extra.',
      step4Title: 'Canjea por premios',
      step4Desc: 'Usa tus puntos para canjear productos, servicios o descuentos.',
      testimonialQuote: '"Desde que empecé a usar BairrouApp, descubrí lugares increíbles en mi calle que ni siquiera sabía que existían. ¡Y los puntos que acumulo ya han pagado mi desayuno varias veces!"',
      testimonialAuthor: '— Mariana S., residente local',
      benefitsEyebrow: 'BENEFICIOS',
      benefitsTitle: 'Todo lo que necesitas',
      howToEyebrow: 'PASO A PASO',
      mockAlt2: 'Pantalla de misiones y recompensas en BairrouApp'
    },
    paraNegocio: {
      heroEyebrow: 'PARA EMPRENDEDORES',
      heroTitle1: 'Haz crecer tu negocio',
      heroTitle2: 'en el barrio.',
      heroDesc: 'Conéctate con clientes que viven cerca de ti. Aumenta tus ventas, crea programas de lealtad y gana visibilidad local.',
      dashTitle: 'Panel del Comerciante',
      dashDesc: 'Resumen de hoy',
      dashStat1: 'Visitas a la página',
      dashStat2: 'Cupones canjeados',
      dashStat3: 'Nuevos clientes',
      whyTitle: '¿Por qué BairrouApp?',
      why1Title: 'Atrae al Barrio',
      why1Desc: 'Sé encontrado por personas que viven o trabajan cerca de tu establecimiento.',
      why2Title: 'Crea Ofertas',
      why2Desc: 'Publica promociones y cupones para atraer tráfico en los días más tranquilos.',
      why3Title: 'Fideliza',
      why3Desc: 'Ofrece puntos en las compras para asegurar que tus clientes siempre regresen.',
      why4Title: 'Recibe Pagos',
      why4Desc: 'Acepta pagos a través de la app con tasas competitivas y recepción rápida.',
      why5Title: 'Visibilidad Local',
      why5Desc: 'Destaca en el mapa del barrio y en las búsquedas por categoría.',
      why6Title: 'Escaparate Digital',
      why6Desc: 'Muestra tus productos, horarios y fotos en una página exclusiva.',
      presenceTitle: 'Tu presencia digital accesible',
      presenceDesc: 'Obtén una página para tu negocio dentro de la app y democratiza la lealtad: herramientas que antes estaban reservadas para grandes cadenas, ahora al alcance del comercio de barrio. Muestra tus servicios y horarios, ofrece cupones y una tarjeta de lealtad digital a tu barrio.',
      presenceList1: 'Listado de tu establecimiento o servicio',
      presenceList2: 'Horarios de apertura actualizados',
      presenceList3: 'Ofertas y tarjeta de lealtad digital',
      presenceList4: 'Check-in con Código QR',
      stepsTitle: 'Comienza en 3 pasos',
      step1Title: 'Regístrate',
      step1Desc: 'Crea tu cuenta de comerciante en menos de 5 minutos.',
      step2Title: 'Configura',
      step2Desc: 'Agrega fotos, horarios y tu primera oferta.',
      step3Title: 'Vende más',
      step3Desc: 'Comienza a recibir clientes de tu barrio.',
      pricingTitle: 'Planes que se ajustan a tu presupuesto',
      pricingDesc: 'Comienza gratis y paga solo una pequeña tarifa sobre las ventas realizadas a través de la app. Sin cuotas mensuales sorpresa.',
      planTitle: 'Plan Básico',
      planList1: 'Listado de tu establecimiento o servicio',
      planList2: 'Programa de puntos básico',
      planPrice: 'Gratis',
      planSub: 'para empezar',
      whyEyebrow: 'POR QUÉ ELEGIRNOS',
      presenceEyebrow: 'ESCAPARATE DIGITAL',
      stepsEyebrow: 'CÓMO EMPEZAR',
      pricingEyebrow: 'PRECIOS',
      democEyebrow: 'A TU ALCANCE',
      democTitle: 'Inteligencia de negocios y lealtad que antes solo tenían las grandes cadenas',
      democDesc: 'No necesitas construir ni mantener tu propia app. BairrouApp! democratiza el acceso a herramientas que eran caras y exclusivas de las grandes cadenas — ahora simples y asequibles para el comercio de barrio.',
      democCard1Title: 'Un programa de lealtad sin tu propia app',
      democCard1Desc: 'Ofrece puntos, cupones y una tarjeta de lealtad digital a tus clientes sin invertir en la construcción y mantenimiento de una app. ¡Todo sucede dentro de BairrouApp!.',
      democCard2Title: 'Inteligencia de negocios accesible',
      democCard2Desc: 'Entiende a tus clientes con datos sobre visitas repetidas, las ofertas que mejor convierten y el rendimiento de tu tienda — información antes reservada para aquellos con grandes presupuestos y equipos de datos.',
      democCard3Title: 'Verdaderamente accesible',
      democCard3Desc: 'Comienza gratis, sin cuotas mensuales sorpresa y sin barreras técnicas. Digitalizarte y construir lealtad se ajusta a tu presupuesto y a tu rutina.',
      democHighlight: 'Tecnología de grandes cadenas, al alcance de tu barrio.'
    },
    gov: {
      heroEyebrow: 'BAIRROUGOV · GOVTECH',
      heroTitle1: 'Infraestructura digital para el compromiso territorial,',
      heroTitle2: 'desarrollo local y participación ciudadana.',
      heroDesc: 'BairrouGov ayuda a municipios, subprefecturas, agencias públicas y organizaciones de desarrollo a fortalecer el compromiso ciudadano, las economías locales, la comunicación territorial y el impacto comunitario a través de una única infraestructura digital.',
      ctaPrimary: 'Programar una demostración',
      ctaSecondary: 'Hablar con nuestro equipo',
      whatTitle: 'Una plataforma GovTech construida para barrios, comunidades y ciudades.',
      whatDesc1: 'BairrouGov es la capa GovTech del ecosistema Bairrou, diseñada para ayudar a las instituciones públicas a conectar ciudadanos, negocios locales, proveedores de servicios, organizaciones comunitarias e iniciativas gubernamentales.',
      whatDesc2: 'Utilizando geolocalización, inteligencia territorial y herramientas de compromiso, los gobiernos pueden crear comunidades más fuertes, mejorar la comunicación pública y apoyar el desarrollo económico local.',
      modulesTitle: 'Módulos principales',
      moduleTitles: ['Comunicación Territorial', 'Participación Ciudadana', 'Desarrollo Económico Local', 'BairrouImpacto Gov', 'BairrouEduca Gov', 'Inteligencia Territorial'],
      moduleDescs: ['Comunicación segmentada por barrio, distrito o región.', 'Habilita la escucha, consulta y compromiso.', 'Apoya a pequeñas empresas y emprendedores locales.', 'Moviliza a las comunidades en torno a iniciativas sociales y ambientales.', 'Promueve la educación, el emprendimiento y el desarrollo de la fuerza laboral.', 'Transforma los datos territoriales en mejores decisiones.'],
      moduleFeatures: [['Campañas públicas', 'Eventos e iniciativas', 'Notificaciones localizadas', 'Anuncios comunitarios'], ['Encuestas', 'Consultas públicas', 'Comentarios de la comunidad', 'Programas de compromiso ciudadano'], ['Mapeo de negocios', 'Directorios de comercio local', 'Iniciativas de desarrollo económico', 'Programas de apoyo a emprendedores'], ['Campañas de sostenibilidad', 'Compromiso comunitario', 'Programas de concientización sobre la salud', 'Iniciativas culturales'], ['Capacitación en emprendimiento', 'Calificación profesional', 'Educación financiera', 'Inclusión digital'], ['Paneles de control', 'Indicadores de barrio', 'Métricas de compromiso comunitario', 'Perspectivas de actividad económica']],
      useCasesTitle: 'Cómo los gobiernos pueden usar BairrouGov',
      useCases: ['Programas de compromiso de barrio', 'Iniciativas de desarrollo económico', 'Eventos comunitarios', 'Consultas públicas', 'Campañas de sostenibilidad', 'Programas de emprendimiento local', 'Iniciativas de desarrollo de la fuerza laboral', 'Presupuesto participativo'],
      impactTitle: 'De la comunicación a la transformación.',
      impactGovTitle: 'Para Gobiernos',
      impactGov: ['Mejor comunicación ciudadana', 'Más participación', 'Toma de decisiones basada en datos', 'Economías locales más fuertes'],
      impactCitizensTitle: 'Para Ciudadanos',
      impactCitizens: ['Acceso más fácil a la información', 'Más oportunidades', 'Mayor participación comunitaria', 'Identidad de barrio más fuerte'],
      impactTerritoriesTitle: 'Para Territorios',
      impactTerritories: ['Desarrollo económico', 'Impacto social', 'Resiliencia comunitaria', 'Crecimiento urbano sostenible'],
      dashboardTitle: 'Panel de Inteligencia Territorial',
      dashboardDesc: 'Convierte los datos territoriales en mejores decisiones con paneles y mapas en tiempo real.',
      dashboardMetrics: ['Barrios activos', 'Compromiso comunitario', 'Densidad de negocios locales', 'Participación en eventos', 'Indicadores de actividad económica', 'Tasas de participación ciudadana'],
      sdgTitle: 'Alineado con los objetivos de impacto global.',
      sdgs: ['ODS 8 — Trabajo Decente y Crecimiento Económico', 'ODS 10 — Reducción de las Desigualdades', 'ODS 11 — Ciudades y Comunidades Sostenibles', 'ODS 12 — Producción y Consumo Responsables', 'ODS 17 — Alianzas para lograr los Objetivos'],
      ecosystemTitle: 'Arquitectura del Ecosistema',
      ecosystemDesc: 'Mira cómo interactúan el gobierno, los ciudadanos, las empresas, las ONG y las marcas a través del ecosistema.',
      ecosystemCenter: 'Plataforma Bairrou',
      ecosystemModules: ['BairrouGov', 'BairrouApp', 'BairrouImpacto', 'BairrouEduca', 'BairrouClube', 'Inteligencia Territorial'],
      investorsTitle: 'Una plataforma que sirve a mercados públicos y privados.',
      investorsDesc: 'Bairrou opera en dos mercados complementarios:',
      marketB2cTitle: 'B2C / B2B',
      marketB2c: ['Ciudadanos', 'Pequeñas empresas', 'Proveedores de servicios', 'Marcas'],
      marketB2gTitle: 'B2G',
      marketB2g: ['Municipios', 'Subprefecturas', 'Agencias gubernamentales', 'Gobiernos estatales', 'Organizaciones de desarrollo'],
      investorsNote: 'Esto crea un modelo de infraestructura territorial escalable con oportunidades de ingresos recurrentes y fuertes efectos de red.',
      ctaFinalTitle: 'Construye barrios más fuertes y ciudades más inteligentes.',
      ctaFinalDesc: 'Empodera a las comunidades, fortalece las economías locales y mejora el compromiso ciudadano a través de una única plataforma territorial.',
      dashboardPanel: 'Panel Territorial',
      dashboardLive: 'En vivo',
      nodeLabels: ['Ciudadanos', 'Negocios locales', 'Gobierno', 'Organizaciones']
    },
    clube: {
      heroEyebrow: 'BAIRROUCLUBE!',
      heroTitle1: 'Recompensas por apoyar',
      heroTitle2: 'el comercio local.',
      heroDesc1: 'BairrouClube! es el programa de lealtad del ecosistema Bairrou, creado para recompensar a quienes compran, participan y fortalecen la economía de su propio barrio.',
      heroDesc2: 'Al comprar en establecimientos asociados, usar servicios locales o participar en campañas y eventos comunitarios, acumulas beneficios y ventajas exclusivas.',
      pointsTitle: 'BairrouPoints!',
      pointsSubtitle: 'Tus puntos, tus recompensas',
      pointsDesc1: 'Con BairrouPoints!, tus interacciones generan recompensas que se pueden usar en diferentes socios de la red.',
      pointsDesc2: 'Cuanto más apoyes a los negocios locales, más beneficios desbloquearás.',
      pointsRedeemIntro: 'Podrás canjear tus puntos por:',
      pointsList: ['Descuentos en establecimientos asociados', 'Productos y servicios locales', 'Beneficios exclusivos', 'Experiencias y acciones promocionales', 'Campañas comunitarias especiales'],
      couponsTitle: 'Cupones y Ofertas Locales',
      couponsSubtitle: 'Ahorra mientras fortaleces tu barrio',
      couponsDesc1: 'Obtén acceso a cupones, promociones y ofertas exclusivas de negocios cerca de ti.',
      couponsDesc2: 'Descubre nuevas tiendas, servicios y oportunidades, ahorrando en la vida diaria mientras contribuyes al crecimiento de la economía local.',
      couponsIntro: 'Todo en un solo lugar:',
      couponsList: ['Cupones de descuento', 'Promociones de temporada', 'Campañas especiales', 'Beneficios exclusivos para miembros', 'Ofertas geolocalizadas'],
      cardLabels: ['Descuentos', 'Ofertas', 'Exclusivos', 'Cerca de ti'],
      pointsBenefit: '+ beneficios con cada compra local',
      localTitle: 'Cuanto más local, mejor',
      localDesc: '¡En BairrouApp!, cada compra, referencia o interacción ayuda a fortalecer los negocios en tu región, generando más oportunidades, ingresos y desarrollo para la comunidad.',
      localHighlight: 'Porque cuando el barrio crece, todos ganan.',
      tagline: 'Descubre. Ahorra. Gana. Disfruta.',
      ctaTitle: '¡Únete a BairrouClube!',
      ctaDesc: 'Convierte tus compras locales en beneficios reales.',
      ctaButton: 'Contáctanos'
    },
    tropa: {
      heroEyebrow: 'Tropa do Bairrou!',
      heroTitle: 'Conectando personas con oportunidades dentro de su propia comunidad.',
      heroDesc1: '¡Tropa do Bairrou! es la red colaborativa del ecosistema BairrouApp!, creada para conectar a los residentes con oportunidades de ingresos, participación e impacto dentro de los barrios donde viven.',
      heroDesc2: 'Nuestra propuesta es simple: acercar a las personas que necesitan ayuda, servicios o apoyo operativo con aquellas que desean generar ingresos, desarrollar experiencia profesional y contribuir al fortalecimiento de la comunidad local.',
      howItWorksTitle: 'Cómo funciona',
      howItWorksDesc1: 'A través de BairrouApp!, socios, negocios, organizaciones y residentes pueden publicar tareas, demandas y oportunidades que pueden ser ejecutadas por miembros de Tropa do Bairrou!.',
      howItWorksDesc2: 'Tras la finalización y validación de la actividad, los participantes reciben la recompensa correspondiente, que puede ser financiera, en beneficios o a través del ecosistema de recompensas de Bairrou.',
      opportunitiesTitle: 'Tipos de oportunidades',
      opportunitiesTitles: ['Entregas y apoyo operativo', 'Apoyo a eventos', 'Promoción local', 'Investigación y recopilación de datos', 'Validación de información', 'Servicios a pedido'],
      opportunitiesDescs: ['Asistencia con la recogida, transporte y entrega de productos para negocios locales y residentes.', 'Apoyo a acciones culturales, deportivas, comunitarias y eventos realizados en el territorio.', 'Distribución de materiales promocionales, promoción de campañas y movilización comunitaria.', 'Participación en encuestas, sondeos de opinión y mapeo de necesidades locales.', 'Confirmación de operaciones de establecimientos, actualización de registros y apoyo para la construcción de inteligencia territorial.', 'Pequeños servicios realizados por proveedores locales registrados en la plataforma.'],
      participantBenefitsTitle: 'Beneficios para quienes participan',
      participantBenefitsTitles: ['Genera ingresos locales', 'Flexibilidad', 'Desarrollo profesional', 'Reconocimiento comunitario', 'Beneficios exclusivos'],
      participantBenefitsDescs: ['Obtén acceso a oportunidades cerca de donde vives.', 'Elige las tareas y actividades que tengan sentido para tu rutina.', 'Construye experiencia, reputación y nuevas conexiones.', 'Participa activamente en el desarrollo de tu barrio.', 'Acumula recompensas y ventajas dentro del ecosistema Bairrou.'],
      businessBenefitsTitle: 'Beneficios para negocios y organizaciones',
      businessBenefitsTitles: ['Acceso rápido a apoyo local', 'Reducción de costos operativos', 'Mayor alcance territorial', 'Fortalecimiento de la comunidad'],
      businessBenefitsDescs: ['Encuentra personas cercanas para ejecutar demandas específicas.', 'Activa recursos de la propia comunidad cuando sea necesario.', 'Moviliza a los residentes para apoyar campañas, eventos e iniciativas.', 'Transforma actividades económicas en oportunidades locales.'],
      closingDesc1: 'Creemos que muchas oportunidades y talentos ya existen dentro de los barrios. El desafío es crear las conexiones correctas.',
      closingDesc2: '¡Tropa do Bairrou! nace para acercar a personas, negocios y organizaciones, fortaleciendo la economía local y creando nuevas formas de participación, generación de ingresos e impacto comunitario.',
      closingHighlight: 'Trabaja local. Genera impacto local. Crece junto con tu comunidad.',
      ctaTitle: '¡Únete a Tropa do Bairrou!',
      ctaDesc: 'Conéctate a oportunidades reales dentro de tu comunidad.',
      ctaButton: 'Contáctanos'
    },
    ods: {
      heroEyebrow: 'NUESTRO IMPACTO',
      heroTitle1: 'Nuestro compromiso con el',
      heroTitle2: 'futuro.',
      heroDesc: 'BairrouApp nació con el propósito de generar un impacto positivo. Nuestras acciones y características están alineadas con los Objetivos de Desarrollo Sostenible (ODS) de la ONU.',
      stat1Desc: 'Artículos reutilizados (Marketplace)',
      stat2Desc: 'Inyectado en la economía local',
      stat3Desc: 'Horas de cursos (Educación)',
      stat4Desc: 'Proyectos sociales apoyados',
      impactTitle: 'Impacto en la práctica',
      impactDesc: 'El módulo BairrouImpacta! transforma acciones sostenibles en recompensas. Los usuarios completan misiones como reciclar, apoyar el comercio local o participar en limpiezas, y ganan puntos por ello.',
      impactList1: 'Misiones semanales de sostenibilidad',
      impactList2: 'Cálculo de CO2 ahorrado',
      impactList3: 'Apoyo a proyectos sociales del barrio',
      impactList4: 'Gamificación por el bien común',
      odsTitle: 'Cómo contribuimos',
      ods1Title: 'Trabajo Decente y Crecimiento Económico',
      ods1Desc: 'Fortalecemos a los pequeños emprendedores locales ofreciendo herramientas de digitalización, ventas y lealtad para que sus negocios prosperen, generando empleo e ingresos en el barrio.',
      ods2Title: 'Ciudades y Comunidades Sostenibles',
      ods2Desc: 'Conectamos a los vecinos, reduciendo la necesidad de grandes desplazamientos para el consumo y promoviendo un sentido de pertenencia y cuidado por el espacio urbano local.',
      ods3Title: 'Producción y Consumo Responsables',
      ods3Desc: "A través del módulo 'Marketplace', fomentamos la economía circular, extendiendo la vida útil de los productos y reduciendo el desperdicio y el consumo desenfrenado.",
      ods4Title: 'Educación de Calidad',
      ods4Desc: "El módulo 'Educación' democratiza el acceso a la capacitación profesional y a cursos de desarrollo personal para residentes y comerciantes locales.",
      impactEyebrow: 'EN LA PRÁCTICA',
      odsEyebrow: 'OBJETIVOS DE LA ONU'
    },
    paraMarca: {
      heroEyebrow: 'PARA GRANDES MARCAS',
      heroTag: 'B2B & Alianzas',
      heroTitle1: 'Conecta tu marca a las comunidades',
      heroTitle2: 'donde ocurre la confianza.',
      heroDesc: 'En un escenario donde los consumidores son cada vez más selectivos con la publicidad tradicional, las recomendaciones de personas cercanas, las experiencias reales y las conexiones comunitarias juegan un papel fundamental en la construcción de confianza y decisión de compra.',
      heroNielsen: 'Las recomendaciones de amigos, familiares y personas cercanas siguen siendo la forma de comunicación más confiable para los consumidores — y es exactamente ahí donde BairrouApp! posiciona tu marca: presente en los barrios de forma relevante, apoyando a pequeños negocios, activando comunidades y creando experiencias que generan valor para todos los involucrados.',
      activeTerritoriesTitle: 'Activa territorios, no solo audiencias',
      activeTerritoriesDesc: 'En lugar de hablar con los consumidores de forma genérica, tu marca puede conectarse directamente a los lugares donde las personas viven, trabajan, consumen y se relacionan. Transforma los barrios en puntos de contacto estratégicos a través de:',
      activeTerritoriesList1: 'Campañas geolocalizadas',
      activeTerritoriesList2: 'Distribución de muestras y regalos',
      activeTerritoriesList3: 'Cupones promocionales',
      activeTerritoriesList4: 'Experiencias patrocinadas',
      activeTerritoriesList5: 'Acciones de impacto social',
      activeTerritoriesList6: 'Iniciativas de compromiso comunitario',
      strengthenTitle: 'Fortalece pequeños negocios y distribuidores',
      strengthenDesc: 'BairrouApp! transforma a comerciantes, proveedores de servicios y distribuidores locales en socios de activación de tu marca. Esto permite:',
      strengthenList1: 'Ampliar capilaridad',
      strengthenList2: 'Generar experimentación de productos',
      strengthenList3: 'Fortalecer canales locales',
      strengthenList4: 'Crear relaciones a largo plazo',
      strengthenConclusion: 'Mientras la marca gana presencia territorial, los pequeños negocios ganan flujo, visibilidad y nuevas oportunidades de ingresos.',
      examplesTitle: 'Ejemplos de campañas',
      example1Title: 'Circuitos de Barrio',
      example1Desc: 'Crea jornadas patrocinadas involucrando a diversos socios locales. Ejemplos:',
      example1List1: 'Circuito del Café',
      example1List2: 'Circuito de la Belleza',
      example1List3: 'Circuito de la Familia',
      example1List4: 'Circuito de Verano',
      example2Title: 'Compra y Gana',
      example2Desc: 'Incentiva la experimentación a través de beneficios patrocinados.',
      example2Detail: 'Compra en socios participantes y recibe un producto, muestra o beneficio exclusivo de la marca.',
      example3Title: 'Descubrimiento Local',
      example3Desc: 'Estimula a los consumidores a conocer nuevos establecimientos y productos dentro de la comunidad.',
      example4Title: 'Impacto Social Patrocinado',
      example4Desc: 'Asocia tu marca a proyectos sociales, culturales o ambientales del territorio.',
      example4Detail: 'Con cada compra realizada, parte de la inversión de la campaña apoya una iniciativa local.',
      benefitsTitle: 'Lo que gana tu marca',
      benefit1Title: 'Presencia con relevancia',
      benefit1Desc: 'Estar presente en los momentos y territorios que forman parte de la rutina de las personas.',
      benefit2Title: 'Confianza comunitaria',
      benefit2Desc: 'Las recomendaciones personales y la confianza construida entre vecinos están entre los factores más influyentes en la decisión de compra, superando gran parte de la publicidad tradicional.',
      benefit3Title: 'Compromiso local auténtico',
      benefit3Desc: 'Crea conexiones a través de experiencias y beneficios reales.',
      benefit4Title: 'Datos territoriales e inteligencia local',
      benefit4Desc: 'Entiende qué comunidades, barrios y perfiles presentan mayor compromiso.',
      benefit5Title: 'Impacto medible',
      benefit5Desc: 'Sigue los resultados a través de:',
      benefit5List1: 'Participación',
      benefit5List2: 'Rescates',
      benefit5List3: 'Activaciones',
      benefit5List4: 'Alcance territorial',
      benefit5List5: 'Compromiso comunitario',
      mockAlt1: 'Pantalla de campaña de marca en BairrouApp',
      ctaTitle: 'Más que campañas. Conexiones.',
      ctaDesc: 'BairrouApp! ayuda a tu marca a construir presencia donde se crea la confianza: en las relaciones entre personas, negocios y comunidades.',
      ctaDesc2: 'Porque los barrios no son solo mercados. Son ecosistemas de relaciones, pertenencia e influencia.',
      ctaButton: 'Programar una presentación',
      ctaOr: 'O escribe directamente a',
      formats: ['Hiperlocal', 'Sampling', 'Cupones', 'Impacto']
    },
    educa: {
      heroEyebrow: 'BAIRROUEDUCA!',
      heroTitle1: 'Conocimiento para crecer,',
      heroTitle2: 'sin costo adicional.',
      heroDesc: 'Todos los usuarios de BairrouApp! tienen acceso gratuito a BairrouEduca!, la plataforma de capacitación creada para fortalecer personas, negocios y comunidades a través del conocimiento.',
      heroDesc2: 'Ten acceso a contenidos prácticos, cursos, rutas de aprendizaje y certificaciones ofrecidas por instituciones reconocidas, especialistas y profesionales del mercado, abordando temas como emprendimiento, ventas, marketing digital, finanzas, atención al cliente, tecnología, innovación y desarrollo profesional.',
      missionTitle: 'Democratizar el acceso a la capacitación',
      missionDesc: 'Nuestro objetivo es democratizar el acceso a capacitación de calidad, ayudando a pequeños emprendedores, proveedores de servicios y residentes a desarrollar nuevas competencias, aumentar sus ingresos y fortalecer la economía local.',
      findTitle: 'Lo que encuentras en BairrouEduca!',
      find1: 'Cursos y contenidos gratuitos',
      find2: 'Certificaciones de socios estratégicos',
      find3: 'Rutas de aprendizaje para emprendedores',
      find4: 'Contenidos sobre gestión, ventas y marketing',
      find5: 'Capacitación profesional y desarrollo de carrera',
      find6: 'Buenas prácticas para negocios locales',
      find7: 'Contenido producido por especialistas e instituciones de referencia',
      partnersTitle: 'Socios de conocimiento',
      partnersDesc: 'BairrouEduca! busca reunir contenidos y oportunidades de instituciones reconocidas de apoyo al emprendimiento local, además de especialistas, empresas y profesionales que comparten conocimiento para impulsar el desarrollo económico y social de los territorios.',
      partnersClosing: 'Porque fortalecer la economía local también significa invertir en el crecimiento de las personas que forman parte de ella.',
      partnerChips: ['Instituciones de apoyo al emprendimiento local', 'Especialistas', 'Instituciones', 'Profesionales'],
      freeBadge: '100% gratis para todos los usuarios',
      ctaTitle: '¿Listo para aprender y crecer?',
      ctaDesc: 'Forma parte de BairrouApp! y ten BairrouEduca! en la palma de tu mano, sin costo adicional.',
      ctaButton: 'Habla con nosotros'
    },
    contato: {
      heroEyebrow: 'CONTÁCTANOS',
      heroTitle: 'Habla con nosotros',
      heroDesc: '¿Dudas, sugerencias o alianzas? Estamos aquí para escucharte.',
      infoTitle: 'Información de Contacto',
      infoEmail: 'Correo electrónico',
      infoPhone: 'Teléfono / WhatsApp',
      infoOffice: 'Oficina',
      infoAddress1: 'Calle del Barrio, 123 - Oficina 45',
      infoAddress2: 'São Paulo, SP - 01234-567',
      successTitle: '¡Mensaje enviado!',
      successDesc: 'Gracias por contactarnos. Nuestro equipo responderá lo antes posible.',
      successButton: 'Enviar nuevo mensaje',
      formName: 'Nombre completo',
      formNamePlaceholder: 'Tu nombre',
      formEmail: 'Correo electrónico',
      formEmailPlaceholder: 'tu@email.com',
      formSubject: 'Asunto',
      formSubjectPlaceholder: 'Selecciona un asunto...',
      formSub1: 'Soy usuario (Duda/Soporte)',
      formSub2: 'Tengo un negocio local',
      formSub3: 'Represento una marca (Alianzas)',
      formSub4: 'Prensa',
      formSub5: 'Otro',
      formSub6: 'Soy inversor',
      formSub7: 'Represento una ONG',
      formMessage: 'Mensaje',
      formMessagePlaceholder: '¿Cómo podemos ayudar?',
      formSubmit: 'Enviar mensaje',
      formSubmitting: 'Enviando...',
      errorTitle: 'Ups, algo salió mal',
      errorDesc: 'No pudimos enviar tu mensaje en este momento. Inténtalo de nuevo en unos instantes o escribe a jon@bairrou.online.',
      errorButton: 'Intentar de nuevo'
    },
    precos: {
      heroEyebrow: 'PLANES PARA SOCIOS',
      heroTitle1: 'Impulsa tu negocio donde más importa:',
      heroTitle2: 'en tu barrio.',
      heroDesc: 'Elige el plan ideal para conectarte con los residentes, fidelizar clientes locales y capacitar a tu equipo.',
      monthly: 'Mensual',
      annual: 'Anual',
      annualDiscount: 'Ahorra 20%',
      plan1Name: 'Básico',
      plan1Desc: 'Ideal para autónomos, profesionales independientes y proveedores de servicios locales que comienzan a marcar presencia digital.',
      plan1PriceM: 'R$ 49,90',
      plan1PriceA: 'R$ 39,90',
      plan1Cta: 'Comenzar Ahora',
      plan1Advantage: 'Salir de la invisibilidad digital y ser encontrado inmediatamente por quienes viven a pocas cuadras de ti por menos de R$ 1,70 al día.',
      plan2Name: 'Profesional',
      plan2Badge: 'MÁS VENDIDO',
      plan2Desc: 'Ideal para pequeños comercios, tiendas físicas, cafeterías y mercados que quieren crear una base de clientes recurrentes y comprometidos.',
      plan2PriceM: 'R$ 99,90',
      plan2PriceA: 'R$ 79,90',
      plan2Cta: 'Probar Versión Profesional',
      plan2Advantage: 'Construye una barrera competitiva local a través de fidelización real e inteligencia operativa propia.',
      plan3Name: 'Premium',
      plan3Desc: 'Ideal para negocios estratégicos, franquicias locales y establecimientos consolidados que buscan dominio territorial y campañas agresivas.',
      plan3PriceM: 'R$ 199,90',
      plan3PriceA: 'R$ 159,90',
      plan3Cta: 'Hablar con un Especialista',
      plan3Advantage: 'Activación en tiempo real e inteligencia de datos de geofencing para garantizar el liderazgo de mercado en tu zona de actuación.',
      feature1: 'Perfil con fotos y contactos',
      feature2: 'Geolocalización en el Mapa',
      feature3: 'Botón directo para WhatsApp',
      feature4: 'Sistema de Reseñas',
      feature5: 'Programa de Lealtad (BairrouClube)',
      feature6: 'Aceptar y Gestionar BairrouPoints!',
      feature7: 'Plataforma de Enseñanza BairrouEduca!',
      feature8: 'Informes de Rendimiento',
      feature9: 'Notificaciones Push Locales',
      feature10: 'Posición Destacada en la App',
      matrixTitle: 'Compara los planes en detalle',
      matrixNote: 'Sin tarifas ocultas sobre tus ventas por WhatsApp. Impuestos y tarifas de procesamiento de tarjetas integradas en los planes recurrentes.',
      faqTitle: 'Preguntas Frecuentes',
      faq1Q: '¿Puedo cambiar de plan cuando quiera?',
      faq1A: 'Sí, el upgrade o downgrade se puede hacer en cualquier momento en tu panel de control, sin multas o tarifas adicionales.',
      faq2Q: '¿Cómo funcionan los BairrouPoints! en mi caja?',
      faq2A: 'Es una herramienta de compromiso integrada a la plataforma. Tú defines las reglas y los clientes acumulan y rescatan puntos sociales directamente en tu establecimiento, generando recurrencia.',
      faq3Q: '¿Necesito CNPJ para suscribirme?',
      faq3A: 'No, los proveedores autónomos y profesionales independientes pueden suscribirse al Plan Básico utilizando solo el CPF.',
      testimonialQuote: '"Después de activar el plan Profesional, el movimiento en la panadería aumentó un 30% en los días de semana gracias al programa de fidelidad. ¡A los vecinos les encanta acumular puntos!"',
      testimonialAuthor: '— Carlos M., dueño de panadería local'
    },
    paraOng: {
      heroEyebrow: 'PARA ONGS Y PROYECTOS SOCIALES',
      heroTitle1: 'Moviliza tu comunidad',
      heroTitle2: 'y expande tu impacto.',
      heroDesc: 'BairrouApp! conecta tu organización con residentes y negocios locales, facilitando la recaudación de donaciones, el reclutamiento de voluntarios y la visibilidad de tus causas.',
      whatTitle: 'Cómo BairrouApp! ayuda a tu ONG',
      whatDesc: 'Nuestra plataforma ofrece herramientas para que las organizaciones sociales involucren a la comunidad de manera directa y transparente, transformando el apoyo local en un impacto real.',
      benefitsTitle: 'Ventajas para tu organización',
      benefit1Title: 'Movilización Comunitaria',
      benefit1Desc: 'Conéctate con residentes comprometidos y dispuestos a apoyar causas en su propio barrio.',
      benefit2Title: 'Misiones BairrouImpacta!',
      benefit2Desc: 'Crea misiones donde los usuarios ganan puntos al participar en acciones voluntarias o donaciones.',
      benefit3Title: 'Campañas Patrocinadas',
      benefit3Desc: 'Participa en campañas donde marcas asociadas donan parte de las ventas locales a tu proyecto.',
      benefit4Title: 'Alcance Territorial',
      benefit4Desc: 'Aumenta la visibilidad de tu ONG para quienes viven y trabajan en tu área de operación.',
      stepsTitle: 'Comienza a impactar',
      step1Title: 'Registra tu ONG',
      step1Desc: 'Crea un perfil oficial para tu organización en la plataforma.',
      step2Title: 'Crea campañas',
      step2Desc: 'Promueve tus necesidades de voluntariado o recaudación de fondos.',
      step3Title: 'Involucra al barrio',
      step3Desc: 'Recibe apoyo directo de la comunidad y de negocios locales asociados.',
      impactaEyebrow: 'INTEGRADO CON BAIRROUIMPACTA!',
      impactaTitle: 'Transforma el apoyo en impacto real',
      impactaDesc: 'Tu ONG se conecta directamente con el módulo BairrouImpacta!, donde los residentes completan misiones de impacto social y ambiental en el barrio. Cada misión completada genera compromiso y apoyo directo para tu causa.',
      impactaList1: 'Crea misiones de voluntariado y donación para la comunidad',
      impactaList2: 'Los residentes ganan BairrouPoints! al participar',
      impactaList3: 'Sigue el impacto generado en tiempo real',
      impactaMockAlt: 'Módulo BairrouImpacta! mostrando misiones de impacto social',
      ctaTitle: '¿Listo para expandir tu impacto?',
      ctaDesc: 'Únete al ecosistema Bairrou y conecta tu causa con quienes quieren marcar la diferencia.',
      ctaButton: 'Contáctanos'
    },
    paraInvestidor: {
      heroEyebrow: 'PARA INVERSORES',
      heroTitle1: 'La infraestructura digital',
      heroTitle2: 'de barrios y ciudades.',
      heroDesc: 'Bairrou es una plataforma territorial escalable que conecta a ciudadanos, negocios locales, gobiernos y grandes marcas, creando un ecosistema con fuertes efectos de red y múltiples fuentes de ingresos.',
      marketTitle: 'Una plataforma, dos mercados complementarios',
      marketB2cTitle: 'B2C / B2B',
      marketB2cList: ['Ciudadanos', 'Pequeños negocios', 'Proveedores de servicios', 'Marcas'],
      marketB2gTitle: 'B2G',
      marketB2gList: ['Municipios', 'Subprefecturas', 'Agencias gubernamentales', 'Gobiernos estatales', 'Organizaciones de desarrollo'],
      whyNowTitle: '¿Por qué ahora?',
      whyNowDesc: 'La digitalización del comercio local y la necesidad de los gobiernos de herramientas de participación ciudadana crean una oportunidad única para una infraestructura territorial unificada.',
      thesisTitle: 'Nuestra tesis de inversión',
      thesis1Title: 'Efectos de Red Locales',
      thesis1Desc: 'Cada nuevo usuario, negocio o agencia pública atrae a más participantes al ecosistema local, creando barreras naturales de entrada.',
      thesis2Title: 'Ingresos Recurrentes y Diversificados',
      thesis2Desc: 'Monetización a través de suscripciones SaaS para negocios, licencias GovTech para municipios y campañas patrocinadas para marcas.',
      thesis3Title: 'Escalabilidad Territorial',
      thesis3Desc: 'Modelo de expansión barrio por barrio, ciudad por ciudad, con bajo costo marginal de replicación de infraestructura tecnológica.',
      ecosystemTitle: 'Ecosistema Bairrou',
      ecosystemDesc: 'Una arquitectura modular que atiende diferentes necesidades del territorio.',
      tractionTitle: 'Alineación con el Impacto Global',
      tractionDesc: 'Nuestro modelo de negocio está alineado de forma nativa con los Objetivos de Desarrollo Sostenible (ODS) de la ONU, combinando retornos financieros con un impacto social y económico medible.',
      ctaTitle: 'Sé parte de esta transformación',
      ctaDesc: 'Estamos construyendo la infraestructura digital que redefinirá la economía y la participación local.',
      ctaButton: 'Hablar con Relaciones con Inversores'
    }
  },
  ja: {
    nav: {
      inicio: 'ホーム',
      paraVoce: 'あなたへ',
      paraNegocio: 'ビジネス向け',
      paraMarca: 'ブランド向け',
      ods: 'SDGs',
      educa: 'BairrouEduca!',
      gov: 'BairrouGov',
      clube: 'BairrouClube!',
      tropa: 'Tropa do Bairrou!',
      solucoes: 'ソリューション',
      ecossistema: 'エコシステム',
      precos: '料金',
      contato: 'お問い合わせ',
      paraOng: 'NGO向け',
      paraInvestidor: '投資家向け'
    },
    footer: {
      blurb: '最高のものはここにあります！あなたの街のビジネス、機会、人々とあなたをつなぎます。',
      plataforma: 'プラットフォーム',
      contato: 'お問い合わせ',
      faleConosco: 'お問い合わせ',
      direitos: '© 2026 BairrouApp. 全著作権所有。',
      termos: '利用規約',
      privacidade: 'プライバシーポリシー'
    },
    common: {
      disponivelEmBreve: '近日公開',
      saibaMais: '詳細を見る',
      faleComAGente: 'お問い合わせ',
      falarComNossoTime: 'チームと話す',
      trustedBy: '信頼される企業',
      tagline: '最高のものはここにあります！',
      darkModeOn: 'ダークモードをオンにする',
      darkModeOff: 'ライトモードをオンにする'
    },
    home: {
      heroEyebrow: 'あなたの街のアプリ',
      heroTitle1: 'あなたの街を、',
      heroTitle2: 'ひとつのアプリで。',
      heroDesc: 'BairrouApp!は街のデジタルインフラです。地元のお店を発見し、ポイントを稼ぎ、お金を節約し、コミュニティを強化します。すべてひとつのアプリで。',
      comoFunciona: '仕組み',
      comoFuncionaDesc: '街をより良く体験するために必要なすべてが、あなたの手のひらに。',
      step1Title: '1. 探索する',
      step1Desc: '近くの最高のお店、サービス、お得な情報を見つけましょう。',
      step2Title: '2. 買い物して稼ぐ',
      step2Desc: 'すべての買い物でポイントを獲得し、限定割引と交換しましょう。',
      step3Title: '3. 強化する',
      step3Desc: '地域経済を支援し、街のインパクトイニシアチブに参加しましょう。',
      pilaresTitle: 'ひとつのアプリ、多くの可能性',
      pilar1Title: '地元のお得な情報',
      pilar1Desc: 'ご近所さんからのクーポンやプロモーション。',
      pilar2Title: '教育',
      pilar2Desc: 'コミュニティ向けのコースとトレーニング。',
      pilar3Title: 'マーケットプレイス',
      pilar3Desc: '中古品の売買や交換。',
      pilar4Title: 'インパクト',
      pilar4Desc: '街の社会貢献活動を支援。',
      audiencesTitle: 'すべての人のために',
      audiencesDesc: 'あなたが住民であれ、小規模ビジネスのオーナーであれ、大手ブランドであれ。',
      aud1Title: 'あなたへ',
      aud1Desc: 'お金を節約し、ポイントを稼ぎ、街の最高なものを発見しましょう。',
      aud2Title: 'ビジネス向け',
      aud2Desc: 'より多くの地元の顧客を引き付け、街でロイヤリティを構築しましょう。',
      aud3Title: 'ブランド向け',
      aud3Desc: 'コミュニティと本物かつ超ローカルにつながりましょう。',
      ctaTitle: '探索する準備はできましたか？',
      ctaDesc: 'すでに街を変革している何千人ものご近所さんに加わりましょう。',
      featuresEyebrow: 'すべてをひとつの場所に',
      audiencesEyebrow: '対象者',
      mockAlt2: 'BairrouAppの地元のお得な情報画面'
    },
    paraVoce: {
      heroEyebrow: '住民向け',
      heroTitle1: 'あなたの街の最高のものを、',
      heroTitle2: 'あなたへ。',
      heroDesc: '限定割引、ポイントの蓄積、そして家から数歩の場所で必要なものをすべて見つける便利さ。',
      ben1Title: '割引とクーポン',
      ben1Desc: 'すでに愛用している地元のお店で限定オファーをお楽しみください。',
      ben2Title: 'ポイントと報酬',
      ben2Desc: 'すべての買い物がデジタルウォレットにポイントを生み出し、賞品と交換できます。',
      ben3Title: 'ビジネスを発見する',
      ben3Desc: 'パン屋、整備士、サロンなど、すぐ近くで見つけましょう。',
      ben4Title: 'Educaのコース',
      ben4Desc: 'あなたの成長のためのトレーニングや短期コースにアクセスしましょう。',
      ben5Title: '売買',
      ben5Desc: 'マーケットプレイスを使用して、使わなくなったアイテムに新しい命を吹き込みましょう。',
      ben6Title: '簡単な支払い',
      ben6Desc: 'アプリを通じて安全に買い物の支払いを直接行いましょう。',
      walletTitle: 'あなたの特典ウォレット',
      walletDesc: 'ポイントを追跡し、クーポンを交換し、節約履歴をリアルタイムで確認します。街の最高のものを楽しむために、すべてがひとつの場所に整理されています。',
      walletList1: '即座に更新される残高',
      walletList2: '地元の報酬カタログ',
      walletList3: '獲得と使用の透明な履歴',
      howToTitle: 'ポイントを稼ぐには？',
      howToDesc: 'シンプルで、速く、楽しいです。',
      step1Title: '地元で買い物をする',
      step1Desc: 'アプリを使用して提携店舗で買い物をします。',
      step2Title: 'ミッションを完了する',
      step2Desc: 'お店のレビューやアイテムのリサイクルなど、地元の課題に参加します。',
      step3Title: '友達を紹介する',
      step3Desc: 'ご近所さんをBairrouAppに招待し、追加ポイントを獲得します。',
      step4Title: '賞品と交換する',
      step4Desc: 'ポイントを使用して、製品、サービス、または割引と交換します。',
      testimonialQuote: '「BairrouAppを使い始めてから、自分の通りに存在すら知らなかった素晴らしい場所を発見しました。そして、蓄積したポイントで何度も朝食代を支払いました！」',
      testimonialAuthor: '— マリアナ S.、地元住民',
      benefitsEyebrow: '利点',
      benefitsTitle: '必要なものすべて',
      howToEyebrow: 'ステップバイステップ',
      mockAlt2: 'BairrouAppのミッションと報酬画面'
    },
    paraNegocio: {
      heroEyebrow: '起業家向け',
      heroTitle1: 'あなたのビジネスを成長させる',
      heroTitle2: '街で。',
      heroDesc: 'あなたの近くに住む顧客とつながりましょう。売上を増やし、ロイヤリティプログラムを作成し、地元の認知度を高めます。',
      dashTitle: 'マーチャントダッシュボード',
      dashDesc: '今日の概要',
      dashStat1: 'ページ訪問数',
      dashStat2: '交換されたクーポン',
      dashStat3: '新規顧客',
      whyTitle: 'なぜBairrouAppなのか？',
      why1Title: '街を引き付ける',
      why1Desc: 'あなたの店舗の近くに住んでいる、または働いている人に見つけてもらいましょう。',
      why2Title: 'オファーを作成する',
      why2Desc: 'プロモーションやクーポンを公開して、静かな日にトラフィックを引き付けます。',
      why3Title: 'ロイヤリティを構築する',
      why3Desc: '買い物にポイントを提供して、顧客が常に戻ってくるようにします。',
      why4Title: '支払いを受け取る',
      why4Desc: '競争力のある料金と迅速な受け取りで、アプリを通じて支払いを受け入れます。',
      why5Title: '地元の認知度',
      why5Desc: '街のマップやカテゴリー検索で目立ちましょう。',
      why6Title: 'デジタルショーウィンドウ',
      why6Desc: '専用ページで製品、営業時間、写真を紹介します。',
      presenceTitle: 'アクセス可能なデジタルプレゼンス',
      presenceDesc: 'アプリ内にあなたのビジネスのページを取得し、ロイヤリティを民主化します。かつては大手チェーンに限定されていたツールが、今では街の商業の手に届くようになりました。サービスと営業時間を示し、クーポンとデジタルロイヤリティカードを街に提供します。',
      presenceList1: 'あなたの店舗またはサービスのリスト',
      presenceList2: '更新された営業時間',
      presenceList3: 'オファーとデジタルロイヤリティカード',
      presenceList4: 'QRコードチェックイン',
      stepsTitle: '3つのステップで開始',
      step1Title: 'サインアップ',
      step1Desc: '5分未満でマーチャントアカウントを作成します。',
      step2Title: '設定',
      step2Desc: '写真、営業時間、最初のオファーを追加します。',
      step3Title: 'もっと売る',
      step3Desc: 'あなたの街から顧客を受け入れ始めましょう。',
      pricingTitle: '予算に合ったプラン',
      pricingDesc: '無料で開始し、アプリを通じて行われた販売に対して少額の料金のみを支払います。驚きの月額料金はありません。',
      planTitle: 'ベーシックプラン',
      planList1: 'あなたの店舗またはサービスのリスト',
      planList2: '基本的なポイントプログラム',
      planPrice: '無料',
      planSub: '開始する',
      whyEyebrow: '選ばれる理由',
      presenceEyebrow: 'デジタルショーウィンドウ',
      stepsEyebrow: '始め方',
      pricingEyebrow: '料金',
      democEyebrow: 'あなたの手の届くところに',
      democTitle: 'かつて大手チェーンだけが持っていたビジネスインテリジェンスとロイヤリティ',
      democDesc: '独自のアプリを構築または維持する必要はありません。BairrouApp!は、かつては高価で大手チェーンに限定されていたツールへのアクセスを民主化します。今では、街の商業にとってシンプルで手頃な価格です。',
      democCard1Title: '独自のアプリなしのロイヤリティプログラム',
      democCard1Desc: 'アプリの構築と維持に投資することなく、顧客にポイント、クーポン、デジタルロイヤリティカードを提供します。すべてはBairrouApp!の中で起こります。',
      democCard2Title: 'アクセス可能なビジネスインテリジェンス',
      democCard2Desc: 'リピート訪問、最もコンバージョン率の高いオファー、店舗のパフォーマンスに関するデータを使用して顧客を理解します。かつては大きな予算とデータチームを持つ人々に限定されていた洞察です。',
      democCard3Title: '真にアクセス可能',
      democCard3Desc: '驚きの月額料金や技術的な障壁なしに、無料で開始しましょう。デジタル化とロイヤリティの構築は、あなたの予算とルーチンに適合します。',
      democHighlight: '大手チェーンの技術が、あなたの街の手の届くところに。'
    },
    paraMarca: {
      heroEyebrow: '大手ブランド向け',
      heroTag: 'B2B & パートナーシップ',
      heroTitle1: 'ブランドをコミュニティに接続する',
      heroTitle2: '信頼が生まれる場所。',
      heroDesc: '消費者が従来の広告に対してますます選択的になっている状況において、身近な人からの推薦、実際の体験、コミュニティのつながりは、信頼を築き、購買決定を促す上で重要な役割を果たします。',
      heroNielsen: '友人、家族、身近な人からの推薦は、消費者にとって最も信頼できるコミュニケーション形態であり続けています。そして、BairrouApp!があなたのブランドを位置づけるのはまさにそこです。関連性のある方法で街に存在し、小規模ビジネスを支援し、コミュニティを活性化し、関わるすべての人に価値を生み出す体験を創造します。',
      activeTerritoriesTitle: '単なるオーディエンスではなく、領域を活性化する',
      activeTerritoriesDesc: '消費者に一般的に話しかけるのではなく、あなたのブランドは、人々が住み、働き、消費し、交流する場所に直接つながることができます。以下を通じて、街を戦略的なタッチポイントに変えましょう：',
      activeTerritoriesList1: 'ジオロケーションキャンペーン',
      activeTerritoriesList2: 'サンプルと景品の配布',
      activeTerritoriesList3: 'プロモーションクーポン',
      activeTerritoriesList4: 'スポンサー付き体験',
      activeTerritoriesList5: '社会的インパクトアクション',
      activeTerritoriesList6: 'コミュニティエンゲージメントイニシアチブ',
      strengthenTitle: '小規模ビジネスとディストリビューターを強化する',
      strengthenDesc: 'BairrouApp!は、地元の商人、サービスプロバイダー、ディストリビューターをあなたのブランドの活性化パートナーに変えます。これにより、以下のことが可能になります：',
      strengthenList1: 'リーチを拡大する',
      strengthenList2: '製品のトライアルを生み出す',
      strengthenList3: 'ローカルチャネルを強化する',
      strengthenList4: '長期的な関係を構築する',
      strengthenConclusion: 'ブランドが領域的なプレゼンスを獲得する一方で、小規模ビジネスは客足、認知度、新たな収益機会を獲得します。',
      examplesTitle: 'キャンペーンの例',
      example1Title: '街のサーキット',
      example1Desc: '複数の地元パートナーを巻き込んだスポンサー付きのジャーニーを作成します。例：',
      example1List1: 'コーヒーサーキット',
      example1List2: 'ビューティーサーキット',
      example1List3: 'ファミリーサーキット',
      example1List4: 'サマーサーキット',
      example2Title: '買ってゲット',
      example2Desc: 'スポンサー付きの特典を通じてトライアルを奨励します。',
      example2Detail: '参加パートナーで購入し、ブランドからの限定製品、サンプル、または特典を受け取ります。',
      example3Title: 'ローカルディスカバリー',
      example3Desc: '消費者にコミュニティ内の新しい店舗や製品を発見するよう促します。',
      example4Title: 'スポンサー付き社会的インパクト',
      example4Desc: 'あなたのブランドを、その領域の社会的、文化的、または環境的プロジェクトに関連付けます。',
      example4Detail: '購入が行われるたびに、キャンペーン投資の一部が地元のイニシアチブを支援します。',
      benefitsTitle: 'あなたのブランドが得るもの',
      benefit1Title: '関連性のあるプレゼンス',
      benefit1Desc: '人々の日常のルーチンの一部である瞬間と領域に存在します。',
      benefit2Title: 'コミュニティの信頼',
      benefit2Desc: '個人的な推薦とご近所さん同士の信頼は、購買決定の最も影響力のある推進要因の1つであり、従来の広告の多くを上回っています。',
      benefit3Title: '本物のローカルエンゲージメント',
      benefit3Desc: '実際の体験と特典を通じてつながりを生み出します。',
      benefit4Title: '領域データとローカルインテリジェンス',
      benefit4Desc: 'どのコミュニティ、街、プロファイルが最も高いエンゲージメントを示しているかを理解します。',
      benefit5Title: '測定可能な影響',
      benefit5Desc: '以下を通じて結果を追跡します：',
      benefit5List1: '参加',
      benefit5List2: '交換',
      benefit5List3: 'アクティベーション',
      benefit5List4: '領域のリーチ',
      benefit5List5: 'コミュニティエンゲージメント',
      mockAlt1: 'BairrouAppのブランドキャンペーン画面',
      ctaTitle: 'キャンペーン以上のもの。つながり。',
      ctaDesc: 'BairrouApp!は、信頼が生まれる場所、つまり人々、ビジネス、コミュニティの関係において、あなたのブランドがプレゼンスを構築するのを支援します。',
      ctaDesc2: 'なぜなら、街は単なる市場ではないからです。それらは関係、帰属、影響力のエコシステムです。',
      ctaButton: 'プレゼンテーションを予約する',
      ctaOr: 'または直接書き込む',
      formats: ['ハイパーローカル', 'サンプリング', 'クーポン', 'インパクト']
    },
    educa: {
      heroEyebrow: 'BAIRROUEDUCA!',
      heroTitle1: '成長するための知識、',
      heroTitle2: '追加費用なしで。',
      heroDesc: 'すべてのBairrouApp!ユーザーは、知識を通じて人々、企業、コミュニティを強化するために作成された学習プラットフォームであるBairrouEduca!に無料でアクセスできます。',
      heroDesc2: '起業家精神、販売、デジタルマーケティング、財務、カスタマーサービス、テクノロジー、イノベーション、専門能力開発などのトピックをカバーする、認められた機関、専門家、市場の専門家が提供する実践的なコンテンツ、コース、学習パス、認定にアクセスできます。',
      missionTitle: 'トレーニングへのアクセスの民主化',
      missionDesc: '私たちの目標は、質の高いトレーニングへのアクセスを民主化し、小規模な起業家、サービスプロバイダー、住民が新しいスキルを開発し、収入を増やし、地域経済を強化するのを支援することです。',
      findTitle: 'BairrouEduca!で見つけられるもの',
      find1: '無料のコースとコンテンツ',
      find2: '戦略的パートナーからの認定',
      find3: '起業家向けの学習パス',
      find4: '管理、販売、マーケティングに関するコンテンツ',
      find5: '専門的なトレーニングとキャリア開発',
      find6: '地元ビジネスのベストプラクティス',
      find7: '専門家や主要機関によって作成されたコンテンツ',
      partnersTitle: '知識のパートナー',
      partnersDesc: 'BairrouEduca!は、領域の経済的および社会的発展を推進するために知識を共有する専門家、企業、専門家に加えて、地域の起業家支援機関などの認められた機関からのコンテンツと機会をまとめることを目指しています。',
      partnersClosing: 'なぜなら、地域経済を強化することは、その一部である人々の成長に投資することでもあるからです。',
      partnerChips: ['地域の起業家支援機関', '専門家', '機関', 'プロフェッショナル'],
      freeBadge: 'すべてのユーザーに100％無料',
      ctaTitle: '学び、成長する準備はできましたか？',
      ctaDesc: 'BairrouApp!に参加して、追加費用なしでBairrouEduca!を手のひらに。',
      ctaButton: 'お問い合わせ'
    },
    contato: {
      heroEyebrow: 'お問い合わせ',
      heroTitle: 'お問い合わせ',
      heroDesc: 'ご質問、ご提案、またはパートナーシップについて？私たちはあなたの声を聞くためにここにいます。',
      infoTitle: '連絡先情報',
      infoEmail: 'メール',
      infoPhone: '電話 / WhatsApp',
      infoOffice: 'オフィス',
      infoAddress1: 'Neighborhood Street, 123 - Suite 45',
      infoAddress2: 'São Paulo, SP - 01234-567',
      successTitle: 'メッセージが送信されました！',
      successDesc: 'ご連絡ありがとうございます。私たちのチームが可能な限り早く返信します。',
      successButton: '新しいメッセージを送信',
      formName: 'フルネーム',
      formNamePlaceholder: 'あなたの名前',
      formEmail: 'メール',
      formEmailPlaceholder: 'your@email.com',
      formSubject: '件名',
      formSubjectPlaceholder: '件名を選択してください...',
      formSub1: '私はユーザーです（質問/サポート）',
      formSub2: '私は地元ビジネスを持っています',
      formSub3: '私はブランドを代表しています（パートナーシップ）',
      formSub4: 'プレス',
      formSub5: 'その他',
      formSub6: '私は投資家です',
      formSub7: '私はNGOを代表しています',
      formMessage: 'メッセージ',
      formMessagePlaceholder: 'どのようにお手伝いできますか？',
      formSubmit: 'メッセージを送信',
      formSubmitting: '送信中...',
      errorTitle: 'おっと、何かが間違っていました',
      errorDesc: '現在メッセージを送信できませんでした。しばらくしてからもう一度お試しいただくか、jon@bairrou.online までご連絡ください。',
      errorButton: 'もう一度試す'
    },
    precos: {
      heroEyebrow: 'パートナープラン',
      heroTitle1: '最も重要な場所でビジネスを後押しする：',
      heroTitle2: 'あなたの街で。',
      heroDesc: '住民とつながり、地元のロイヤリティを構築し、チームに力を与えるための理想的なプランを選択してください。',
      monthly: '月額',
      annual: '年額',
      annualDiscount: '20%節約',
      plan1Name: 'ベーシック',
      plan1Desc: 'デジタルプレゼンスを開始するフリーランサー、独立した専門家、地元のサービスプロバイダーに最適です。',
      plan1PriceM: 'R$ 49.90',
      plan1PriceA: 'R$ 39.90',
      plan1Cta: '今すぐ開始',
      plan1Advantage: 'デジタルの不可視性から抜け出し、1日あたりR$ 1.70未満で数ブロック離れた場所に住んでいる人々にすぐに見つけてもらいましょう。',
      plan2Name: 'プロフェッショナル',
      plan2Badge: '最も人気',
      plan2Desc: 'リピーターで熱心な顧客ベースを構築したい小規模店舗、実店舗、カフェ、市場に最適です。',
      plan2PriceM: 'R$ 99.90',
      plan2PriceA: 'R$ 79.90',
      plan2Cta: 'プロフェッショナル版を試す',
      plan2Advantage: '真のロイヤリティと独自の運用インテリジェンスを通じて、地元の競争障壁を構築します。',
      plan3Name: 'プレミアム',
      plan3Desc: '領域の支配と積極的なキャンペーンを求める戦略的ビジネス、地元のフランチャイズ、確立された店舗に最適です。',
      plan3PriceM: 'R$ 199.90',
      plan3PriceA: 'R$ 159.90',
      plan3Cta: '専門家に相談する',
      plan3Advantage: 'リアルタイムのアクティベーションとジオフェンシングデータインテリジェンスにより、事業分野での市場リーダーシップを確保します。',
      feature1: '写真と連絡先を含むプロフィール',
      feature2: 'マップ上のジオロケーション',
      feature3: '直接のWhatsAppボタン',
      feature4: 'レビューシステム',
      feature5: 'ロイヤリティプログラム（BairrouClube）',
      feature6: 'BairrouPoints!の受け入れと管理',
      feature7: 'BairrouEduca! 学習プラットフォーム',
      feature8: 'パフォーマンスレポート',
      feature9: 'ローカルプッシュ通知',
      feature10: 'アプリ内の注目の位置',
      matrixTitle: 'プランを詳細に比較する',
      matrixNote: 'WhatsAppの販売に隠された料金はありません。定期的なプランに統合された税金とカード処理手数料。',
      faqTitle: 'よくある質問',
      faq1Q: 'いつでもプランを変更できますか？',
      faq1A: 'はい、アップグレードまたはダウングレードは、ダッシュボードでいつでも行うことができ、ペナルティや追加料金はかかりません。',
      faq2Q: 'チェックアウトでBairrouPoints!はどのように機能しますか？',
      faq2A: 'プラットフォームに統合されたエンゲージメントツールです。あなたがルールを設定し、顧客はあなたの店舗で直接ソーシャルポイントを蓄積して交換し、再発を生み出します。',
      faq3Q: 'サブスクライブするにはビジネスID（CNPJ）が必要ですか？',
      faq3A: 'いいえ、フリーランサーや独立した専門家は、個人のID（CPF）のみを使用してベーシックプランにサブスクライブできます。',
      testimonialQuote: '「プロフェッショナルプランを有効にした後、ロイヤリティプログラムのおかげで平日のパン屋のトラフィックが30%増加しました。ご近所さんはポイントを貯めるのが大好きです！」',
      testimonialAuthor: '— カルロス M.、地元のパン屋のオーナー'
    },
    gov: {
      heroEyebrow: 'BAIRROUGOV · GOVTECH',
      heroTitle1: '地域参加のためのデジタルインフラ、',
      heroTitle2: '地域開発と市民参加。',
      heroDesc: 'BairrouGovは、自治体、支庁、公的機関、開発組織が、単一のデジタルインフラを通じて市民参加、地域経済、地域コミュニケーション、コミュニティへの影響を強化するのを支援します。',
      ctaPrimary: 'デモを予約する',
      ctaSecondary: 'チームに相談する',
      whatTitle: '街、コミュニティ、都市のために構築されたGovTechプラットフォーム。',
      whatDesc1: 'BairrouGovはBairrouエコシステムのGovTechレイヤーであり、公的機関が市民、地元企業、サービスプロバイダー、コミュニティ組織、政府の取り組みを結びつけるのを支援するように設計されています。',
      whatDesc2: '位置情報、地域インテリジェンス、参加ツールを使用して、政府はより強力なコミュニティを構築し、公共コミュニケーションを改善し、地域経済の発展を支援できます。',
      modulesTitle: 'コアモジュール',
      moduleTitles: ['地域コミュニケーション', '市民参加', '地域経済開発', 'BairrouImpacto Gov', 'BairrouEduca Gov', '地域インテリジェンス'],
      moduleDescs: ['街、地区、または地域ごとのセグメント化されたコミュニケーション。', '傾聴、協議、参加を可能にします。', '小規模ビジネスと地元の起業家を支援します。', '社会的および環境的取り組みを中心にコミュニティを動員します。', '教育、起業家精神、労働力開発を促進します。', '地域データをより良い意思決定に変換します。'],
      moduleFeatures: [['公開キャンペーン', 'イベントと取り組み', 'ローカライズされた通知', 'コミュニティの発表'], ['アンケート', '公開協議', 'コミュニティのフィードバック', '市民参加プログラム'], ['ビジネスのセグメンテーション', '地域商業ディレクトリ', '経済開発の取り組み', '起業家支援プログラム'], ['持続可能性キャンペーン', 'コミュニティ参加', '健康啓発プログラム', '文化的取り組み'], ['起業家精神のトレーニング', '専門資格', '金融リテラシー', 'デジタルインクルージョン'], ['ダッシュボード', '街の指標', 'コミュニティ参加指標', '経済活動の洞察']],
      useCasesTitle: '政府によるBairrouGovの活用方法',
      useCases: ['街の参加プログラム', '経済開発の取り組み', 'コミュニティイベント', '公開協議', '持続可能性キャンペーン', '地元の起業家プログラム', '労働力開発の取り組み', '参加型予算編成'],
      impactTitle: 'コミュニケーションから変革へ。',
      impactGovTitle: '政府向け',
      impactGov: ['より良い市民コミュニケーション', 'より多くの参加', 'データ主導の意思決定', 'より強力な地域経済'],
      impactCitizensTitle: '市民向け',
      impactCitizens: ['情報へのより簡単なアクセス', 'より多くの機会', 'より大きなコミュニティの関与', 'より強力な街のアイデンティティ'],
      impactTerritoriesTitle: '地域向け',
      impactTerritories: ['経済開発', '社会的影響', 'コミュニティの回復力', '持続可能な都市の成長'],
      dashboardTitle: '地域インテリジェンスダッシュボード',
      dashboardDesc: 'リアルタイムのダッシュボードとマップを使用して、地域データをより良い意思決定に変えます。',
      dashboardMetrics: ['アクティブな街', 'コミュニティ参加', '地元企業の密度', 'イベント参加', '経済活動指標', '市民参加率'],
      sdgTitle: 'グローバルな影響目標と連携。',
      sdgs: ['SDG 8 — 働きがいも経済成長も', 'SDG 10 — 人や国の不平等をなくそう', 'SDG 11 — 住み続けられるまちづくりを', 'SDG 12 — つくる責任 つかう責任', 'SDG 17 — パートナーシップで目標を達成しよう'],
      ecosystemTitle: 'エコシステムアーキテクチャ',
      ecosystemDesc: '政府、市民、企業、NGO、ブランドがエコシステムを通じてどのように相互作用するかをご覧ください。',
      ecosystemCenter: 'Bairrouプラットフォーム',
      ecosystemModules: ['BairrouGov', 'BairrouApp', 'BairrouImpacto', 'BairrouEduca', 'BairrouClube', '地域インテリジェンス'],
      investorsTitle: '公共および民間市場の両方にサービスを提供するプラットフォーム。',
      investorsDesc: 'Bairrouは2つの補完的な市場で事業を展開しています：',
      marketB2cTitle: 'B2C / B2B',
      marketB2c: ['市民', '小規模ビジネス', 'サービスプロバイダー', 'ブランド'],
      marketB2gTitle: 'B2G',
      marketB2g: ['自治体', '支庁', '政府機関', '州政府', '開発組織'],
      investorsNote: 'これにより、経常収益の機会と強力なネットワーク効果を備えたスケーラブルな地域インフラストラクチャモデルが作成されます。',
      ctaFinalTitle: 'より強力な街とよりスマートな都市を構築する。',
      ctaFinalDesc: '単一の地域プラットフォームを通じて、コミュニティに力を与え、地域経済を強化し、市民参加を向上させます。',
      dashboardPanel: '地域ダッシュボード',
      dashboardLive: 'ライブ',
      nodeLabels: ['市民', '地元企業', '政府', '組織']
    },
    clube: {
      heroEyebrow: 'BAIRROUCLUBE!',
      heroTitle1: '地域商業を支援するための',
      heroTitle2: '報酬。',
      heroDesc1: 'BairrouClube! は、自分の街の経済で買い物をし、参加し、強化する人々に報いるために作成された、Bairrouエコシステムのロイヤリティプログラムです。',
      heroDesc2: '提携店舗で買い物をしたり、ローカルサービスを利用したり、コミュニティのキャンペーンやイベントに参加したりすることで、限定の特典や利点を蓄積できます。',
      pointsTitle: 'BairrouPoints!',
      pointsSubtitle: 'あなたのポイント、あなたの報酬',
      pointsDesc1: 'BairrouPoints!を使用すると、あなたのやり取りがネットワーク内のさまざまなパートナーで使用できる報酬を生み出します。',
      pointsDesc2: '地元企業を支援すればするほど、より多くの特典がアンロックされます。',
      pointsRedeemIntro: 'ポイントは以下と交換できます：',
      pointsList: ['提携店舗での割引', '地元の製品とサービス', '限定特典', '体験とプロモーション活動', '特別なコミュニティキャンペーン'],
      couponsTitle: '地域のクーポンとオファー',
      couponsSubtitle: '街を強化しながら節約する',
      couponsDesc1: 'お近くのビジネスからの限定クーポン、プロモーション、オファーにアクセスしましょう。',
      couponsDesc2: '新しいお店、サービス、機会を発見し、地域経済の成長に貢献しながら日常生活で節約しましょう。',
      couponsIntro: 'すべてをひとつの場所に：',
      couponsList: ['割引クーポン', '季節のプロモーション', '特別なキャンペーン', 'メンバー限定特典', '位置情報に基づくオファー'],
      cardLabels: ['割引', 'オファー', '限定', 'お近く'],
      pointsBenefit: '+ 地元での購入ごとに特典',
      localTitle: 'よりローカルに、より良く',
      localDesc: 'BairrouApp!では、すべての購入、紹介、またはやり取りがあなたの地域のビジネスを強化するのに役立ち、コミュニティにより多くの機会、収入、発展をもたらします。',
      localHighlight: '街が成長すれば、誰もが勝者になるからです。',
      tagline: '発見。節約。獲得。楽しむ。',
      ctaTitle: 'BairrouClube!に参加する',
      ctaDesc: '地元の買い物を実際の特典に変えましょう。',
      ctaButton: 'お問い合わせ'
    },
    tropa: {
      heroEyebrow: 'Tropa do Bairrou!',
      heroTitle: '人々を自分たちのコミュニティ内の機会に結びつける。',
      heroDesc1: 'Tropa do Bairrou!は、BairrouApp!エコシステムの協調的なネットワークであり、住民を彼らが住む地域内の収入、参加、および影響の機会に結びつけるために作成されました。',
      heroDesc2: '私たちの提案はシンプルです。助け、サービス、または運用サポートを必要とする人々と、収入を生み出し、専門的な経験を積み、地域コミュニティの強化に貢献したい人々を結びつけることです。',
      howItWorksTitle: '仕組み',
      howItWorksDesc1: 'BairrouApp!を通じて、パートナー、企業、組織、および住民は、Tropa do Bairrou!のメンバーが実行できるタスク、需要、および機会を公開できます。',
      howItWorksDesc2: '活動の完了と検証時に、参加者は対応する報酬を受け取ります。これは、金銭的、特典、またはBairrouの報酬エコシステムを通じて行われます。',
      opportunitiesTitle: '機会の種類',
      opportunitiesTitles: ['配達と運用サポート', 'イベントサポート', 'ローカルプロモーション', '調査とデータ収集', '情報検証', 'オンデマンドサービス'],
      opportunitiesDescs: ['地元企業や住民のための製品の集荷、輸送、配達の支援。', '地域で開催される文化、スポーツ、コミュニティの活動やイベントのサポート。', '販促資料の配布、キャンペーンの宣伝、コミュニティの動員。', 'アンケート、世論調査、地域のニーズのマッピングへの参加。', '施設の運営の確認、登録の更新、地域インテリジェンスの構築のサポート。', 'プラットフォームに登録されたローカルプロバイダーによって実行される小さなサービス。'],
      participantBenefitsTitle: '参加者のメリット',
      participantBenefitsTitles: ['地域で収入を生み出す', '柔軟性', '専門的な開発', 'コミュニティの認識', '限定特典'],
      participantBenefitsDescs: ['あなたが住んでいる場所に近い機会にアクセスしてください。', 'あなたのルーチンに意味のあるタスクと活動を選択してください。', '経験、評判、そして新しいつながりを構築します。', 'あなたの街の発展に積極的に参加してください。', 'Bairrouエコシステム内で報酬と利点を蓄積します。'],
      businessBenefitsTitle: '企業と組織のメリット',
      businessBenefitsTitles: ['ローカルサポートへの迅速なアクセス', '運用コストの削減', 'より大きな地域的リーチ', 'コミュニティの強化'],
      businessBenefitsDescs: ['特定の需要を実行するために近くの人を見つけます。', '必要なときにコミュニティ自体からリソースをアクティブにします。', 'キャンペーン、イベント、イニシアチブをサポートするために住民を動員します。', '経済活動を地域の機会に変えます。'],
      closingDesc1: '私たちは、多くの機会と才能がすでに地域内に存在していると信じています。課題は、適切なつながりを作ることです。',
      closingDesc2: 'Tropa do Bairrou!は、人々、企業、組織を近づけ、地域経済を強化し、参加、収入創出、コミュニティへの影響の新しい形を生み出すために生まれました。',
      closingHighlight: '地元で働く。地域に影響を与える。コミュニティと共に成長する。',
      ctaTitle: 'Tropa do Bairrou!に参加する！',
      ctaDesc: 'コミュニティ内の実際の機会につながりましょう。',
      ctaButton: 'お問い合わせ'
    },
    ods: {
      heroEyebrow: '私たちの影響',
      heroTitle1: '未来への',
      heroTitle2: '私たちのコミットメント。',
      heroDesc: 'BairrouAppは、プラスの影響を生み出すことを目的として誕生しました。私たちの行動と機能は、国連の持続可能な開発目標（SDGs）に沿っています。',
      stat1Desc: '再利用されたアイテム（マーケットプレイス）',
      stat2Desc: '地域経済に注入された',
      stat3Desc: 'コースの時間（教育）',
      stat4Desc: '支援された社会プロジェクト',
      impactTitle: '実践における影響',
      impactDesc: 'BairrouImpacta! モジュールは、持続可能な行動を報酬に変換します。ユーザーは、リサイクル、地域商業の支援、清掃活動への参加などのミッションを完了し、そのためのポイントを獲得します。',
      impactList1: '毎週の持続可能性ミッション',
      impactList2: '節約されたCO2の計算',
      impactList3: '街の社会プロジェクトへの支援',
      impactList4: '公益のためのゲーミフィケーション',
      odsTitle: '私たちがどのように貢献しているか',
      ods1Title: '働きがいも経済成長も',
      ods1Desc: '私たちは、デジタル化、販売、ロイヤリティツールを提供することで小規模な地元の起業家を強化し、彼らのビジネスが繁栄し、街で雇用と収入を生み出すようにします。',
      ods2Title: '住み続けられるまちづくりを',
      ods2Desc: '私たちはご近所さんを結びつけ、消費のための大規模な通勤の必要性を減らし、地元の都市空間への帰属意識とケアを促進します。',
      ods3Title: 'つくる責任 つかう責任',
      ods3Desc: '「マーケットプレイス」モジュールを通じて、私たちは循環型経済を奨励し、製品の寿命を延ばし、無駄と無制限の消費を減らします。',
      ods4Title: '質の高い教育をみんなに',
      ods4Desc: '「教育」モジュールは、地元住民や商人向けの専門的なトレーニングや自己啓発コースへのアクセスを民主化します。',
      impactEyebrow: '実践において',
      odsEyebrow: '国連の目標'
    },
    paraOng: {
      heroEyebrow: 'NGOおよび社会プロジェクト向け',
      heroTitle1: 'コミュニティを動員し、',
      heroTitle2: '影響力を拡大する。',
      heroDesc: 'BairrouApp!は、あなたの組織を地元住民や企業と結びつけ、寄付活動、ボランティアの募集、あなたの活動の認知度向上を促進します。',
      whatTitle: 'BairrouApp!がNGOをどのように支援するか',
      whatDesc: '私たちのプラットフォームは、社会組織がコミュニティと直接的かつ透明性を持って関わり、地元の支援を実際の影響に変えるためのツールを提供します。',
      benefitsTitle: 'あなたの組織の利点',
      benefit1Title: 'コミュニティの動員',
      benefit1Desc: '自分たちの街の活動を支援したいと考えている熱心な住民とつながりましょう。',
      benefit2Title: 'BairrouImpacta! ミッション',
      benefit2Desc: 'ユーザーがボランティア活動や寄付に参加することでポイントを獲得できるミッションを作成します。',
      benefit3Title: 'スポンサー付きキャンペーン',
      benefit3Desc: 'パートナーブランドが地元の売上の一部をあなたのプロジェクトに寄付するキャンペーンに参加します。',
      benefit4Title: '地域へのリーチ',
      benefit4Desc: 'あなたの活動地域に住み、働く人々に対するNGOの認知度を高めます。',
      stepsTitle: '影響を与え始める',
      step1Title: 'NGOを登録する',
      step1Desc: 'プラットフォーム上にあなたの組織の公式プロフィールを作成します。',
      step2Title: 'キャンペーンを作成する',
      step2Desc: 'ボランティアや資金調達のニーズを宣伝します。',
      step3Title: '街を巻き込む',
      step3Desc: 'コミュニティや提携する地元企業から直接支援を受けます。',
      impactaEyebrow: 'BAIRROUIMPACTA!と統合',
      impactaTitle: '支援を実際の影響に変える',
      impactaDesc: 'あなたのNGOはBairrouImpacta!モジュールに直接接続されます。住民は街で社会的・環境的なインパクトミッションを達成します。達成された各ミッションは、あなたの活動へのエンゲージメントと直接的な支援を生み出します。',
      impactaList1: 'コミュニティ向けのボランティアや寄付のミッションを作成',
      impactaList2: '住民は参加することでBairrouPoints!を獲得',
      impactaList3: '生み出された影響をリアルタイムで追跡',
      impactaMockAlt: '社会的インパクトミッションを表示するBairrouImpacta!モジュール',
      ctaTitle: '影響力を拡大する準備はできましたか？',
      ctaDesc: 'Bairrouエコシステムに参加し、あなたの活動を変化をもたらしたい人々と結びつけましょう。',
      ctaButton: 'お問い合わせ'
    },
    paraInvestidor: {
      heroEyebrow: '投資家向け',
      heroTitle1: '街と都市の',
      heroTitle2: 'デジタルインフラストラクチャ。',
      heroDesc: 'Bairrouは、市民、地元企業、政府、大手ブランドを結びつけるスケーラブルな地域プラットフォームであり、強力なネットワーク効果と複数の収益源を備えたエコシステムを構築します。',
      marketTitle: '1つのプラットフォーム、2つの補完的な市場',
      marketB2cTitle: 'B2C / B2B',
      marketB2cList: ['市民', '小規模ビジネス', 'サービスプロバイダー', 'ブランド'],
      marketB2gTitle: 'B2G',
      marketB2gList: ['自治体', '支庁', '政府機関', '州政府', '開発組織'],
      whyNowTitle: 'なぜ今なのか？',
      whyNowDesc: '地元商業のデジタル化と、政府による市民参加ツールの必要性が、統一された地域インフラストラクチャのユニークな機会を生み出しています。',
      thesisTitle: '私たちの投資テーマ',
      thesis1Title: 'ローカルネットワーク効果',
      thesis1Desc: '新しいユーザー、企業、または公的機関が参加するたびに、ローカルエコシステムにさらに多くの参加者が引き付けられ、自然な参入障壁が生まれます。',
      thesis2Title: '経常的かつ多様な収益',
      thesis2Desc: '企業向けのSaaSサブスクリプション、自治体向けのGovTechライセンス、ブランド向けのスポンサー付きキャンペーンによる収益化。',
      thesis3Title: '地域的なスケーラビリティ',
      thesis3Desc: '技術インフラストラクチャの複製限界費用が低い、街ごと、都市ごとの拡大モデル。',
      ecosystemTitle: 'Bairrouエコシステム',
      ecosystemDesc: '地域のさまざまなニーズに対応するモジュラーアーキテクチャ。',
      tractionTitle: 'グローバルな影響との連携',
      tractionDesc: '私たちのビジネスモデルは、国連の持続可能な開発目標（SDGs）とネイティブに連携しており、財務的リターンと測定可能な社会的および経済的影響を組み合わせています。',
      ctaTitle: 'この変革の一部になりましょう',
      ctaDesc: '私たちは、地域経済と参加を再定義するデジタルインフラストラクチャを構築しています。',
      ctaButton: '投資家向け広報に連絡する'
    }
  },
  zh: {
    nav: {
      inicio: '首页',
      paraVoce: '为你',
      paraNegocio: '为你的业务',
      paraMarca: '为品牌',
      ods: '可持续发展目标',
      educa: 'BairrouEduca!',
      gov: 'BairrouGov',
      clube: 'BairrouClube!',
      tropa: 'Tropa do Bairrou!',
      solucoes: '解决方案',
      ecossistema: '生态系统',
      precos: '定价',
      contato: '联系我们',
      paraOng: '为非政府组织',
      paraInvestidor: '为投资者'
    },
    footer: {
      blurb: '最好的就在这里！将您与社区中的企业、机会和人们联系起来。',
      plataforma: '平台',
      contato: '联系我们',
      faleConosco: '联系我们',
      direitos: '© 2026 BairrouApp. 保留所有权利。',
      termos: '使用条款',
      privacidade: '隐私政策'
    },
    common: {
      disponivelEmBreve: '即将推出',
      saibaMais: '了解更多',
      faleComAGente: '联系我们',
      falarComNossoTime: '联系我们的团队',
      trustedBy: '受信任于',
      tagline: '最好的就在这里！',
      darkModeOn: '开启深色模式',
      darkModeOff: '开启浅色模式'
    },
    home: {
      heroEyebrow: '你的社区应用',
      heroTitle1: '你的社区，',
      heroTitle2: '在一个应用中。',
      heroDesc: 'BairrouApp! 是社区的数字基础设施：发现本地企业，赚取积分，省钱，并加强您的社区 — 一切都在一个应用中。',
      comoFunciona: '怎么运行的？',
      comoFuncionaDesc: '在掌中体验社区所需的一切。',
      step1Title: '1. 探索',
      step1Desc: '寻找您附近最好的商店、服务和优惠。',
      step2Title: '2. 购物并赚取',
      step2Desc: '每次购物都可赚取积分，并兑换独家折扣。',
      step3Title: '3. 加强',
      step3Desc: '支持当地经济并参与社区影响倡议。',
      pilaresTitle: '一个应用，无限可能',
      pilar1Title: '本地优惠',
      pilar1Desc: '来自邻居的优惠券和促销活动。',
      pilar2Title: '教育',
      pilar2Desc: '面向社区的课程和培训。',
      pilar3Title: '市场',
      pilar3Desc: '买卖或交换二手物品。',
      pilar4Title: '影响',
      pilar4Desc: '支持您社区的社会事业。',
      audiencesTitle: '为所有人打造',
      audiencesDesc: '无论您是居民、小企业主还是大品牌。',
      aud1Title: '为你',
      aud1Desc: '省钱、赚取积分并发现社区中最好的事物。',
      aud2Title: '为你的业务',
      aud2Desc: '吸引更多本地客户并在社区建立忠诚度。',
      aud3Title: '为品牌',
      aud3Desc: '以真实和超本地化的方式与社区建立联系。',
      ctaTitle: '准备好探索了吗？',
      ctaDesc: '加入成千上万已经改变他们社区的邻居。',
      featuresEyebrow: '一切尽在一个地方',
      audiencesEyebrow: '适合人群',
      mockAlt2: 'BairrouApp 上的本地优惠屏幕'
    },
    paraVoce: {
      heroEyebrow: '为居民',
      heroTitle1: '你社区中最好的，',
      heroTitle2: '为你。',
      heroDesc: '独家折扣、积分积累，以及在离家几步之遥找到所需一切的便利。',
      ben1Title: '折扣和优惠券',
      ben1Desc: '在您已经喜爱的当地商店享受独家优惠。',
      ben2Title: '积分和奖励',
      ben2Desc: '每次购买都会在您的数字钱包中生成积分以兑换奖品。',
      ben3Title: '发现企业',
      ben3Desc: '在附近寻找面包店、机械师、沙龙等。',
      ben4Title: 'Educa 课程',
      ben4Desc: '访问培训和短期课程以促进您的发展。',
      ben5Title: '买卖',
      ben5Desc: '使用市场为您不再使用的物品赋予新生命。',
      ben6Title: '轻松支付',
      ben6Desc: '通过应用程序安全地直接支付您的购买费用。',
      walletTitle: '您的福利钱包',
      walletDesc: '实时跟踪您的积分、兑换优惠券并查看您的储蓄历史。一切都集中在一个地方，让您享受社区中最好的事物。',
      walletList1: '即时更新余额',
      walletList2: '本地奖励目录',
      walletList3: '透明的收入和使用历史',
      howToTitle: '如何赚取积分？',
      howToDesc: '简单、快速且有趣。',
      step1Title: '在当地购物',
      step1Desc: '使用该应用程序在合作机构购物。',
      step2Title: '完成任务',
      step2Desc: '参与当地挑战，例如评论商店或回收物品。',
      step3Title: '推荐朋友',
      step3Desc: '将您的邻居带到 BairrouApp 并赚取额外积分。',
      step4Title: '兑换奖品',
      step4Desc: '使用您的积分兑换产品、服务或折扣。',
      testimonialQuote: '“自从我开始使用 BairrouApp，我在我的街道上发现了我甚至不知道存在的令人惊叹的地方。我积累的积分已经多次支付了我的早餐！”',
      testimonialAuthor: '— Mariana S., 当地居民',
      benefitsEyebrow: '福利',
      benefitsTitle: '您需要的一切',
      howToEyebrow: '一步步',
      mockAlt2: 'BairrouApp 上的任务和奖励屏幕'
    },
    paraNegocio: {
      heroEyebrow: '为企业家',
      heroTitle1: '发展你的业务',
      heroTitle2: '在社区中。',
      heroDesc: '与住在你附近的客户联系。增加销售额，创建忠诚度计划，并获得本地知名度。',
      dashTitle: '商家仪表板',
      dashDesc: '今日概览',
      dashStat1: '页面访问量',
      dashStat2: '兑换的优惠券',
      dashStat3: '新客户',
      whyTitle: '为什么选择 BairrouApp？',
      why1Title: '吸引社区',
      why1Desc: '让在您机构附近生活或工作的人找到您。',
      why2Title: '创建优惠',
      why2Desc: '发布促销和优惠券以在较安静的日子吸引流量。',
      why3Title: '建立忠诚度',
      why3Desc: '为购物提供积分，以确保您的客户始终回归。',
      why4Title: '接收付款',
      why4Desc: '通过应用程序接受付款，费率具有竞争力且收款快速。',
      why5Title: '本地知名度',
      why5Desc: '在社区地图和类别搜索中脱颖而出。',
      why6Title: '数字店面',
      why6Desc: '在专属页面上展示您的产品、营业时间和照片。',
      presenceTitle: '您可访问的数字形象',
      presenceDesc: '在应用程序内为您的企业获取一个页面并使忠诚度民主化：曾经专属于大型连锁店的工具，现在社区商业触手可及。展示您的服务和营业时间，向您的社区提供优惠券和数字忠诚度卡。',
      presenceList1: '您的机构或服务列表',
      presenceList2: '更新的营业时间',
      presenceList3: '优惠和数字忠诚度卡',
      presenceList4: '二维码签到',
      stepsTitle: '分 3 步开始',
      step1Title: '注册',
      step1Desc: '在不到 5 分钟内创建您的商家帐户。',
      step2Title: '配置',
      step2Desc: '添加照片、营业时间和您的第一个优惠。',
      step3Title: '卖得更多',
      step3Desc: '开始接待来自您社区的客户。',
      pricingTitle: '适合您预算的计划',
      pricingDesc: '免费开始，只需对通过应用程序进行的销售支付少量费用。没有令人惊讶的月费。',
      planTitle: '基本计划',
      planList1: '您的机构或服务列表',
      planList2: '基本积分计划',
      planPrice: '免费',
      planSub: '开始',
      whyEyebrow: '为什么选择我们',
      presenceEyebrow: '数字店面',
      stepsEyebrow: '如何开始',
      pricingEyebrow: '定价',
      democEyebrow: '触手可及',
      democTitle: '以前只有大型连锁店才有的商业智能和忠诚度',
      democDesc: '您不需要构建或维护自己的应用程序。BairrouApp! 使获取曾经昂贵且专属于大型连锁店的工具变得民主化 — 现在对于社区商业来说简单且负担得起。',
      democCard1Title: '没有自己应用程序的忠诚度计划',
      democCard1Desc: '向您的客户提供积分、优惠券和数字忠诚度卡，而无需投资构建和维护应用程序。一切都在 BairrouApp! 内发生。',
      democCard2Title: '可访问的商业智能',
      democCard2Desc: '通过有关重复访问、转化率最高的优惠以及商店绩效的数据了解您的客户 — 这些见解曾经专属于那些拥有大量预算和数据团队的人。',
      democCard3Title: '真正可访问',
      democCard3Desc: '免费开始，没有令人惊讶的月费，也没有技术障碍。数字化和建立忠诚度符合您的预算和日常工作。',
      democHighlight: '大型连锁店的技术，在您的社区触手可及。'
    },
    paraMarca: {
      heroEyebrow: '为大品牌',
      heroTag: 'B2B & 合作伙伴关系',
      heroTitle1: '将您的品牌连接到社区',
      heroTitle2: '信任发生的地方。',
      heroDesc: '在消费者对传统广告越来越挑剔的背景下，亲近的人的推荐、真实的体验和社区联系在建立信任和推动购买决策方面发挥着基础性作用。',
      heroNielsen: '来自朋友、家人和附近人的推荐仍然是消费者最信任的沟通形式 — 这正是 BairrouApp! 定位您品牌的地方：以相关的方式存在于社区中，支持小企业，激活社区，并创造为所有参与者产生价值的体验。',
      activeTerritoriesTitle: '激活区域，而不仅仅是受众',
      activeTerritoriesDesc: '您的品牌可以直接连接到人们生活、工作、消费和互动的地方，而不是泛泛地与消费者交谈。通过以下方式将社区转变为战略接触点：',
      activeTerritoriesList1: '地理定位活动',
      activeTerritoriesList2: '分发样品和赠品',
      activeTerritoriesList3: '促销优惠券',
      activeTerritoriesList4: '赞助体验',
      activeTerritoriesList5: '社会影响行动',
      activeTerritoriesList6: '社区参与倡议',
      strengthenTitle: '加强小企业和分销商',
      strengthenDesc: 'BairrouApp! 将当地商家、服务提供商和分销商转变为您品牌的激活合作伙伴。这使您可以：',
      strengthenList1: '扩大覆盖面',
      strengthenList2: '产生产品试用',
      strengthenList3: '加强本地渠道',
      strengthenList4: '建立长期关系',
      strengthenConclusion: '在品牌获得区域影响力的同时，小企业获得了客流量、知名度和新的收入机会。',
      examplesTitle: '活动示例',
      example1Title: '社区巡回',
      example1Desc: '创建涉及多个本地合作伙伴的赞助旅程。示例：',
      example1List1: '咖啡巡回',
      example1List2: '美容巡回',
      example1List3: '家庭巡回',
      example1List4: '夏季巡回',
      example2Title: '买就送',
      example2Desc: '通过赞助福利鼓励试用。',
      example2Detail: '在参与的合作伙伴处购买，即可获得品牌的独家产品、样品或福利。',
      example3Title: '本地发现',
      example3Desc: '鼓励消费者发现社区内的新机构和产品。',
      example4Title: '赞助的社会影响',
      example4Desc: '将您的品牌与该地区的社会、文化或环境项目联系起来。',
      example4Detail: '每次购买，部分活动投资将支持当地倡议。',
      benefitsTitle: '您的品牌获得了什么',
      benefit1Title: '相关的存在',
      benefit1Desc: '存在于人们日常生活中不可或缺的时刻和区域。',
      benefit2Title: '社区信任',
      benefit2Desc: '个人推荐和邻居之间建立的信任是购买决策中最具影响力的驱动因素之一，优于许多传统广告。',
      benefit3Title: '真实的本地参与',
      benefit3Desc: '通过真实的体验和福利建立联系。',
      benefit4Title: '区域数据和本地智能',
      benefit4Desc: '了解哪些社区、街区和个人资料表现出最高的参与度。',
      benefit5Title: '可衡量的影响',
      benefit5Desc: '通过以下方式跟踪结果：',
      benefit5List1: '参与',
      benefit5List2: '兑换',
      benefit5List3: '激活',
      benefit5List4: '区域覆盖面',
      benefit5List5: '社区参与',
      mockAlt1: 'BairrouApp 上的品牌活动屏幕',
      ctaTitle: '不仅仅是活动。是联系。',
      ctaDesc: 'BairrouApp! 帮助您的品牌在建立信任的地方建立影响力：在人、企业和社区之间的关系中。',
      ctaDesc2: '因为社区不仅仅是市场。它们是关系、归属感和影响力的生态系统。',
      ctaButton: '安排演示',
      ctaOr: '或直接写信给',
      formats: ['超本地', '样品派发', '优惠券', '影响力']
    },
    educa: {
      heroEyebrow: 'BAIRROUEDUCA!',
      heroTitle1: '成长的知识，',
      heroTitle2: '无需额外费用。',
      heroDesc: '每个 BairrouApp! 用户都可以免费访问 BairrouEduca!，这是一个旨在通过知识加强个人、企业和社区的学习平台。',
      heroDesc2: '获取由公认机构、专家和市场专业人士提供的实用内容、课程、学习路径和认证，涵盖创业、销售、数字营销、财务、客户服务、技术、创新和专业发展等主题。',
      missionTitle: '使培训获取民主化',
      missionDesc: '我们的目标是使获取优质培训民主化，帮助小企业家、服务提供商和居民培养新技能、增加收入并加强当地经济。',
      findTitle: '您将在 BairrouEduca! 中找到什么',
      find1: '免费课程和内容',
      find2: '来自战略合作伙伴的认证',
      find3: '企业家的学习路径',
      find4: '关于管理、销售和营销的内容',
      find5: '专业培训和职业发展',
      find6: '本地企业的最佳实践',
      find7: '由专家和领先机构制作的内容',
      partnersTitle: '知识合作伙伴',
      partnersDesc: 'BairrouEduca! 旨在汇集来自公认的本地创业支持机构的内容和机会，以及分享知识以推动地区经济和社会发展的专家、公司和专业人士。',
      partnersClosing: '因为加强当地经济也意味着投资于作为其一部分的人们的成长。',
      partnerChips: ['本地创业支持机构', '专家', '机构', '专业人士'],
      freeBadge: '对所有用户 100% 免费',
      ctaTitle: '准备好学习和成长了吗？',
      ctaDesc: '加入 BairrouApp!，将 BairrouEduca! 掌握在手中，无需额外费用。',
      ctaButton: '联系我们'
    },
    gov: {
      heroEyebrow: 'BAIRROUGOV · GOVTECH',
      heroTitle1: '用于区域参与的数字基础设施，',
      heroTitle2: '地方发展和公民参与。',
      heroDesc: 'BairrouGov 帮助市政当局、分支机构、公共机构和发展组织通过单一的数字基础设施加强公民参与、地方经济、区域沟通和社区影响。',
      ctaPrimary: '安排演示',
      ctaSecondary: '联系我们的团队',
      whatTitle: '为社区、街区和城市打造的 GovTech 平台。',
      whatDesc1: 'BairrouGov 是 Bairrou 生态系统的 GovTech 层，旨在帮助公共机构连接公民、本地企业、服务提供商、社区组织和政府倡议。',
      whatDesc2: '利用地理定位、区域智能和参与工具，政府可以创建更强大的社区，改善公共沟通，并支持当地经济发展。',
      modulesTitle: '核心模块',
      moduleTitles: ['区域沟通', '公民参与', '地方经济发展', 'BairrouImpacto Gov', 'BairrouEduca Gov', '区域智能'],
      moduleDescs: ['按社区、地区或区域细分的沟通。', '实现倾听、咨询和参与。', '支持小企业和当地企业家。', '围绕社会和环境倡议动员社区。', '促进教育、创业和劳动力发展。', '将区域数据转化为更好的决策。'],
      moduleFeatures: [['公共活动', '活动和倡议', '本地化通知', '社区公告'], ['调查', '公众咨询', '社区反馈', '公民参与计划'], ['业务映射', '本地商业目录', '经济发展倡议', '企业家支持计划'], ['可持续发展活动', '社区参与', '健康意识计划', '文化倡议'], ['创业培训', '专业资格', '金融知识', '数字包容'], ['仪表板', '社区指标', '社区参与指标', '经济活动洞察']],
      useCasesTitle: '政府如何使用 BairrouGov',
      useCases: ['社区参与计划', '经济发展倡议', '社区活动', '公众咨询', '可持续发展活动', '当地创业计划', '劳动力发展倡议', '参与式预算'],
      impactTitle: '从沟通到转型。',
      impactGovTitle: '对政府',
      impactGov: ['更好的公民沟通', '更多参与', '数据驱动的决策', '更强大的地方经济'],
      impactCitizensTitle: '对公民',
      impactCitizens: ['更容易获取信息', '更多机会', '更大的社区参与', '更强的社区认同感'],
      impactTerritoriesTitle: '对区域',
      impactTerritories: ['经济发展', '社会影响', '社区复原力', '可持续的城市增长'],
      dashboardTitle: '区域智能仪表板',
      dashboardDesc: '通过实时仪表板和地图将区域数据转化为更好的决策。',
      dashboardMetrics: ['活跃社区', '社区参与', '本地企业密度', '活动参与', '经济活动指标', '公民参与率'],
      sdgTitle: '与全球影响目标保持一致。',
      sdgs: ['SDG 8 — 体面工作和经济增长', 'SDG 10 — 减少不平等', 'SDG 11 — 可持续城市和社区', 'SDG 12 — 负责任的消费和生产', 'SDG 17 — 促进目标实现的伙伴关系'],
      ecosystemTitle: '生态系统架构',
      ecosystemDesc: '了解政府、公民、企业、非政府组织和品牌如何通过生态系统互动。',
      ecosystemCenter: 'Bairrou 平台',
      ecosystemModules: ['BairrouGov', 'BairrouApp', 'BairrouImpacto', 'BairrouEduca', 'BairrouClube', '区域智能'],
      investorsTitle: '服务于公共和私人市场的平台。',
      investorsDesc: 'Bairrou 在两个互补的市场中运营：',
      marketB2cTitle: 'B2C / B2B',
      marketB2c: ['公民', '小型企业', '服务提供商', '品牌'],
      marketB2gTitle: 'B2G',
      marketB2g: ['市政当局', '分支机构', '政府机构', '州政府', '发展组织'],
      investorsNote: '这创建了一个可扩展的区域基础设施模型，具有经常性收入机会和强大的网络效应。',
      ctaFinalTitle: '建设更强大的社区和更智能的城市。',
      ctaFinalDesc: '通过单一的区域平台赋予社区权力，加强地方经济，并提高公民参与度。',
      dashboardPanel: '区域仪表盘',
      dashboardLive: '实时',
      nodeLabels: ['公民', '本地企业', '政府', '组织']
    },
    clube: {
      heroEyebrow: 'BAIRROUCLUBE!',
      heroTitle1: '支持本地商业的',
      heroTitle2: '奖励。',
      heroDesc1: 'BairrouClube! 是 Bairrou 生态系统的忠诚度计划，旨在奖励那些在自己社区购物、参与并加强经济的人。',
      heroDesc2: '通过在合作机构购物、使用本地服务或参加社区活动和事件，您可以积累独家福利和优势。',
      pointsTitle: 'BairrouPoints!',
      pointsSubtitle: '您的积分，您的奖励',
      pointsDesc1: '使用 BairrouPoints!，您的互动会产生奖励，这些奖励可以在网络中的不同合作伙伴处使用。',
      pointsDesc2: '您越支持本地企业，解锁的福利就越多。',
      pointsRedeemIntro: '您将能够将积分兑换为：',
      pointsList: ['合作机构的折扣', '本地产品和服务', '独家福利', '体验和促销活动', '特别社区活动'],
      couponsTitle: '本地优惠券和优惠',
      couponsSubtitle: '在加强社区的同时省钱',
      couponsDesc1: '获取您附近企业的独家优惠券、促销和优惠。',
      couponsDesc2: '发现新商店、服务和机会，在日常生活中省钱，同时为当地经济的增长做出贡献。',
      couponsIntro: '一切尽在一个地方：',
      couponsList: ['折扣优惠券', '季节性促销', '特别活动', '独家会员福利', '地理定位优惠'],
      cardLabels: ['折扣', '优惠', '独家', '在您附近'],
      pointsBenefit: '+ 每次本地购物均可获得福利',
      localTitle: '越本地化越好',
      localDesc: '在 BairrouApp! 上，每次购买、推荐或互动都有助于加强您所在地区的企业，为社区创造更多机会、收入和发展。',
      localHighlight: '因为当社区发展时，每个人都是赢家。',
      tagline: '发现。省钱。赚取。享受。',
      ctaTitle: '加入 BairrouClube!',
      ctaDesc: '将您的本地购物转化为真正的福利。',
      ctaButton: '联系我们'
    },
    tropa: {
      heroEyebrow: 'Tropa do Bairrou!',
      heroTitle: '将人们与自己社区内的机会联系起来。',
      heroDesc1: 'Tropa do Bairrou! 是 BairrouApp! 生态系统的协作网络，旨在将居民与他们居住的社区内的收入、参与和影响机会联系起来。',
      heroDesc2: '我们的主张很简单：将需要帮助、服务或运营支持的人与那些希望创造收入、发展专业经验并为加强当地社区做出贡献的人聚集在一起。',
      howItWorksTitle: '怎么运行的',
      howItWorksDesc1: '通过 BairrouApp!，合作伙伴、企业、组织和居民可以发布可由 Tropa do Bairrou! 成员执行的任务、需求和机会。',
      howItWorksDesc2: '在完成并验证活动后，参与者将获得相应的奖励，这些奖励可以是财务上的、福利上的，或者是通过 Bairrou 奖励生态系统获得的。',
      opportunitiesTitle: '机会类型',
      opportunitiesTitles: ['交付和运营支持', '活动支持', '本地推广', '研究和数据收集', '信息验证', '按需服务'],
      opportunitiesDescs: ['协助为当地企业和居民提取、运输和交付产品。', '支持在该地区举办的文化、体育、社区活动和事件。', '分发宣传材料、活动推广和社区动员。', '参与调查、民意测验和绘制当地需求图。', '确认机构运营、更新注册并支持建立区域情报。', '由在平台上注册的本地提供商执行的小型服务。'],
      participantBenefitsTitle: '参与者的好处',
      participantBenefitsTitles: ['产生当地收入', '灵活性', '专业发展', '社区认可', '独家优惠'],
      participantBenefitsDescs: ['获得离您居住地近的机会。', '选择对您的日常工作有意义的任务和活动。', '建立经验、声誉和新的联系。', '积极参与您所在社区的发展。', '在 Bairrou 生态系统中积累奖励和优势。'],
      businessBenefitsTitle: '企业和组织的好处',
      businessBenefitsTitles: ['快速获得本地支持', '降低运营成本', '更大的区域覆盖范围', '社区强化'],
      businessBenefitsDescs: ['寻找附近的人来执行特定需求。', '在需要时激活社区本身的资源。', '动员居民支持活动、事件和倡议。', '将经济活动转化为当地机会。'],
      closingDesc1: '我们相信社区内已经存在许多机会和人才。挑战在于建立正确的联系。',
      closingDesc2: 'Tropa do Bairrou! 的诞生是为了拉近人、企业和组织之间的距离，加强当地经济，并创造参与、创收和社区影响的新形式。',
      closingHighlight: '在本地工作。产生本地影响。与您的社区一起成长。',
      ctaTitle: '加入 Tropa do Bairrou!',
      ctaDesc: '连接到您社区内的真实机会。',
      ctaButton: '联系我们'
    },
    ods: {
      heroEyebrow: '我们的影响',
      heroTitle1: '我们对未来的',
      heroTitle2: '承诺。',
      heroDesc: 'BairrouApp 的诞生旨在产生积极影响。我们的行动和功能符合联合国可持续发展目标 (SDGs)。',
      stat1Desc: '重复使用的物品（市场）',
      stat2Desc: '注入当地经济',
      stat3Desc: '课程小时数（教育）',
      stat4Desc: '支持的社会项目',
      impactTitle: '实践中的影响',
      impactDesc: 'BairrouImpacta! 模块将可持续行动转化为奖励。用户完成回收、支持当地商业或参与清理等任务，并因此赚取积分。',
      impactList1: '每周可持续发展任务',
      impactList2: '节省的二氧化碳计算',
      impactList3: '支持社区社会项目',
      impactList4: '为了共同利益的游戏化',
      odsTitle: '我们如何贡献',
      ods1Title: '体面工作和经济增长',
      ods1Desc: '我们通过提供数字化、销售和忠诚度工具来加强当地小企业家，使他们的业务蓬勃发展，在社区创造就业和收入。',
      ods2Title: '可持续城市和社区',
      ods2Desc: '我们连接邻居，减少为了消费而进行的大量通勤的需求，并培养对当地城市空间的归属感和关怀。',
      ods3Title: '负责任的消费和生产',
      ods3Desc: '通过"市场"模块，我们鼓励循环经济，延长产品的使用寿命，减少浪费和无节制的消费。',
      ods4Title: '优质教育',
      ods4Desc: ' "教育"模块使当地居民和商人能够民主地获得专业培训和个人发展课程。',
      impactEyebrow: '在实践中',
      odsEyebrow: '联合国目标'
    },
    contato: {
      heroEyebrow: '联系我们',
      heroTitle: '联系我们',
      heroDesc: '有问题、建议或合作意向？我们在这里倾听您的声音。',
      infoTitle: '联系信息',
      infoEmail: '电子邮件',
      infoPhone: '电话 / WhatsApp',
      infoOffice: '办公室',
      infoAddress1: 'Neighborhood Street, 123 - Suite 45',
      infoAddress2: 'São Paulo, SP - 01234-567',
      successTitle: '消息已发送！',
      successDesc: '感谢您与我们联系。我们的团队将尽快回复。',
      successButton: '发送新消息',
      formName: '全名',
      formNamePlaceholder: '您的名字',
      formEmail: '电子邮件',
      formEmailPlaceholder: 'your@email.com',
      formSubject: '主题',
      formSubjectPlaceholder: '选择一个主题...',
      formSub1: '我是用户（问题/支持）',
      formSub2: '我有一家本地企业',
      formSub3: '我代表一个品牌（合作）',
      formSub4: '新闻界',
      formSub5: '其他',
      formSub6: '我是投资者',
      formSub7: '我代表一个非政府组织',
      formMessage: '消息',
      formMessagePlaceholder: '我们能帮什么忙？',
      formSubmit: '发送消息',
      formSubmitting: '发送中...',
      errorTitle: '哎呀，出了点问题',
      errorDesc: '我们现在无法发送您的消息。请稍后再试或写信至 jon@bairrou.online。',
      errorButton: '重试'
    },
    precos: {
      heroEyebrow: '合作伙伴计划',
      heroTitle1: '在最重要的地方推动您的业务：',
      heroTitle2: '在您的社区。',
      heroDesc: '选择理想的计划与居民联系，建立当地忠诚度，并赋予您的团队权力。',
      monthly: '每月',
      annual: '每年',
      annualDiscount: '节省 20%',
      plan1Name: '基本',
      plan1Desc: '非常适合自由职业者、独立专业人士和开始其数字形象的本地服务提供商。',
      plan1PriceM: 'R$ 49.90',
      plan1PriceA: 'R$ 39.90',
      plan1Cta: '立即开始',
      plan1Advantage: '摆脱数字隐形，让住在几个街区外的人立即找到您，每天不到 R$ 1.70。',
      plan2Name: '专业',
      plan2Badge: '最受欢迎',
      plan2Desc: '非常适合希望建立经常性和参与度高的客户群的小型商店、实体店、咖啡馆和市场。',
      plan2PriceM: 'R$ 99.90',
      plan2PriceA: 'R$ 79.90',
      plan2Cta: '尝试专业版',
      plan2Advantage: '通过真正的忠诚度和专有的运营智能建立本地竞争壁垒。',
      plan3Name: '高级',
      plan3Desc: '非常适合寻求区域主导地位和积极活动的战略企业、本地特许经营店和成熟的机构。',
      plan3PriceM: 'R$ 199.90',
      plan3PriceA: 'R$ 159.90',
      plan3Cta: '与专家交谈',
      plan3Advantage: '实时激活和地理围栏数据智能，以确保您在运营区域的市场领导地位。',
      feature1: '包含照片和联系方式的个人资料',
      feature2: '地图上的地理定位',
      feature3: '直接的 WhatsApp 按钮',
      feature4: '评论系统',
      feature5: '忠诚度计划 (BairrouClube)',
      feature6: '接受和管理 BairrouPoints!',
      feature7: 'BairrouEduca! 学习平台',
      feature8: '绩效报告',
      feature9: '本地推送通知',
      feature10: '应用程序中的特色位置',
      matrixTitle: '详细比较计划',
      matrixNote: '您的 WhatsApp 销售没有隐藏费用。税收和卡处理费集成在经常性计划中。',
      faqTitle: '常见问题',
      faq1Q: '我可以随时更改我的计划吗？',
      faq1A: '是的，您可以随时在仪表板中进行升级或降级，无需支付罚款或额外费用。',
      faq2Q: 'BairrouPoints! 在我的结账处如何运作？',
      faq2A: '它是集成到平台中的参与工具。您设定规则，客户直接在您的机构积累和兑换社交积分，产生重复消费。',
      faq3Q: '我需要企业 ID (CNPJ) 才能订阅吗？',
      faq3A: '不需要，自由职业者和独立专业人士只需使用其个人 ID (CPF) 即可订阅基本计划。',
      testimonialQuote: '“激活专业计划后，由于忠诚度计划，面包店工作日的客流量增加了 30%。邻居们喜欢积累积分！”',
      testimonialAuthor: '— Carlos M., 当地一家面包店老板'
    },
    paraOng: {
      heroEyebrow: '为非政府组织和社会项目',
      heroTitle1: '动员您的社区',
      heroTitle2: '并扩大您的影响。',
      heroDesc: 'BairrouApp! 将您的组织与当地居民和企业联系起来，促进捐赠活动、志愿者招募以及提高您的事业知名度。',
      whatTitle: 'BairrouApp! 如何帮助您的非政府组织',
      whatDesc: '我们的平台为社会组织提供工具，使其能够直接透明地参与社区活动，将当地的支持转化为真正的影响力。',
      benefitsTitle: '您组织的优势',
      benefit1Title: '社区动员',
      benefit1Desc: '与愿意在自己社区支持事业的积极居民建立联系。',
      benefit2Title: 'BairrouImpacta! 任务',
      benefit2Desc: '创建任务，让用户通过参与志愿者行动或捐赠来赚取积分。',
      benefit3Title: '赞助活动',
      benefit3Desc: '参与合作品牌将部分当地销售额捐赠给您的项目的活动。',
      benefit4Title: '地域覆盖',
      benefit4Desc: '提高您的非政府组织在您运营地区生活和工作的人群中的知名度。',
      stepsTitle: '开始产生影响',
      step1Title: '注册您的非政府组织',
      step1Desc: '在平台上为您的组织创建官方资料。',
      step2Title: '创建活动',
      step2Desc: '宣传您的志愿服务或筹款需求。',
      step3Title: '参与社区',
      step3Desc: '获得社区和合作当地企业的直接支持。',
      impactaEyebrow: '与 BAIRROUIMPACTA! 集成',
      impactaTitle: '将支持转化为真正的影响',
      impactaDesc: '您的非政府组织直接连接到 BairrouImpacta! 模块，居民在社区中完成社会和环境影响任务。每个完成的任务都会推动参与并为您的事业提供直接支持。',
      impactaList1: '为社区创建志愿服务和捐赠任务',
      impactaList2: '居民通过参与赚取 BairrouPoints!',
      impactaList3: '实时跟踪产生的影响',
      impactaMockAlt: '显示社会影响任务的 BairrouImpacta! 模块',
      ctaTitle: '准备好扩大您的影响了吗？',
      ctaDesc: '加入 Bairrou 生态系统，将您的事业与那些想要有所作为的人联系起来。',
      ctaButton: '联系我们'
    },
    paraInvestidor: {
      heroEyebrow: '为投资者',
      heroTitle1: '社区和城市的',
      heroTitle2: '数字基础设施。',
      heroDesc: 'Bairrou 是一个可扩展的地域平台，连接公民、当地企业、政府和大型品牌，创建一个具有强大网络效应和多种收入来源的生态系统。',
      marketTitle: '一个平台，两个互补市场',
      marketB2cTitle: 'B2C / B2B',
      marketB2cList: ['公民', '小型企业', '服务提供商', '品牌'],
      marketB2gTitle: 'B2G',
      marketB2gList: ['市政当局', '分支机构', '政府机构', '州政府', '发展组织'],
      whyNowTitle: '为什么是现在？',
      whyNowDesc: '当地商业的数字化以及政府对公民参与工具的需求，为统一的地域基础设施创造了独特的机会。',
      thesisTitle: '我们的投资论点',
      thesis1Title: '本地网络效应',
      thesis1Desc: '每一个新用户、企业或公共机构都会吸引更多参与者进入本地生态系统，从而形成天然的进入壁垒。',
      thesis2Title: '经常性和多元化收入',
      thesis2Desc: '通过企业的 SaaS 订阅、市政当局的 GovTech 许可和品牌的赞助活动实现货币化。',
      thesis3Title: '地域可扩展性',
      thesis3Desc: '逐个社区、逐个城市的扩张模式，技术基础设施复制的边际成本低。',
      ecosystemTitle: 'Bairrou 生态系统',
      ecosystemDesc: '满足该地区不同需求的模块化架构。',
      tractionTitle: '与全球影响保持一致',
      tractionDesc: '我们的商业模式与联合国可持续发展目标 (SDGs) 原生一致，将财务回报与可衡量的社会和经济影响结合起来。',
      ctaTitle: '成为这一转型的一部分',
      ctaDesc: '我们正在构建将重新定义当地经济和参与度的数字基础设施。',
      ctaButton: '联系投资者关系'
    }
  },
  ko: {
    nav: {
      inicio: '홈',
      paraVoce: '당신을 위해',
      paraNegocio: '비즈니스를 위해',
      paraMarca: '브랜드를 위해',
      ods: 'SDGs',
      educa: 'BairrouEduca!',
      gov: 'BairrouGov',
      clube: 'BairrouClube!',
      solucoes: '솔루션',
      ecossistema: '생태계',
      precos: '가격',
      contato: '연락처'
    },
    footer: {
      blurb: '가장 좋은 것은 바로 모퉁이에 있습니다. 동네의 비즈니스, 기회 및 사람들과 연결해 드립니다.',
      plataforma: '플랫폼',
      contato: '연락처',
      faleConosco: '문의하기',
      direitos: '© 2026 BairrouApp. 모든 권리 보유.',
      termos: '이용 약관',
      privacidade: '개인정보 처리방침'
    },
    common: {
      disponivelEmBreve: '출시 예정',
      saibaMais: '자세히 알아보기',
      faleComAGente: '문의하기',
      falarComNossoTime: '팀과 대화하기',
      trustedBy: '신뢰하는 기업',
      tagline: '가장 좋은 것은 바로 모퉁이에 있습니다.'
    },
    home: {
      heroEyebrow: '당신의 동네 앱',
      heroTitle1: '당신의 동네,',
      heroTitle2: '하나의 앱에.',
      heroDesc: 'BairrouApp!은 동네를 위한 디지털 인프라입니다: 지역 비즈니스를 발견하고, 포인트를 적립하고, 돈을 절약하고, 커뮤니티를 강화하세요 — 이 모든 것이 하나의 앱에서 가능합니다.',
      comoFunciona: '어떻게 작동하나요?',
      comoFuncionaDesc: '동네를 더 잘 경험하는 데 필요한 모든 것이 손안에 있습니다.',
      ctaTitle: '탐험할 준비가 되셨나요?'
    },
    paraVoce: {
      heroEyebrow: '주민을 위해',
      heroTitle1: '동네에서 가장 좋은 것,',
      heroTitle2: '당신을 위해.',
      heroDesc: '독점 할인, 포인트 적립, 그리고 집에서 몇 걸음 떨어진 곳에서 필요한 모든 것을 쉽게 찾을 수 있습니다.'
    },
    paraNegocio: {
      heroEyebrow: '기업가를 위해',
      heroTitle1: '비즈니스를 성장시키세요',
      heroTitle2: '동네에서.',
      heroDesc: '가까이 사는 고객과 연결하세요. 매출을 늘리고, 로열티 프로그램을 만들고, 지역 가시성을 확보하세요.'
    },
    paraMarca: {
      heroEyebrow: '대형 브랜드를 위해',
      heroTitle1: '브랜드를 커뮤니티에 연결하세요',
      heroTitle2: '신뢰가 일어나는 곳.',
      heroDesc: '소비자가 전통적인 광고에 점점 더 선택적이 되는 환경에서, 가까운 사람들의 추천, 실제 경험 및 커뮤니티 연결은 신뢰를 구축하고 구매 결정을 내리는 데 근본적인 역할을 합니다.'
    },
    educa: {
      heroEyebrow: 'BAIRROUEDUCA!',
      heroTitle1: '성장하기 위한 지식,',
      heroTitle2: '추가 비용 없이.',
      heroDesc: '모든 BairrouApp! 사용자는 지식을 통해 사람, 비즈니스 및 커뮤니티를 강화하기 위해 만들어진 학습 플랫폼인 BairrouEduca!에 무료로 액세스할 수 있습니다.'
    },
    gov: {
      heroEyebrow: 'BAIRROUGOV · GOVTECH',
      heroTitle1: '지역 참여를 위한 디지털 인프라,',
      heroTitle2: '지역 개발 및 시민 참여.',
      heroDesc: 'BairrouGov는 지자체, 하위 부서, 공공 기관 및 개발 조직이 단일 디지털 인프라를 통해 시민 참여, 지역 경제, 지역 커뮤니케이션 및 커뮤니티 영향을 강화하도록 돕습니다.'
    },
    clube: {
      heroEyebrow: 'BAIRROUCLUBE!',
      heroTitle1: '지역 상업을 지원하는 것에 대한',
      heroTitle2: '보상.',
      heroDesc1: 'BairrouClube!는 자신의 동네 경제에서 쇼핑하고, 참여하고, 강화하는 사람들에게 보상하기 위해 만들어진 Bairrou 생태계의 로열티 프로그램입니다.'
    },
    ods: {
      heroEyebrow: '우리의 영향',
      heroTitle1: '미래에 대한',
      heroTitle2: '우리의 약속.',
      heroDesc: 'BairrouApp은 긍정적인 영향을 창출하기 위해 탄생했습니다. 우리의 행동과 기능은 UN 지속 가능한 개발 목표(SDGs)와 일치합니다.'
    },
    contato: {
      heroEyebrow: '문의하기',
      heroTitle: '문의하기',
      heroDesc: '질문, 제안 또는 파트너십? 우리는 당신의 의견을 듣기 위해 여기 있습니다.'
    },
    precos: {
      heroEyebrow: '파트너 플랜',
      heroTitle1: '가장 중요한 곳에서 비즈니스를 활성화하세요:',
      heroTitle2: '당신의 동네에서.'
    },
    paraOng: {
      heroEyebrow: 'NGO 및 사회 프로젝트를 위해',
      heroTitle1: '커뮤니티를 동원하고',
      heroTitle2: '영향력을 확대하세요.',
      heroDesc: 'BairrouApp!은 귀하의 조직을 지역 주민 및 비즈니스와 연결하여 기부 캠페인, 자원 봉사자 모집 및 귀하의 대의에 대한 가시성을 촉진합니다.',
      whatTitle: 'BairrouApp!이 NGO를 돕는 방법',
      whatDesc: '우리 플랫폼은 사회 조직이 커뮤니티에 직접적이고 투명하게 참여하여 지역의 지원을 실질적인 영향으로 바꿀 수 있는 도구를 제공합니다.',
      benefitsTitle: '조직을 위한 이점',
      benefit1Title: '커뮤니티 동원',
      benefit1Desc: '자신의 동네에서 대의를 지원할 의향이 있는 참여 주민들과 연결하세요.',
      benefit2Title: 'BairrouImpacta! 임무',
      benefit2Desc: '사용자가 자원 봉사 활동이나 기부에 참여하여 포인트를 얻을 수 있는 임무를 만듭니다.',
      benefit3Title: '후원 캠페인',
      benefit3Desc: '파트너 브랜드가 지역 판매의 일부를 프로젝트에 기부하는 캠페인에 참여하세요.',
      benefit4Title: '지역적 도달 범위',
      benefit4Desc: '귀하가 활동하는 지역에 거주하고 일하는 사람들에게 NGO의 가시성을 높이세요.',
      stepsTitle: '영향을 미치기 시작하세요',
      step1Title: 'NGO 등록',
      step1Desc: '플랫폼에서 조직의 공식 프로필을 만듭니다.',
      step2Title: '캠페인 만들기',
      step2Desc: '자원 봉사 또는 기금 모금 요구 사항을 홍보하세요.',
      step3Title: '동네 참여',
      step3Desc: '커뮤니티 및 파트너 지역 비즈니스로부터 직접적인 지원을 받으세요.',
      ctaTitle: '영향력을 확대할 준비가 되셨나요?',
      ctaDesc: 'Bairrou 생태계에 참여하여 변화를 만들고자 하는 사람들과 귀하의 대의를 연결하세요.',
      ctaButton: '문의하기'
    },
    paraInvestidor: {
      heroEyebrow: '투자자를 위해',
      heroTitle1: '동네와 도시의',
      heroTitle2: '디지털 인프라.',
      heroDesc: 'Bairrou는 시민, 지역 비즈니스, 정부 및 대형 브랜드를 연결하여 강력한 네트워크 효과와 다양한 수익원을 갖춘 생태계를 구축하는 확장 가능한 지역 플랫폼입니다.',
      marketTitle: '하나의 플랫폼, 두 개의 상호 보완적인 시장',
      marketB2cTitle: 'B2C / B2B',
      marketB2cList: ['시민', '소규모 비즈니스', '서비스 제공업체', '브랜드'],
      marketB2gTitle: 'B2G',
      marketB2gList: ['지자체', '하위 부서', '정부 기관', '주 정부', '개발 조직'],
      whyNowTitle: '왜 지금인가?',
      whyNowDesc: '지역 상업의 디지털화와 정부의 시민 참여 도구에 대한 필요성은 통합된 지역 인프라를 위한 독특한 기회를 창출합니다.',
      thesisTitle: '우리의 투자 논제',
      thesis1Title: '로컬 네트워크 효과',
      thesis1Desc: '새로운 사용자, 비즈니스 또는 공공 기관이 참여할 때마다 로컬 생태계에 더 많은 참여자를 끌어들여 자연스러운 진입 장벽을 만듭니다.',
      thesis2Title: '반복적이고 다양한 수익',
      thesis2Desc: '비즈니스를 위한 SaaS 구독, 지자체를 위한 GovTech 라이선스, 브랜드를 위한 후원 캠페인을 통한 수익화.',
      thesis3Title: '지역적 확장성',
      thesis3Desc: '기술 인프라 복제의 한계 비용이 낮은 동네별, 도시별 확장 모델.',
      ecosystemTitle: 'Bairrou 생태계',
      ecosystemDesc: '지역의 다양한 요구를 충족하는 모듈식 아키텍처.',
      tractionTitle: '글로벌 임팩트와의 연계',
      tractionDesc: '우리의 비즈니스 모델은 UN 지속 가능한 개발 목표(SDGs)와 기본적으로 일치하여 재정적 수익과 측정 가능한 사회적 및 경제적 영향을 결합합니다.',
      ctaTitle: '이 변화의 일부가 되십시오',
      ctaDesc: '우리는 지역 경제와 참여를 재정의할 디지털 인프라를 구축하고 있습니다.',
      ctaButton: '투자자 관계 부서에 문의하기'
    }
  }
};
function mergeDeep(target: any, source: any) {
  const isObject = (obj: any) => obj && typeof obj === 'object' && !Array.isArray(obj);
  if (!isObject(target) || !isObject(source)) return source;
  const output = {
    ...target
  };
  Object.keys(source).forEach(key => {
    if (isObject(source[key])) {
      if (!(key in target)) Object.assign(output, {
        [key]: source[key]
      });else output[key] = mergeDeep(target[key], source[key]);
    } else {
      Object.assign(output, {
        [key]: source[key]
      });
    }
  });
  return output;
}
interface LanguageContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: Translations;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('pt');
  useEffect(() => {
    const savedLang = localStorage.getItem('bairrou_lang') as Language;
    if (savedLang && ['pt', 'en', 'es', 'ja', 'zh'].includes(savedLang)) {
      setLanguage(savedLang);
    } else {
      const browserLang = navigator.language.split('-')[0];
      if (['pt', 'en', 'es', 'ja', 'zh'].includes(browserLang)) {
        setLanguage(browserLang as Language);
      }
    }
  }, []);
  const handleSetLanguage = (lang: Language) => {
    setLanguage(lang);
    localStorage.setItem('bairrou_lang', lang);
  };
  const t = useMemo(() => {
    if (language === 'pt' || language === 'en') {
      return translations[language];
    }
    const base = translations['en'];
    const override = localeOverrides[language];
    if (!override) return base;
    return mergeDeep(base, override) as Translations;
  }, [language]);
  return <LanguageContext.Provider value={{
    lang: language,
    setLang: handleSetLanguage,
    t
  }} data-id="element-73" data-mp="251f4k42aidhn">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
export function useT() {
  return useLanguage().t;
}